webpackJsonp([47],{

/***/ "+ChJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueI18n = __webpack_require__("TXmL");

var _vueI18n2 = _interopRequireDefault(_vueI18n);

var _enUS = __webpack_require__("IFIa");

var _enUS2 = _interopRequireDefault(_enUS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueI18n2.default);

exports.default = new _vueI18n2.default({
	locale: 'en',
	silentTranslationWarn: true,
	fallbackLocale: 'en',
	messages: {
		en: _enUS2.default
	}
});

/***/ }),

/***/ "+fG9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+gLZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */
// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) {
	Object.defineProperty(Array.prototype, 'find', {
		value: function value(predicate) {
			// 1. Let O be ? ToObject(this value).
			if (this == null) {
				throw new TypeError('"this" is null or not defined');
			}

			var o = Object(this);

			// 2. Let len be ? ToLength(? Get(O, "length")).
			var len = o.length >>> 0;

			// 3. If IsCallable(predicate) is false, throw a TypeError exception.
			if (typeof predicate !== 'function') {
				throw new TypeError('predicate must be a function');
			}

			// 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
			var thisArg = arguments[1];

			// 5. Let k be 0.
			var k = 0;

			// 6. Repeat, while k < len
			while (k < len) {
				// a. Let Pk be ! ToString(k).
				// b. Let kValue be ? Get(O, Pk).
				// c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
				// d. If testResult is true, return kValue.
				var kValue = o[k];
				if (predicate.call(thisArg, kValue, k, o)) {
					return kValue;
				}
				// e. Increase k by 1.
				k++;
			}

			// 7. Return undefined.
			return undefined;
		}
	});
}

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("+gLZ");
__webpack_require__("Xk2i");
__webpack_require__("j1ja");
__webpack_require__("5mUy");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "0OET":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	bind: function bind(el, binding) {
		var bubble = binding.modifiers.bubble,
		    handler = function handler(e) {
			if (bubble || !el.contains(e.target) && el !== e.target) {
				binding.value(e);
			}
		};

		el.vueClickOutside = handler;
		document.addEventListener('click', handler);
	},
	unbind: function unbind(el) {
		document.removeEventListener('click', el.vueClickOutside);
		el.vueClickOutside = null;
	}
};

/***/ }),

/***/ "0XPQ":
/***/ (function(module, exports) {

module.exports = {"footer":{"aboutNexon":"關於Nexon","support":"服務支援","careers":"公司願景","businessOpportunities":"職缺項目","press":"電子報","investorRelations":"投資者關係","privacy":"個人隱私權","legalDoc":"法律條文","tou":"使用者條款","eula":"使用者同意書","copyright":"©{0} NEXON (Taiwan) Co., Ltd. & NEXON America Inc. All Rights Reserved.","languages":{"es":"西班牙文 (LA)","en":"英語","pt":"葡萄牙文 (BR)","de":"德語","fr":"法語","it":"意大利語","pl":"波蘭語","tr":"土耳其文","th":"泰國語言","zh":"中文","nl":"Dutch"},"regions":{"sea":"东南亚","th":"泰國","kr":"韓國","jp":"日本","tw":"臺灣","global":"全球"}}}

/***/ }),

/***/ "1cKC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2qwb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var setting = Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(__webpack_require__.bind(null, "xXdY")),
    createChangePassword = Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(22)]).then(__webpack_require__.bind(null, "9lR4")),
    changeEmail = Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(9)]).then(__webpack_require__.bind(null, "UWJQ")),
    changeSecurity = Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(8)]).then(__webpack_require__.bind(null, "QsGw")),
    challengeSecurity = Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(10)]).then(__webpack_require__.bind(null, "GEB7")),
    addSecurityQuestion = Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(23)]).then(__webpack_require__.bind(null, "8X/V")),
    resetAccount = Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(21)]).then(__webpack_require__.bind(null, "6sVt")),
    revertId = Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(11)]).then(__webpack_require__.bind(null, "VN4m")),
    revertIdSuccess = Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(24)]).then(__webpack_require__.bind(null, "GQz4")),
    verifyAccount = Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(19)]).then(__webpack_require__.bind(null, "Htgb"));

exports.default = [{
	path: '/:locale/setting',
	name: 'setting',
	components: {
		body: function body() {
			return setting;
		}
	},
	meta: { requireSettingsInfo: true }
}, {
	path: '/:locale/setting/verify-account',
	name: 'verify-account',
	components: {
		body: function body() {
			return verifyAccount;
		}
	},
	meta: { requireSettingsInfo: true }
}, {
	path: '/:locale/setting/challenge-security',
	name: 'challenge-security',
	components: {
		body: function body() {
			return challengeSecurity;
		}
	},
	meta: { requireSettingsInfo: true }
}, {
	path: '/:locale/setting/password/:type?',
	name: 'create-change-password',
	components: {
		body: function body() {
			return createChangePassword;
		}
	},
	meta: { requireSettingsInfo: true }
}, {
	path: '/:locale/setting/change-email',
	name: 'change-email',
	components: {
		body: function body() {
			return changeEmail;
		}
	},
	meta: { requiresLogin: true }
}, {
	path: '/:locale/setting/change-security',
	name: 'change-security',
	components: {
		body: function body() {
			return changeSecurity;
		}
	},
	meta: { requireSettingsInfo: true }
}, {
	path: '/:locale/setting/add-security-question',
	name: 'add-security-question',
	components: {
		body: function body() {
			return addSecurityQuestion;
		}
	},
	meta: { requireSettingsInfo: true }
}, {
	path: '/:locale/setting/reset-account',
	name: 'reset-your-account',
	components: {
		body: function body() {
			return resetAccount;
		}
	},
	meta: { requireSettingsInfo: true }
}, {
	path: '/:locale/revert-id',
	name: 'revert-id',
	components: {
		body: function body() {
			return revertId;
		}
	}
}, {
	path: '/:locale/revert-id-success',
	name: 'revert-id-success',
	components: {
		body: function body() {
			return revertIdSuccess;
		}
	}
}];

/***/ }),

/***/ "3KbE":
/***/ (function(module, exports) {

module.exports = {"footer":{"aboutNexon":"A proposito di Nexon","support":"Assistenza","careers":"Carriere","businessOpportunities":"Opportunità di business","press":"Stampa","investorRelations":"Relazioni con gli investitori","privacy":"Informativa sulla privacy","legalDoc":"Documentazione legale","tou":"Termini di utilizzo","eula":"Contratto di licenza per l'utente finale","copyright":"©{0} NEXON Korea Corporation and NEXON America Inc. All Rights Reserved.","languages":{"es":"Español (LA)","en":"English","pt":"Português (BR)","de":"Deutsch","fr":"Français","it":"Italiano","pl":"Polski","tr":"Türkçe","th":"ภาษาไทย","zh":"cinese","nl":"Dutch"},"regions":{"sea":"SEA","th":"Thailand","kr":"Korea","jp":"Japan","tw":"Taiwan","global":"Globale"}}}

/***/ }),

/***/ "3kZz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _login = __webpack_require__("7sS4");

var _login2 = _interopRequireDefault(_login);

var _setting = __webpack_require__("2qwb");

var _setting2 = _interopRequireDefault(_setting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var authorize = __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, "dfX3")),
    error = __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, "Zazt")),
    resetPassword = Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(30)]).then(__webpack_require__.bind(null, "Yva6")),
    resetPasswordLegacy = Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(31)]).then(__webpack_require__.bind(null, "fEFA")),
    createAccount = Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, "0jyn")),
    createAccountComplete = Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(17)]).then(__webpack_require__.bind(null, "JzEt")),
    verifyEmail = Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(18)]).then(__webpack_require__.bind(null, "qOwT")),
    verifyCodeTPA = Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(7)]).then(__webpack_require__.bind(null, "DggF")),
    healup = Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(__webpack_require__.bind(null, "ds6u")),
    maintenance = __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, "q+oP")),
    optOut = Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(25)]).then(__webpack_require__.bind(null, "vuxu")),
    linkTwitch = Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(__webpack_require__.bind(null, "WsIo"));

exports.default = [].concat((0, _toConsumableArray3.default)(_login2.default), (0, _toConsumableArray3.default)(_setting2.default), [{
	path: '/:locale/link/twitch',
	name: 'link-twitch',
	components: {
		body: function body() {
			return linkTwitch;
		}
	}
}, {
	path: '/:locale/reset-password',
	name: 'reset-password',
	components: {
		body: function body() {
			return resetPassword;
		}
	}
}, {
	path: '/:locale/reset-password-legacy',
	name: 'reset-password-legacy',
	components: {
		body: function body() {
			return resetPasswordLegacy;
		}
	}
}, {
	path: '/:locale/authorize',
	name: 'authorize',
	components: {
		body: function body() {
			return authorize;
		}
	}
}, {
	path: '/:locale/create',
	name: 'create-account',
	components: {
		body: function body() {
			return createAccount;
		}
	}
}, {
	path: '/:locale/create/complete',
	name: 'creation-complete',
	components: {
		body: function body() {
			return createAccountComplete;
		}
	}
}, {
	path: '/:locale/healup/:mode?',
	name: 'healup',
	components: {
		body: function body() {
			return healup;
		}
	},
	props: { body: true }
}, {
	path: '/:locale/create-tpa',
	name: 'create-tpa',
	redirect: '/:locale/healup/tpa'
}, {
	path: '/:locale/create/verify',
	name: 'verify-email',
	components: {
		body: function body() {
			return verifyEmail;
		}
	}
}, {
	path: '/:locale/create/verify/code-tpa',
	name: 'verify-code-tpa',
	components: {
		body: function body() {
			return verifyCodeTPA;
		}
	}
}, {
	path: '*',
	name: 'error-redirect',
	redirect: function redirect(to) {
		var firstPathSegment = to.path.split('/')[1],
		    cookieLang = _vue2.default.cookie.get('i18next') || 'en';
		if (firstPathSegment.length !== 2) {
			window.location = '/' + cookieLang + to.fullPath;
			return false;
		}
		return {
			path: '/' + cookieLang + '/error'
		};
	}
}, {
	path: '/:locale/error',
	name: 'error',
	components: {
		body: function body() {
			return error;
		}
	}
}, {
	path: '/:locale/maintenance',
	name: 'maintenance',
	components: {
		body: function body() {
			return maintenance;
		}
	}
}, {
	path: '/:locale/newsletter/opt-out',
	name: 'opt-out',
	components: {
		body: function body() {
			return optOut;
		}
	}
}]);

/***/ }),

/***/ "3lXs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
		value: true
});
exports.localeCodes = exports.locales = undefined;

var _values = __webpack_require__("gRE1");

var _values2 = _interopRequireDefault(_values);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var localeCodes = {
		de: 'de-DE',
		en: 'en-US',
		es: 'es-419',
		fr: 'fr-FR',
		it: 'it-IT',
		nl: 'nl-NL',
		pl: 'pl-PL',
		pt: 'pt-BR',
		th: 'th-TH',
		tr: 'tr-TR',
		zh: 'zh-TW'
},
    locales = (0, _values2.default)(localeCodes);

exports.locales = locales;
exports.localeCodes = localeCodes;

/***/ }),

/***/ "4hp6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "52fu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confirm_vue__ = __webpack_require__("az0N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confirm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confirm_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confirm_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confirm_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58de467c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_confirm_vue__ = __webpack_require__("8ShN");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confirm_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58de467c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_confirm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "7NE0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_error_vue__ = __webpack_require__("meBj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_error_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_error_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_error_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_error_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d35aa37c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_error_vue__ = __webpack_require__("Ns/l");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_error_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d35aa37c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_error_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "7sS4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _store = __webpack_require__("IcnI");

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var login = Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(__webpack_require__.bind(null, "K31e")),
    verifyDevice = Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(13)]).then(__webpack_require__.bind(null, "99Lm")),
    success = Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(28)]).then(__webpack_require__.bind(null, "wp4I")),
    zendesk = Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(27)]).then(__webpack_require__.bind(null, "TdNC")),
    sso = Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(29)]).then(__webpack_require__.bind(null, "dAd9")),
    logout = Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(26)]).then(__webpack_require__.bind(null, "0US+")),
    sMode = Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(14)]).then(__webpack_require__.bind(null, "BG7a")),
    nMode = Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(32)]).then(__webpack_require__.bind(null, "nESg")),
    migration = Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(15)]).then(__webpack_require__.bind(null, "qQYb")),
    migrationTPA = Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, "L5mF")),
    loginTPA = Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, "8JD3")),
    socialLink = Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, "i/lN")),
    migrationComplete = Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(16)]).then(__webpack_require__.bind(null, "TFGD")),
    settingSocialLink = __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, "ooda")),
    legacyTPA = Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(34)]).then(__webpack_require__.bind(null, "VFrK")),
    loginRoutes = [{
	path: '/:locale/login',
	name: 'login',
	components: {
		body: function body() {
			return login;
		}
	},
	props: { body: true },
	beforeEnter: function beforeEnter(to, from, next) {
		if (_store2.default.state.channel === 'steam') {
			// steam connector shouldn't show login page
			window.launcherLoginCancel();
		} else {
			next();
		}
	}
}, {
	path: '/:locale/logout',
	name: 'logout',
	components: {
		body: function body() {
			return logout;
		}
	}
}, {
	path: '/:locale/login/verify-device',
	name: 'verify-device',
	components: {
		body: function body() {
			return verifyDevice;
		}
	}
}, {
	path: '/:locale/login/tpa/:socialProvider?',
	name: 'login-tpa',
	components: {
		body: function body() {
			return loginTPA;
		}
	},
	props: { body: true }
}, {
	path: '/:locale/login/legacy-tpa/:socialProvider?',
	name: 'legacy-tpa',
	components: {
		body: function body() {
			return legacyTPA;
		}
	},
	props: { body: true }
}, {
	path: '/:locale/login/social-link/:case',
	name: 'login-social-link',
	components: {
		body: function body() {
			return socialLink;
		}
	},
	props: { body: true }
}, {
	path: '/:locale/login/callback/:socialProvider',
	name: 'login-tpa-callback',
	beforeEnter: function beforeEnter(to, from, next) {
		var state = void 0;
		// to support a redirect mode of google oauth
		if (to.hash) {
			var params = new URLSearchParams(to.hash.slice(1));
			to.query.code = params.get('id_token') || params.get('access_token');
			state = params.get('state');
		}
		if (state === 'socialLink') {
			next({
				replace: true,
				name: 'setting-social-link',
				params: to.params,
				query: to.query
			});
		} else if (state === 'legacyTPA') {
			next({
				replace: true,
				name: 'legacy-tpa',
				params: to.params,
				query: to.query
			});
		} else {
			next({
				replace: true,
				name: 'login-tpa',
				params: to.params,
				query: to.query
			});
		}
	}
}, {
	path: '/:locale/settings/social-link/:socialProvider',
	name: 'setting-social-link',
	components: {
		body: function body() {
			return settingSocialLink;
		}
	},
	props: { body: true }
}, {
	path: '/:locale/login/s-mode',
	name: 'smode',
	components: {
		body: function body() {
			return sMode;
		}
	}
}, {
	path: '/:locale/login/n-mode',
	name: 'nmode',
	components: {
		body: function body() {
			return nMode;
		}
	}
}, {
	path: '/:locale/login/success',
	name: 'success',
	components: {
		body: function body() {
			return success;
		}
	}
}, {
	path: '/:locale/login/zendesk',
	name: 'zendesk',
	components: {
		body: function body() {
			return zendesk;
		}
	}
}, {
	path: '/:locale/login/sso',
	name: 'sso',
	components: {
		body: function body() {
			return sso;
		}
	}
}, {
	path: '/:locale/login/migration',
	name: 'migration',
	components: {
		body: function body() {
			return migration;
		}
	}
}, {
	path: '/:locale/login/migration-tpa',
	name: 'migration-tpa',
	components: {
		body: function body() {
			return migrationTPA;
		}
	}
}, {
	path: '/:locale/login/migration-complete',
	name: 'migration-complete',
	components: {
		body: function body() {
			return migrationComplete;
		}
	}
}];

exports.default = loginRoutes;

/***/ }),

/***/ "8ShN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-box dialog-mask"},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.$t(_vm.title, _vm.i18nData)))])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t(_vm.content, _vm.i18nData))}})]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('ModalMultiButtons',{attrs:{"loading":_vm.loading,"btnPrimaryText":_vm.$t(_vm.confirmLabel),"btnSecondaryText":_vm.$t(_vm.cancelLabel),"primaryButtonClick":_vm.clickYes,"secondaryButtonClick":_vm.clickNo,"secondaryButtonHide":!_vm.cancelLabel}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8Ygz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cdnApi = _axios2.default.create({
	baseURL: "https://nxl.nxfs.nexon.com/"
}),
    getNotificationList = function getNotificationList() {
	return cdnApi.get('web/' + environment.region + '/notifications.json').then(function (res) {
		return res.data;
	});
},
    notificationAPI = {
	install: function install(Vue) {
		Vue.prototype.$notificationAPI = {
			getNotificationList: getNotificationList
		};
	}
};
exports.default = notificationAPI;

/***/ }),

/***/ "9fCX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue-full-loading/src/index.js
var src = __webpack_require__("B7eW");
var src_default = /*#__PURE__*/__webpack_require__.n(src);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@arena/toolkit/src/components/common/loading-overlay.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var loading_overlay = ({
	name: 'loadingOverlay',
	introduction: 'Full page loading spinner',
	token: '<loadingOverlay></loadingOverlay>',
	props: {
		show: {
			type: Boolean,
			default: false
		},
		label: {
			type: String,
			default: ''
		},
		eventBus: {
			default: null
		}
	},
	computed: {
		overlayLabel: function overlayLabel() {
			return this.label;
		}
	},
	components: {
		loading: src_default.a
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-263df929","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@arena/toolkit/src/components/common/loading-overlay.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loadingOverlay"},[_c('loading',{attrs:{"show":_vm.show,"label":_vm.overlayLabel,"overlay-class":"dark-overlay","loader-class":"centered-loader-wrapper","event-bus":_vm.eventBus,"event-show":"show-loading-overlay","event-hide":"hide-loading-overlay"}},[_c('div',{staticClass:"centered-spinner",attrs:{"slot":"loading-spinner"},slot:"loading-spinner"},[_c('span',{staticClass:"spinner-circle"})])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_loading_overlay = (esExports);
// CONCATENATED MODULE: ./node_modules/@arena/toolkit/src/components/common/loading-overlay.vue
function injectStyle (ssrContext) {
  __webpack_require__("4hp6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-263df929"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  loading_overlay,
  common_loading_overlay,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_common_loading_overlay = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9jjE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@arena/toolkit/src/components/common/icon-svg.vue + 2 modules
var icon_svg = __webpack_require__("EO4f");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@arena/toolkit/src/components/common/form-error.vue
//
//
//
//
//
//
//
//



/* harmony default export */ var form_error = ({
	name: 'formError',
	introduction: 'Vujs error form component',
	components: {
		svgIcon: icon_svg["default"]
	},
	props: {
		hideError: {
			type: Boolean,
			default: true,
			note: 'Show and hide control'
		},
		errorCode: {
			type: String,
			default: '',
			note: 'Set error code to get translated text'
		},
		extraErrorData: {
			type: Object,
			default: function _default() {
				return {};
			},
			note: 'Can be set some extra error date'
		}
	},
	computed: {
		formErrorCode: function formErrorCode() {
			return this.$store.state.form.errors.code;
		}
	},
	watch: {
		formErrorCode: function formErrorCode() {
			var container = document.getElementById('errorContainer');

			if (this.formErrorCode && container !== null) {
				container.scrollIntoView({
					behavior: 'smooth'
				});
			}
		}
	},
	created: function created() {
		if (!this.formErrorCode) {
			this.hideError = true;
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e6a12de6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@arena/toolkit/src/components/common/form-error.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hideError)?_c('div',{staticClass:"alert alert-danger text-center",class:{ 'hide': _vm.hideError},attrs:{"id":"errorContainer","role":"alert"}},[_c('svgIcon',{attrs:{"iconHolderClass":"icon-warning","iconId":"icon-warning"}}),_vm._v("\n\t"+_vm._s(_vm.$t('error.form.' + _vm.errorCode, _vm.extraErrorData))+"\n\t"),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_form_error = (esExports);
// CONCATENATED MODULE: ./node_modules/@arena/toolkit/src/components/common/form-error.vue
function injectStyle (ssrContext) {
  __webpack_require__("fVip")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e6a12de6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  form_error,
  common_form_error,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_common_form_error = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9pJU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A/uU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A9iO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer",class:_vm.classes,attrs:{"id":"globalFooter"}},[_c('svgIcons',{staticClass:"hide"}),_vm._v(" "),_c('div',{staticClass:"footer-top"},[(_vm.showFooterBtn && _vm.checkPath === 'main')?_c('div',{staticClass:"footer-btn"},[(_vm.moveFooterUp === true)?_c('a',{staticClass:"footer-btn-off",on:{"click":_vm.footerToogle}},[_c('svgIcon',{attrs:{"iconHolderClass":"icon-ellipsis","iconId":"icon-ellipsis-active"}})],1):(_vm.moveFooterUp === false)?_c('a',{staticClass:"footer-btn-on",on:{"click":_vm.footerToogle}},[_c('svgIcon',{attrs:{"iconHolderClass":"icon-ellipsis","iconId":"icon-ellipsis"}})],1):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.close),expression:"close"}],ref:"select",staticClass:"language pull-right",class:{ 'show-languages': _vm.showLanguage }},[_c('div',{staticClass:"current-language",on:{"click":function($event){_vm.toggle()},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }$event.stopPropagation();$event.preventDefault();return _vm.close($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.stopPropagation();$event.preventDefault();return _vm.toggle($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.stopPropagation();$event.preventDefault();return _vm.toggle($event)}]}},[_c('span',[_vm._v(_vm._s(_vm.$t(("footer.regions." + _vm.region)))+" - ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(("footer.languages." + (_vm.$i18n.locale)))))]),_vm._v(" "),_c('svgIcon',{attrs:{"iconHolderClass":"icon-locale","iconId":"icon-globe"}}),_vm._v(" "),_c('svgIcon',{attrs:{"iconHolderClass":"icon-locale-hover","iconId":"icon-globe-hover"}})],1),_vm._v(" "),_c('ul',{staticClass:"languages list-unstyled",class:{ 'show-languages': _vm.showLanguage }},[_c('li',{staticClass:"region global"},[(_vm.region === 'global')?_c('a',{staticClass:"global",on:{"click":_vm.toggleGlobalLocale}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.$t('footer.regions.global'))+"\n\t\t\t\t\t\t"),(_vm.showGlobalLocale)?_c('svgIcon',{attrs:{"iconHolderClass":"icon-minus","iconId":"icon-minus"}}):_vm._e(),_vm._v(" "),(_vm.showGlobalLocale)?_c('svgIcon',{attrs:{"iconHolderClass":"icon-minus-hover","iconId":"icon-minus-hover"}}):_vm._e(),_vm._v(" "),(!_vm.showGlobalLocale)?_c('svgIcon',{attrs:{"iconHolderClass":"icon-plus","iconId":"icon-plus"}}):_vm._e(),_vm._v(" "),(!_vm.showGlobalLocale)?_c('svgIcon',{attrs:{"iconHolderClass":"icon-plus-hover","iconId":"icon-plus-hover"}}):_vm._e()],1):_c('a',{on:{"click":function($event){_vm.changeRegion(_vm.regionHost.global, 'en')}}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.$t('footer.regions.global'))+"\n\t\t\t\t\t")])]),_vm._v(" "),(_vm.region === 'global')?_c('ul',{staticClass:"global-locale list-unstyled",class:{ 'show-global-locale': _vm.showGlobalLocale }},_vm._l((_vm.language['global']),function(languages){return _c('li',{staticClass:"language-list"},[_c('a',{on:{"click":function($event){_vm.changeLanguage(languages.split('-')[0])}}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.$t(("footer.languages." + (languages.split('-')[0]))))+"\n\t\t\t\t\t\t")])])}),0):_vm._e(),_vm._v(" "),_c('li',{staticClass:"region th"},[_c('a',{staticClass:"th",on:{"click":function($event){_vm.changeRegion(_vm.regionHost.th, 'th')}}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.$t('footer.regions.th'))+"\n\t\t\t\t\t")])]),_vm._v(" "),_c('li',{staticClass:"region tw"},[_c('a',{staticClass:"tw",on:{"click":function($event){_vm.changeRegion(_vm.regionHost.tw, 'zh')}}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.$t('footer.regions.tw'))+"\n\t\t\t\t\t")])]),_vm._v(" "),_c('li',{staticClass:"region kr"},[_c('a',{staticClass:"kr",attrs:{"target":"_blank","rel":"external"},on:{"click":_vm.redirectToKR}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.$t('footer.regions.kr'))+"\n\t\t\t\t\t\t"),_c('svgIcon',{attrs:{"iconHolderClass":"icon-external-link","iconId":"icon-external-link"}}),_vm._v(" "),_c('svgIcon',{attrs:{"iconHolderClass":"icon-external-link-hover","iconId":"icon-external-link-hover"}})],1)]),_vm._v(" "),_c('li',{staticClass:"region jp"},[_c('a',{staticClass:"jp",attrs:{"href":_vm.externalRegionLinks.jp,"target":"_blank","rel":"external"}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.$t('footer.regions.jp'))+"\n\t\t\t\t\t\t"),_c('svgIcon',{attrs:{"iconHolderClass":"icon-external-link","iconId":"icon-external-link"}}),_vm._v(" "),_c('svgIcon',{attrs:{"iconHolderClass":"icon-external-link-hover","iconId":"icon-external-link-hover"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"pull-left"},[_c('ul',{staticClass:"links list-inline text-uppercase"},_vm._l((_vm.footerTopLinks),function(footerTopLink){return _c('li',[_c('a',{staticClass:"footer-top-link",attrs:{"href":footerTopLink.url}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(footerTopLink.name)+"\n\t\t\t\t\t")])])}),0)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"footer-bottom"},[_c('ul',{staticClass:"links list-inline text-uppercase"},_vm._l((_vm.footerBottomLinks[_vm.region]),function(footerBottomLink){return _c('li',[_c('a',{class:footerBottomLink.name,attrs:{"href":footerBottomLink.url}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.$t(("footer." + (footerBottomLink.name))))+"\n\t\t\t\t")])])}),0),_vm._v(" "),_c('p',{staticClass:"copyright"},[_vm._v("\n\t\t\t"+_vm._s(_vm.$t('footer.copyright', [_vm.currentYear]))+"\n\t\t")]),_vm._v(" "),_c('a',{staticClass:"nexon-logo-footer"},[_c('svgIcon',{attrs:{"iconHolderClass":"logo","iconId":"nexon-logo-full"}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BFtu":
/***/ (function(module, exports) {

module.exports = {"footer":{"aboutNexon":"เกี่ยวกับบริษัทเน็กซอน","support":"ช่วยเหลือ","careers":"ตำแหน่งงาน","businessOpportunities":"โอกาสทางธุรกิจ","press":"ข่าวสาร","investorRelations":"นักลงทุนสัมพันธ์","privacy":"นโยบายความเป็นส่วนตัว","legalDoc":"เอกสารทางกฎหมาย","tou":"ข้อกำหนดการใช้งาน","eula":"สัญญาในการเข้าใช้งาน","copyright":"© NEXON (Thailand) Co., Ltd. All Rights Reserved.","languages":{"es":"Español (LA)","en":"English","pt":"Português (BR)","de":"Deutsch","fr":"Français","it":"Italiano","pl":"Polski","tr":"Türkçe","th":"ภาษาไทย","zh":"จีน","nl":"Dutch"},"regions":{"sea":"SEA","th":"Thailand","kr":"Korea","jp":"Japan","tw":"Taiwan","global":"Global"}}}

/***/ }),

/***/ "CXSM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D/ac":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@arena/toolkit/src/components/common/form-iovation.vue
//
//
//
//
//
//
//
//


/* harmony default export */ var form_iovation = ({
	name: 'formIovation',
	mounted: function mounted() {
		var iovationScript = document.createElement('script');
		window.io_bbout_element_id = 'blackbox';
		window.io_install_stm = false;
		window.io_exclude_stm = 12;
		window.io_max_wait = 3000;
		window.io_submit_form_id = 'reg-fs-form';
		window.io_min_flash_version = '20.1.0';
		iovationScript.setAttribute('src', 'https://mpsnare.iesnare.com/snare.js');
		document.head.appendChild(iovationScript);
	},
	beforeDestroy: function beforeDestroy() {
		var iovationScripts = document.querySelectorAll('script[src^="https://mpsnare.iesnare.com/snare.js"]');
		for (var i = 0; i < iovationScripts.length; i += 1) {
			iovationScripts[i].parentElement.removeChild(iovationScripts[i]);
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02218982","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@arena/toolkit/src/components/common/form-iovation.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{attrs:{"id":"blackbox","type":"hidden"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_form_iovation = (esExports);
// CONCATENATED MODULE: ./node_modules/@arena/toolkit/src/components/common/form-iovation.vue
function injectStyle (ssrContext) {
  __webpack_require__("j+p7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  form_iovation,
  common_form_iovation,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_common_form_iovation = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DX4b":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./de-DE.json": [
		"IdXX",
		45
	],
	"./en-US.json": [
		"IFIa"
	],
	"./es-419.json": [
		"uGlq",
		44
	],
	"./fr-FR.json": [
		"znoz",
		43
	],
	"./it-IT.json": [
		"JO1e",
		42
	],
	"./nl-NL.json": [
		"WROx",
		41
	],
	"./pl-PL.json": [
		"6X3a",
		40
	],
	"./pt-BR.json": [
		"wJOA",
		39
	],
	"./th-TH.json": [
		"BhAd",
		38
	],
	"./tr-TR.json": [
		"8YNv",
		37
	],
	"./zh-TW.json": [
		"bSGe",
		36
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "DX4b";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "EO4f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@arena/toolkit/src/components/common/icon-svg.vue
//
//
//
//
//
//

/* harmony default export */ var icon_svg = ({
	name: 'iconSVG',
	description: 'This required to use svg icon sprite file. With CSS class it can control the icon size.',
	props: {
		iconHolderClass: {
			type: String,
			default: '',
			note: 'CSS class that can be assign to handle size and other'
		},
		iconId: {
			type: String,
			required: true,
			default: '',
			note: 'Required to assign exist ID to get the image from sprite file.'
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11b43a4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@arena/toolkit/src/components/common/icon-svg.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.iconHolderClass},[_c('use',{attrs:{"xlink:href":("#" + _vm.iconId)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_icon_svg = (esExports);
// CONCATENATED MODULE: ./node_modules/@arena/toolkit/src/components/common/icon-svg.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  icon_svg,
  common_icon_svg,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_common_icon_svg = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "EXcH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FOgX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@arena/toolkit/src/components/common/icon-sprite.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var icon_sprite = ({
	name: 'iconSprite'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06156d44","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@arena/toolkit/src/components/common/icon-sprite.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"id":"icons","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","version":"1.1","viewBox":"0 0 36 36"}},[_c('defs',[_c('symbol',{attrs:{"id":"nexon-logo-full","viewBox":"0 0 91.12 27.73"}},[_c('polygon',{staticClass:"cls-1",attrs:{"points":"45.8 12.6 37.43 12.6 37.43 10.48 45.8 10.48 45.8 8.11 37.43 8.11 37.43 6.21 45.8 6.21 45.8 3.86 34.46 3.86 34.46 14.95 45.8 14.95 45.8 12.6"}}),_c('polygon',{staticClass:"cls-1",attrs:{"points":"81.85 8.25 88.88 14.95 91.12 14.95 91.12 3.86 88.15 3.86 88.15 10.57 81.13 3.86 78.89 3.86 78.89 14.95 81.85 14.95 81.85 8.25"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M102.64,14H90.4V25.12h12.24Zm-3,8.74h-6.3V16.38h6.3Z","transform":"translate(-26.95 -10.17)"}}),_c('polygon',{staticClass:"cls-1",attrs:{"points":"22 8.25 29.03 14.95 31.26 14.95 31.26 3.86 28.3 3.86 28.3 10.57 21.27 3.86 19.03 3.86 19.03 14.95 22 14.95 22 8.25"}}),_c('polygon',{staticClass:"cls-1",attrs:{"points":"54.63 11.53 57.67 14.95 61.42 14.95 56.51 9.41 61.43 3.86 57.68 3.86 54.63 7.3 51.59 3.86 47.84 3.86 52.76 9.41 47.85 14.95 51.6 14.95 54.63 11.53"}}),_c('polygon',{staticClass:"cls-2",attrs:{"points":"0 15 0 24.32 12.38 17.74 0 15"}}),_c('polygon',{staticClass:"cls-3",attrs:{"points":"12.38 0 0 6.58 0 15 12.38 17.74 12.38 0"}}),_c('polygon',{staticClass:"cls-4",attrs:{"points":"12.38 17.74 0 24.32 15.35 27.73 27.73 21.14 12.38 17.74"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"nexon-logo","viewBox":"0 0 88 13.54"}},[_c('polygon',{staticClass:"white",attrs:{"points":"32.68 10.67 22.46 10.67 22.46 8.08 32.68 8.08 32.68 5.19 22.46 5.19 22.46 2.87 32.68 2.87 32.68 0 18.84 0 18.84 13.54 32.68 13.54 32.68 10.67"}}),_c('polygon',{staticClass:"white",attrs:{"points":"76.69 5.35 85.27 13.54 88 13.54 88 0 84.38 0 84.38 8.19 75.8 0 73.07 0 73.07 13.54 76.69 13.54 76.69 5.35"}}),_c('path',{staticClass:"white",attrs:{"d":"M97.17,17H82.24V30.57H97.17ZM93.55,27.7H85.86V19.9h7.69Z","transform":"translate(-28 -17.03)"}}),_c('polygon',{staticClass:"white",attrs:{"points":"3.62 5.35 12.2 13.54 14.94 13.54 14.94 0 11.31 0 11.31 8.19 2.73 0 0 0 0 13.54 3.62 13.54 3.62 5.35"}}),_c('polygon',{staticClass:"white",attrs:{"points":"43.46 9.36 47.17 13.54 51.75 13.54 45.75 6.78 51.76 0 47.18 0 43.46 4.2 39.75 0 35.16 0 41.17 6.78 35.18 13.54 39.76 13.54 43.46 9.36"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-account","viewBox":"0 0 48 48"}},[_c('path',{staticClass:"highlight",attrs:{"d":"M24,6C14.1,6,6,14.1,6,24c0,9.9,8.1,18,18,18c9.9,0,18-8.1,18-18C42,14.1,34,6,24,6z M24,13.2\n\t\tc3,0,5.4,2.4,5.4,5.4c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4C18.6,15.6,21,13.2,24,13.2z M24,38.4c-3.9,0-7.4-1.5-10-4.1\n\t\tc1.6-4,5.5-6.7,10-6.7c4.5,0,8.4,2.8,10,6.7C31.4,36.9,27.9,38.4,24,38.4z"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-all-game","viewBox":"0 0 36 36"}},[_c('path',{staticClass:"white",attrs:{"d":"M7.72,6h5.14a1.72,1.72,0,0,1,1.72,1.71v5.15a1.72,1.72,0,0,1-1.72,1.71H7.72A1.71,1.71,0,0,1,6,12.89V7.74A1.71,1.71,0,0,1,7.72,6Z","transform":"translate(-6.01 -6.03)"}}),_c('path',{staticClass:"white",attrs:{"d":"M21.43,6h5.15a1.72,1.72,0,0,1,1.71,1.71v5.15a1.72,1.72,0,0,1-1.71,1.71H21.43a1.72,1.72,0,0,1-1.71-1.71V7.74A1.72,1.72,0,0,1,21.43,6Z","transform":"translate(-6.01 -6.03)"}}),_c('path',{staticClass:"white",attrs:{"d":"M35.15,6h5.14A1.72,1.72,0,0,1,42,7.74v5.15a1.72,1.72,0,0,1-1.72,1.71H35.15a1.72,1.72,0,0,1-1.72-1.71V7.74A1.72,1.72,0,0,1,35.15,6Z","transform":"translate(-6.01 -6.03)"}}),_c('path',{staticClass:"white",attrs:{"d":"M7.72,19.74h5.14a1.72,1.72,0,0,1,1.72,1.72V26.6a1.71,1.71,0,0,1-1.72,1.71H7.72A1.7,1.7,0,0,1,6,26.6V21.46A1.71,1.71,0,0,1,7.72,19.74Z","transform":"translate(-6.01 -6.03)"}}),_c('path',{staticClass:"white",attrs:{"d":"M21.43,19.74h5.15a1.72,1.72,0,0,1,1.71,1.72V26.6a1.71,1.71,0,0,1-1.71,1.71H21.43a1.71,1.71,0,0,1-1.71-1.71V21.46A1.72,1.72,0,0,1,21.43,19.74Z","transform":"translate(-6.01 -6.03)"}}),_c('path',{staticClass:"white",attrs:{"d":"M35.15,19.74h5.14A1.72,1.72,0,0,1,42,21.46V26.6a1.71,1.71,0,0,1-1.72,1.71H35.15a1.71,1.71,0,0,1-1.72-1.71V21.46A1.72,1.72,0,0,1,35.15,19.74Z","transform":"translate(-6.01 -6.03)"}}),_c('path',{staticClass:"white",attrs:{"d":"M7.72,33.46h5.14a1.71,1.71,0,0,1,1.72,1.71v5.14A1.72,1.72,0,0,1,12.86,42H7.72A1.71,1.71,0,0,1,6,40.31V35.17A1.7,1.7,0,0,1,7.72,33.46Z","transform":"translate(-6.01 -6.03)"}}),_c('path',{staticClass:"white",attrs:{"d":"M21.43,33.46h5.15a1.71,1.71,0,0,1,1.71,1.71v5.14A1.72,1.72,0,0,1,26.58,42H21.43a1.72,1.72,0,0,1-1.71-1.72V35.17A1.71,1.71,0,0,1,21.43,33.46Z","transform":"translate(-6.01 -6.03)"}}),_c('path',{staticClass:"white",attrs:{"d":"M35.15,33.46h5.14A1.71,1.71,0,0,1,42,35.17v5.14A1.72,1.72,0,0,1,40.29,42H35.15a1.72,1.72,0,0,1-1.72-1.72V35.17A1.71,1.71,0,0,1,35.15,33.46Z","transform":"translate(-6.01 -6.03)"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-close","viewBox":"0 0 36 35.99"}},[_c('polygon',{staticClass:"white",attrs:{"points":"36 2.25 33.75 0 18 15.75 2.25 0 0 2.25 15.75 18 0.01 33.74 2.26 35.98 18 20.25 33.74 35.98 35.98 33.74 20.25 18 36 2.25"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-plus","viewBox":"0 0 32 32"}},[_c('path',{staticClass:"white",attrs:{"d":"M31 12h-11v-11c0-0.552-0.448-1-1-1h-6c-0.552 0-1 0.448-1 1v11h-11c-0.552 0-1 0.448-1 1v6c0 0.552 0.448 1 1 1h11v11c0 0.552 0.448 1 1 1h6c0.552 0 1-0.448 1-1v-11h11c0.552 0 1-0.448 1-1v-6c0-0.552-0.448-1-1-1z"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-plus-hover","viewBox":"0 0 32 32"}},[_c('path',{staticClass:"black",attrs:{"d":"M31 12h-11v-11c0-0.552-0.448-1-1-1h-6c-0.552 0-1 0.448-1 1v11h-11c-0.552 0-1 0.448-1 1v6c0 0.552 0.448 1 1 1h11v11c0 0.552 0.448 1 1 1h6c0.552 0 1-0.448 1-1v-11h11c0.552 0 1-0.448 1-1v-6c0-0.552-0.448-1-1-1z"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-minus","viewBox":"0 0 32 32"}},[_c('path',{staticClass:"white",attrs:{"d":"M0 13v6c0 0.552 0.448 1 1 1h30c0.552 0 1-0.448 1-1v-6c0-0.552-0.448-1-1-1h-30c-0.552 0-1 0.448-1 1z"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-minus-hover","viewBox":"0 0 32 32"}},[_c('path',{staticClass:"black",attrs:{"d":"M0 13v6c0 0.552 0.448 1 1 1h30c0.552 0 1-0.448 1-1v-6c0-0.552-0.448-1-1-1h-30c-0.552 0-1 0.448-1 1z"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-globe","viewBox":"0 0 36 36"}},[_c('path',{staticClass:"white",attrs:{"d":"M29.6,37.92A24.92,24.92,0,0,0,32.52,30h5.25A15,15,0,0,1,29.6,37.92ZM10.3,30h5.25a25.17,25.17,0,0,0,2.92,7.91A15,15,0,0,1,10.3,30Zm-1-9h5.78a31.64,31.64,0,0,0,0,6H9.34a15.15,15.15,0,0,1,0-6Zm9.13-10.92A25.23,25.23,0,0,0,15.55,18H10.3A15,15,0,0,1,18.47,10.09ZM25.54,27V21h4.39a27.36,27.36,0,0,1,0,6Zm0,11.48V30h3.9A19.81,19.81,0,0,1,25.54,38.49Zm-3-8.48v8.48A19.7,19.7,0,0,1,18.63,30Zm0-9v6h-4.4a27.36,27.36,0,0,1,0-6Zm0-11.49V18H18.63A19.69,19.69,0,0,1,22.54,9.52ZM29.44,18h-3.9V9.52A19.8,19.8,0,0,1,29.44,18Zm8.33,0H32.52a25,25,0,0,0-2.92-7.92A15,15,0,0,1,37.77,18ZM39,24a14.89,14.89,0,0,1-.31,3H33a31.64,31.64,0,0,0,0-6h5.78A14.82,14.82,0,0,1,39,24ZM24,6A18,18,0,1,0,42,24,18,18,0,0,0,24,6Z","transform":"translate(-6.04 -6.01)"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-globe-hover","viewBox":"0 0 36 36"}},[_c('path',{staticClass:"hover",attrs:{"d":"M29.6,37.92A24.92,24.92,0,0,0,32.52,30h5.25A15,15,0,0,1,29.6,37.92ZM10.3,30h5.25a25.17,25.17,0,0,0,2.92,7.91A15,15,0,0,1,10.3,30Zm-1-9h5.78a31.64,31.64,0,0,0,0,6H9.34a15.15,15.15,0,0,1,0-6Zm9.13-10.92A25.23,25.23,0,0,0,15.55,18H10.3A15,15,0,0,1,18.47,10.09ZM25.54,27V21h4.39a27.36,27.36,0,0,1,0,6Zm0,11.48V30h3.9A19.81,19.81,0,0,1,25.54,38.49Zm-3-8.48v8.48A19.7,19.7,0,0,1,18.63,30Zm0-9v6h-4.4a27.36,27.36,0,0,1,0-6Zm0-11.49V18H18.63A19.69,19.69,0,0,1,22.54,9.52ZM29.44,18h-3.9V9.52A19.8,19.8,0,0,1,29.44,18Zm8.33,0H32.52a25,25,0,0,0-2.92-7.92A15,15,0,0,1,37.77,18ZM39,24a14.89,14.89,0,0,1-.31,3H33a31.64,31.64,0,0,0,0-6h5.78A14.82,14.82,0,0,1,39,24ZM24,6A18,18,0,1,0,42,24,18,18,0,0,0,24,6Z","transform":"translate(-6.04 -6.01)"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-menu","viewBox":"0 0 36 30.6"}},[_c('path',{staticClass:"white",attrs:{"d":"M6,8.73H42v5.4H6Z","transform":"translate(-6.01 -8.73)"}}),_c('path',{staticClass:"white",attrs:{"d":"M6,21.33H42v5.4H6Z","transform":"translate(-6.01 -8.73)"}}),_c('path',{staticClass:"white",attrs:{"d":"M6,33.93H42v5.4H6Z","transform":"translate(-6.01 -8.73)"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-arrow-left","viewBox":"0 0 20.37 36"}},[_c('polygon',{attrs:{"points":"18 36 20.37 33.63 4.74 18 20.37 2.37 18 0 0 18 18 36"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-arrow-right","viewBox":"0 0 20.37 36"}},[_c('polygon',{attrs:{"points":"2.37 0 0 2.37 15.63 18 0 33.63 2.37 36 20.37 18 2.37 0"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-arrow-up","viewBox":"0 0 36 20.37"}},[_c('polygon',{attrs:{"points":"0 18 2.37 20.37 18 4.74 33.63 20.37 36 18 18 0 0 18"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-arrow-down","viewBox":"0 0 36 20.37"}},[_c('polygon',{attrs:{"points":"36 2.37 33.63 0 18 15.63 2.37 0 0 2.37 18 20.37 36 2.37"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-page-left","viewBox":"0 0 20.25 36"}},[_c('path',{staticClass:"white",attrs:{"d":"M19.29,24l14.2-14.2a2.23,2.23,0,1,0-3.16-3.15L14.55,22.45a2.23,2.23,0,0,0,0,3.15L30.33,41.37a2.23,2.23,0,1,0,3.16-3.15Z","transform":"translate(-13.9 -6.03)"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-page-right","viewBox":"0 0 20.25 36"}},[_c('path',{staticClass:"white",attrs:{"d":"M33.49,22.45,17.7,6.68a2.23,2.23,0,0,0-3.15,3.16L28.75,24,14.55,38.22a2.23,2.23,0,1,0,3.15,3.15L33.49,25.6A2.23,2.23,0,0,0,33.49,22.45Z","transform":"translate(-13.89 -6.03)"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-page-right-blue","viewBox":"0 0 20.25 36"}},[_c('path',{staticClass:"light-blue",attrs:{"d":"M33.49,22.45,17.7,6.68a2.23,2.23,0,0,0-3.15,3.16L28.75,24,14.55,38.22a2.23,2.23,0,1,0,3.15,3.15L33.49,25.6A2.23,2.23,0,0,0,33.49,22.45Z","transform":"translate(-13.89 -6.03)"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-page-up","viewBox":"0 0 36 20.25"}},[_c('path',{staticClass:"white",attrs:{"d":"M24,19.29,38.21,33.5a2.23,2.23,0,1,0,3.16-3.16L25.6,14.56a2.24,2.24,0,0,0-3.16,0L6.67,30.34A2.23,2.23,0,1,0,9.83,33.5Z","transform":"translate(-6.02 -13.9)"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-page-down","viewBox":"0 0 36 20.25"}},[_c('path',{staticClass:"white",attrs:{"d":"M25.59,33.5,41.36,17.71a2.23,2.23,0,0,0-3.15-3.15L24,28.76,9.82,14.56a2.23,2.23,0,0,0-3.15,3.15L22.44,33.5A2.23,2.23,0,0,0,25.59,33.5Z","transform":"translate(-6.02 -13.9)"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-page-down-hover","viewBox":"0 0 36 20.25"}},[_c('path',{staticClass:"black",attrs:{"d":"M25.59,33.5,41.36,17.71a2.23,2.23,0,0,0-3.15-3.15L24,28.76,9.82,14.56a2.23,2.23,0,0,0-3.15,3.15L22.44,33.5A2.23,2.23,0,0,0,25.59,33.5Z","transform":"translate(-6.02 -13.9)"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-warning","viewBox":"0 0 24 24"}},[_c('path',{staticClass:"white",attrs:{"d":"M23.8,20.2L13.4,2.2c-0.6-1.1-2.2-1.1-2.8,0L0.2,20.2c-0.6,1.1,0.2,2.5,1.4,2.5h20.7C23.6,22.6,24.4,21.2,23.8,20.2z\n M12,19.5c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1C13.1,19,12.6,19.5,12,19.5z M13.3,9.4l-0.8,6\nc0,0.3-0.3,0.5-0.6,0.5c-0.3,0-0.5-0.2-0.6-0.5l-0.7-6c-0.1-0.8,0.5-1.5,1.3-1.5C12.8,7.9,13.4,8.6,13.3,9.4z"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-download","viewBox":"0 0 64 64"}},[_c('g',{attrs:{"transform":"matrix(1.3333333,0,0,-1.3333333,0,64)","id":"g10"}},[_c('g',{attrs:{"transform":"translate(10.541,26.2446)","id":"g12"}},[_c('path',{attrs:{"id":"path14","d":"m 0,0 h 9 v 15.75 h 8.999 V 0 h 9 L 13.5,-13.5 Z"}})]),_vm._v(" "),_c('path',{attrs:{"id":"path16","d":"M 10.542,10.494 H 37.54 v -4.5 H 10.542 Z"}})])]),_vm._v("\n\t\t// Third party account providers //\n\t\t"),_c('symbol',{attrs:{"id":"icon-facebook","viewBox":"0 0 100 100"}},[_c('path',{staticClass:"facebook-bg",attrs:{"id":"Blue_2_","d":"M94.5,100c3,0,5.5-2.5,5.5-5.5v-89c0-3-2.5-5.5-5.5-5.5h-89C2.5,0,0,2.5,0,5.5v89\n\t\tc0,3,2.5,5.5,5.5,5.5H94.5z"}}),_vm._v(" "),_c('path',{staticClass:"facebook-f",attrs:{"id":"f_1_","d":"M69,100V61.3h13l1.9-15.1H69v-9.6c0-4.4,1.2-7.3,7.5-7.3l8,0V15.7c-1.4-0.2-6.1-0.6-11.6-0.6\n\t\tc-11.5,0-19.4,7-19.4,19.9v11.1h-13v15.1h13V100H69z"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-facebook-blue","viewBox":"0 0 100 100"}},[_c('path',{staticClass:"facebook-bg-blue",attrs:{"id":"Blue_2_","d":"M94.5,100c3,0,5.5-2.5,5.5-5.5v-89c0-3-2.5-5.5-5.5-5.5h-89C2.5,0,0,2.5,0,5.5v89\n\t\tc0,3,2.5,5.5,5.5,5.5H94.5z"}}),_vm._v(" "),_c('path',{staticClass:"white",attrs:{"id":"f_1_","d":"M69,100V61.3h13l1.9-15.1H69v-9.6c0-4.4,1.2-7.3,7.5-7.3l8,0V15.7c-1.4-0.2-6.1-0.6-11.6-0.6\n\t\tc-11.5,0-19.4,7-19.4,19.9v11.1h-13v15.1h13V100H69z"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"wordmark-facebook","viewBox":"0 0 98.1 18.7"}},[_c('path',{staticClass:"facebook-bg",attrs:{"id":"XMLID_48_","d":"M7.7,3C6.5,3,6.2,3.5,6.2,4.6v1.9h3.1L9,9.5H6.2v9.2H2.5V9.5H0v-3h2.5V4.7\n\t\t\tC2.5,1.6,3.7,0,7.2,0c0.7,0,1.6,0.1,2.2,0.1V3"}}),_vm._v(" "),_c('path',{staticClass:"facebook-bg",attrs:{"id":"XMLID_66_","d":"M9.5,12.2c0-3.4,1.6-6,5-6c1.8,0,3,1,3.5,2.1V6.5h3.5v12.2H18v-1.8C17.5,18,16.4,19,14.5,19\n\t\t\tc-3.4,0-5-2.6-5-6 M13.2,13c0,1.8,0.7,3,2.4,3c1.5,0,2.3-1.1,2.3-2.8V12c0-1.7-0.8-2.8-2.3-2.8c-1.7,0-2.4,1.2-2.4,3V13z"}}),_vm._v(" "),_c('path',{staticClass:"facebook-bg",attrs:{"id":"XMLID_45_","d":"M29.3,6.2c1.4,0,2.8,0.3,3.5,0.8L32,9.7c-0.6-0.3-1.5-0.6-2.5-0.6c-2,0-2.9,1.2-2.9,3.1V13\n\t\t\tc0,2,0.9,3.1,2.9,3.1c1,0,1.9-0.3,2.5-0.6l0.8,2.6c-0.7,0.5-2.1,0.8-3.5,0.8c-4.3,0-6.3-2.3-6.3-6.1v-0.6\n\t\t\tC23,8.6,24.9,6.2,29.3,6.2"}}),_vm._v(" "),_c('path',{staticClass:"facebook-bg",attrs:{"id":"XMLID_62_","d":"M33.3,13.1V12c0-3.5,2-5.7,6-5.7c3.8,0,5.5,2.3,5.5,5.7v2H37c0.1,1.7,0.8,2.4,2.9,2.4\n\t\t\tc1.4,0,2.8-0.3,3.9-0.7l0.7,2.5c-1,0.5-3,0.9-4.7,0.9C35.1,19,33.3,16.7,33.3,13.1 M37,11.5h4.5v-0.3c0-1.3-0.5-2.4-2.2-2.4\n\t\t\tC37.6,8.8,37,9.8,37,11.5"}}),_vm._v(" "),_c('path',{staticClass:"facebook-bg",attrs:{"id":"XMLID_59_","d":"M58.5,13c0,3.4-1.6,6-5,6c-1.8,0-3.1-0.9-3.6-2.1v1.8h-3.5V0.4L50,0v8.2\n\t\t\tc0.5-1.1,1.7-1.9,3.4-1.9c3.4,0,5,2.6,5,6 M54.8,12.1c0-1.7-0.7-3-2.4-3c-1.5,0-2.3,1.1-2.3,2.8v1.3c0,1.7,0.8,2.8,2.3,2.8\n\t\t\tc1.8,0,2.4-1.3,2.4-3V12.1z"}}),_vm._v(" "),_c('path',{staticClass:"facebook-bg",attrs:{"id":"XMLID_56_","d":"M59.7,12.9v-0.6c0-3.5,2-6.1,6.1-6.1c4.1,0,6.1,2.5,6.1,6.1v0.6c0,3.5-2,6.1-6.1,6.1\n\t\t\tC61.7,19,59.7,16.4,59.7,12.9 M68.2,12c0-1.6-0.7-2.9-2.4-2.9c-1.7,0-2.4,1.3-2.4,2.9v1.1c0,1.6,0.7,2.9,2.4,2.9\n\t\t\tc1.7,0,2.4-1.3,2.4-2.9V12z"}}),_vm._v(" "),_c('path',{staticClass:"facebook-bg",attrs:{"id":"XMLID_53_","d":"M73.1,12.9v-0.6c0-3.5,2-6.1,6.1-6.1c4.1,0,6.1,2.5,6.1,6.1v0.6c0,3.5-2,6.1-6.1,6.1\n\t\t\tC75.1,19,73.1,16.4,73.1,12.9 M81.6,12c0-1.6-0.7-2.9-2.4-2.9c-1.7,0-2.4,1.3-2.4,2.9v1.1c0,1.6,0.7,2.9,2.4,2.9\n\t\t\tc1.7,0,2.4-1.3,2.4-2.9V12z"}}),_vm._v(" "),_c('polyline',{staticClass:"facebook-bg",attrs:{"id":"XMLID_32_","points":"90.4,12.3 94,6.5 97.9,6.5 94.1,12.5 98.1,18.7 94.2,18.7 90.4,12.7 90.4,18.7\n\t\t\t86.7,18.7 86.7,0.4 90.4,0"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-google","viewBox":"0 0 48 48"}},[_c('path',{staticStyle:{"fill":"#FFC107"},attrs:{"d":"M 43.609375 20.082031 L 42 20.082031 L 42 20 L 24 20 L 24 28 L 35.304688 28 C 33.652344 32.65625 29.222656 36 24 36 C 17.371094 36 12 30.628906 12 24 C 12 17.371094 17.371094 12 24 12 C 27.058594 12 29.84375 13.152344 31.960938 15.039063 L 37.617188 9.382813 C 34.046875 6.054688 29.269531 4 24 4 C 12.953125 4 4 12.953125 4 24 C 4 35.046875 12.953125 44 24 44 C 35.046875 44 44 35.046875 44 24 C 44 22.660156 43.863281 21.351563 43.609375 20.082031 Z "}}),_vm._v(" "),_c('path',{staticStyle:{"fill":"#FF3D00"},attrs:{"d":"M 6.304688 14.691406 L 12.878906 19.511719 C 14.65625 15.109375 18.960938 12 24 12 C 27.058594 12 29.84375 13.152344 31.960938 15.039063 L 37.617188 9.382813 C 34.046875 6.054688 29.269531 4 24 4 C 16.316406 4 9.65625 8.335938 6.304688 14.691406 Z "}}),_vm._v(" "),_c('path',{staticStyle:{"fill":"#4CAF50"},attrs:{"d":"M 24 44 C 29.164063 44 33.859375 42.023438 37.410156 38.808594 L 31.21875 33.570313 C 29.210938 35.089844 26.714844 36 24 36 C 18.796875 36 14.382813 32.683594 12.71875 28.054688 L 6.195313 33.078125 C 9.503906 39.554688 16.226563 44 24 44 Z "}}),_vm._v(" "),_c('path',{staticStyle:{"fill":"#1976D2"},attrs:{"d":"M 43.609375 20.082031 L 42 20.082031 L 42 20 L 24 20 L 24 28 L 35.304688 28 C 34.511719 30.238281 33.070313 32.164063 31.214844 33.570313 C 31.21875 33.570313 31.21875 33.570313 31.21875 33.570313 L 37.410156 38.808594 C 36.972656 39.203125 44 34 44 24 C 44 22.660156 43.863281 21.351563 43.609375 20.082031 Z "}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"wordmark-google","viewBox":"0 0 98.1 30.8"}},[_c('path',{staticClass:"wordmark-google",attrs:{"id":"XMLID_10_","d":"M12.3,11v3.3h7.9c-0.2,1.9-0.9,3.2-1.8,4.2c-1.2,1.2-3,2.4-6.1,2.4c-4.9,0-8.7-3.9-8.7-8.8\n\t\t\ts3.8-8.8,8.7-8.8c2.6,0,4.5,1,5.9,2.4l2.3-2.3c-2-1.9-4.6-3.4-8.3-3.4C5.6,0,0,5.4,0,12.1s5.6,12.1,12.3,12.1\n\t\t\tc3.6,0,6.3-1.2,8.4-3.4c2.2-2.2,2.9-5.2,2.9-7.7c0-0.8-0.1-1.5-0.2-2.1H12.3z"}}),_vm._v(" "),_c('path',{staticClass:"wordmark-google",attrs:{"id":"XMLID_24_","d":"M33.4,8.3c-4.3,0-7.8,3.3-7.8,7.8c0,4.5,3.5,7.8,7.8,7.8s7.8-3.3,7.8-7.8\n\t\t\tC41.2,11.6,37.7,8.3,33.4,8.3z M33.4,20.8c-2.4,0-4.4-1.9-4.4-4.7c0-2.8,2-4.7,4.4-4.7s4.4,1.9,4.4,4.7\n\t\t\tC37.8,18.9,35.8,20.8,33.4,20.8z"}}),_vm._v(" "),_c('path',{staticClass:"wordmark-google",attrs:{"id":"XMLID_21_","d":"M71.7,10.1h-0.1c-0.8-0.9-2.2-1.7-4.1-1.7c-3.9,0-7.3,3.4-7.3,7.8c0,4.4,3.4,7.8,7.3,7.8\n\t\t\tc1.9,0,3.3-0.8,4.1-1.8h0.1v1.1c0,3-1.6,4.6-4.2,4.6c-2.1,0-3.4-1.5-3.9-2.8l-3,1.2c0.9,2.1,3.1,4.6,6.9,4.6c4,0,7.4-2.4,7.4-8.1\n\t\t\tv-14h-3.2V10.1z M67.8,20.8c-2.4,0-4.2-2-4.2-4.7c0-2.8,1.8-4.7,4.2-4.7c2.3,0,4.2,2,4.2,4.8C72,18.9,70.2,20.8,67.8,20.8z"}}),_vm._v(" "),_c('path',{staticClass:"wordmark-google",attrs:{"id":"XMLID_18_","d":"M50.8,8.3c-4.3,0-7.8,3.3-7.8,7.8c0,4.5,3.5,7.8,7.8,7.8s7.8-3.3,7.8-7.8\n\t\t\tC58.7,11.6,55.1,8.3,50.8,8.3z M50.8,20.8c-2.4,0-4.4-1.9-4.4-4.7c0-2.8,2-4.7,4.4-4.7s4.4,1.9,4.4,4.7\n\t\t\tC55.2,18.9,53.2,20.8,50.8,20.8z"}}),_vm._v(" "),_c('path',{staticClass:"wordmark-google",attrs:{"id":"XMLID_3_","d":"M77.7,0.3H81v23.6h-3.4V0.3z"}}),_vm._v(" "),_c('path',{staticClass:"wordmark-google",attrs:{"id":"XMLID_14_","d":"M91.4,20.8c-1.7,0-3-0.8-3.8-2.4l10.4-4.3l-0.3-0.9c-0.6-1.7-2.6-5-6.7-5\n\t\t\tc-4,0-7.4,3.2-7.4,7.8c0,4.4,3.3,7.8,7.7,7.8c3.6,0,5.6-2.2,6.5-3.4l-2.7-1.8C94.4,20,93.2,20.8,91.4,20.8L91.4,20.8z M91.2,11.2\n\t\t\tc1.4,0,2.6,0.7,3,1.7l-7,2.9C87.1,12.6,89.4,11.2,91.2,11.2z"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-steam","viewBox":"0 0 99.1 100"}},[_c('path',{staticClass:"white",attrs:{"d":"M49.5,0C23.5,0,2.2,20.3,0.1,46l26.6,11.1c2.2-1.6,5-2.5,7.9-2.5c0.3,0,0.5,0,0.8,0l11.8-17.3c0-0.1,0-0.2,0-0.2\n\t\tc0-10.4,8.4-18.9,18.7-18.9c10.3,0,18.7,8.5,18.7,18.9c0,10.4-8.4,18.9-18.7,18.9c-0.1,0-0.3,0-0.4,0L48.6,68.1c0,0.2,0,0.4,0,0.7\n\t\tc0,7.8-6.3,14.2-14,14.2c-6.8,0-12.5-4.9-13.8-11.4l-19-7.9c5.9,21,25,36.4,47.7,36.4c27.4,0,49.5-22.4,49.5-50\n\t\tC99.1,22.4,76.9,0,49.5,0"}}),_vm._v(" "),_c('path',{staticClass:"white",attrs:{"d":"M31.2,75.9l-6.1-2.5c1.1,2.3,2.9,4.2,5.4,5.2c5.4,2.3,11.5-0.3,13.8-5.7c1.1-2.6,1.1-5.5,0-8.1c-1.1-2.6-3.1-4.7-5.7-5.8\n\t\tc-2.6-1.1-5.3-1-7.8-0.1l6.3,2.6c4,1.7,5.8,6.2,4.2,10.2C39.7,75.6,35.1,77.5,31.2,75.9"}}),_vm._v(" "),_c('path',{staticClass:"white",attrs:{"d":"M56.5,37.1c0-5.2,4.2-9.4,9.4-9.4c5.2,0,9.4,4.2,9.4,9.4c0,5.2-4.2,9.4-9.4,9.4C60.7,46.5,56.5,42.3,56.5,37.1 M78.3,37.1\n\t\tc0-6.9-5.6-12.6-12.5-12.6c-6.9,0-12.5,5.6-12.5,12.6c0,6.9,5.6,12.6,12.5,12.6C72.7,49.7,78.3,44,78.3,37.1"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-steam-gray","viewBox":"0 0 99.1 100"}},[_c('path',{staticClass:"steam-gray",attrs:{"d":"M49.5,0C23.5,0,2.2,20.3,0.1,46l26.6,11.1c2.2-1.6,5-2.5,7.9-2.5c0.3,0,0.5,0,0.8,0l11.8-17.3c0-0.1,0-0.2,0-0.2\n\t\tc0-10.4,8.4-18.9,18.7-18.9c10.3,0,18.7,8.5,18.7,18.9c0,10.4-8.4,18.9-18.7,18.9c-0.1,0-0.3,0-0.4,0L48.6,68.1c0,0.2,0,0.4,0,0.7\n\t\tc0,7.8-6.3,14.2-14,14.2c-6.8,0-12.5-4.9-13.8-11.4l-19-7.9c5.9,21,25,36.4,47.7,36.4c27.4,0,49.5-22.4,49.5-50\n\t\tC99.1,22.4,76.9,0,49.5,0"}}),_vm._v(" "),_c('path',{staticClass:"steam-gray",attrs:{"d":"M31.2,75.9l-6.1-2.5c1.1,2.3,2.9,4.2,5.4,5.2c5.4,2.3,11.5-0.3,13.8-5.7c1.1-2.6,1.1-5.5,0-8.1c-1.1-2.6-3.1-4.7-5.7-5.8\n\t\tc-2.6-1.1-5.3-1-7.8-0.1l6.3,2.6c4,1.7,5.8,6.2,4.2,10.2C39.7,75.6,35.1,77.5,31.2,75.9"}}),_vm._v(" "),_c('path',{staticClass:"steam-gray",attrs:{"d":"M56.5,37.1c0-5.2,4.2-9.4,9.4-9.4c5.2,0,9.4,4.2,9.4,9.4c0,5.2-4.2,9.4-9.4,9.4C60.7,46.5,56.5,42.3,56.5,37.1 M78.3,37.1\n\t\tc0-6.9-5.6-12.6-12.5-12.6c-6.9,0-12.5,5.6-12.5,12.6c0,6.9,5.6,12.6,12.5,12.6C72.7,49.7,78.3,44,78.3,37.1"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"wordmark-steam","viewBox":"0 0 100 19.1"}},[_c('path',{staticClass:"white",attrs:{"d":"M13.1,1.8l-1.6,2.9c-1.3-0.9-3-1.4-4.4-1.4c-1.7,0-2.7,0.7-2.7,2c0,1.5,1.9,1.9,4.6,2.9c3,1.1,4.7,2.3,4.7,5.1\n\t\tc0,3.8-2.9,5.9-7.2,5.9c-2.1,0-4.5-0.5-6.5-1.7l1.2-3.2c1.6,0.8,3.4,1.3,5.1,1.3c2.2,0,3.3-0.8,3.3-2.1c0-1.4-1.6-1.8-4.2-2.7\n\t\tc-3-1-5-2.3-5-5.4C0.3,2,3,0,6.9,0C9.7,0,11.9,0.9,13.1,1.8"}}),_vm._v(" "),_c('polygon',{staticClass:"white",attrs:{"points":"25.9,3.6 25.9,18.8 22,18.8 22,3.6 16.4,3.6 16.4,0.3 31.4,0.3 31.4,3.6 \t\t"}}),_vm._v(" "),_c('polygon',{staticClass:"white",attrs:{"points":"39.5,3.6 39.5,7.8 46.9,7.8 46.9,11.1 39.5,11.1 39.5,15.5 48,15.5 48,18.8 35.7,18.8 35.7,0.3 48,0.3 48,3.6\n\t\t"}}),_vm._v(" "),_c('path',{staticClass:"white",attrs:{"d":"M60.2,4.7l-2.5,7.4h5.1L60.2,4.7z M56.6,15.2l-1.2,3.6h-4l6.9-18.5h3.9l7.1,18.5H65l-1.2-3.6H56.6z"}}),_vm._v(" "),_c('polygon',{staticClass:"white",attrs:{"points":"88.9,7.5 83.9,18.3 81.7,18.3 76.8,7.6 76.8,18.8 73.1,18.8 73.1,0.3 76.8,0.3 82.9,13.7 88.9,0.3 92.6,0.3\n\t\t92.6,18.8 88.9,18.8 \t\t"}}),_vm._v(" "),_c('g',[_c('path',{staticClass:"white",attrs:{"d":"M97.5,0.5c-1.2,0-2.1,0.8-2.1,2.2c0,1.3,0.9,2.2,2.1,2.2c1.2,0,2.1-0.8,2.1-2.2C99.6,1.3,98.6,0.5,97.5,0.5z\n\t\t\t M98,3.9l-0.5-1H97v1h-0.4V1.3h0.9c0.7,0,0.9,0.4,0.9,0.7c0,0.3-0.2,0.6-0.5,0.7l0.6,1.1H98z"}}),_vm._v(" "),_c('path',{staticClass:"white",attrs:{"d":"M97.5,0.1c-1.4,0-2.5,1-2.5,2.6c0,1.6,1.2,2.6,2.5,2.6c1.4,0,2.5-1,2.5-2.6C100,1.1,98.8,0.1,97.5,0.1z\n\t\t\t M97.5,4.8c-1.2,0-2.1-0.8-2.1-2.2c0-1.3,1-2.2,2.1-2.2c1.2,0,2.1,0.8,2.1,2.2C99.6,4,98.6,4.8,97.5,4.8z"}}),_vm._v(" "),_c('path',{staticClass:"white",attrs:{"d":"M98.4,2.1c0-0.4-0.2-0.7-0.9-0.7h-0.9v2.5H97v-1h0.5l0.5,1h0.5l-0.6-1.1C98.2,2.6,98.4,2.4,98.4,2.1z\n\t\t\t M97.5,2.5H97V1.7h0.4c0.3,0,0.5,0.2,0.5,0.4C97.9,2.3,97.8,2.5,97.5,2.5z"}})])]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-psn","viewBox":"0 0 100 80.1"}},[_c('path',{staticClass:"white",attrs:{"d":"M37.4,0v71.7l16.2,5.1V16.7c0-2.8,1.3-4.7,3.3-4c2.6,0.7,3.2,3.3,3.2,6.1v24c10.1,4.9,18.1,0,18.1-12.9\n\t\t\tc0-13.2-4.7-19.1-18.4-23.8C54.4,4.3,44.3,1.3,37.4,0"}}),_vm._v(" "),_c('path',{staticClass:"white",attrs:{"d":"M56.7,66.4l26.1-9.3c3-1.1,3.4-2.6,1-3.4c-2.4-0.8-6.8-0.6-9.7,0.5l-17.4,6.1v-9.8l1-0.3c0,0,5-1.8,12.1-2.6\n\t\t\tc7.1-0.8,15.7,0.1,22.5,2.7c7.6,2.4,8.5,6,6.6,8.4C97,61.3,92.2,63,92.2,63L56.7,75.8V66.4z"}}),_vm._v(" "),_c('path',{staticClass:"white",attrs:{"d":"M7.7,65.4c-7.9-2.2-9.2-6.8-5.6-9.5c3.3-2.5,8.9-4.3,8.9-4.3l23.3-8.3v9.4l-16.7,6c-3,1.1-3.4,2.6-1,3.4\n\t\t\tc2.4,0.8,6.8,0.6,9.7-0.5l8-2.9v8.4c-0.5,0.1-1.1,0.2-1.6,0.3C24.7,68.7,16.1,68.2,7.7,65.4"}}),_vm._v(" "),_c('path',{staticClass:"white",attrs:{"d":"M95.1,80.1c1.3,0,2.5-0.5,3.4-1.4c0.9-0.9,1.4-2.1,1.4-3.4c0-1.3-0.5-2.5-1.4-3.4c-0.9-0.9-2.1-1.4-3.4-1.4\n\t\t\tc-2.6,0-4.8,2.1-4.8,4.8c0,1.3,0.5,2.5,1.4,3.4C92.6,79.6,93.8,80.1,95.1,80.1 M91.1,75.3c0-1.1,0.4-2.1,1.2-2.8\n\t\t\tc0.7-0.7,1.7-1.2,2.8-1.2c1.1,0,2.1,0.4,2.8,1.2c0.8,0.7,1.2,1.7,1.2,2.8c0,2.2-1.8,4-4,4c-1.1,0-2.1-0.4-2.8-1.2\n\t\t\tC91.6,77.4,91.1,76.4,91.1,75.3"}}),_vm._v(" "),_c('path',{staticClass:"white",attrs:{"d":"M97.5,77.5l-0.2-0.2l0-0.4l0-0.7c0-0.3-0.1-0.6-0.2-0.7l-0.3-0.3l0.4-0.4c0.1-0.2,0.2-0.5,0.2-0.8c0-0.6-0.3-1.1-0.8-1.3\n\t\t\tc-0.3-0.1-0.6-0.2-1-0.2h-2.4h-0.1v0.1v5.1v0.1h0.1h0.7H94v-0.1v-2.1h1.5l0.6,0.1l0.3,0.6l0,0.9l0,0.4l0.1,0.2l0,0.1h0.1h0.8h0.1\n\t\t\tv-0.1v-0.1L97.5,77.5L97.5,77.5z M96.4,74.1l-0.2,0.6l-0.7,0.2H94v-1.5h1.6l0.5,0.1C96.3,73.6,96.4,73.8,96.4,74.1"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"wordmark-psn","viewBox":"0 0 100 19.8"}},[_c('path',{staticClass:"white",attrs:{"d":"M98.9,14.4c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8c0-0.3-0.1-0.6-0.3-0.8c-0.2-0.2-0.5-0.3-0.8-0.3\n\t\t\tc-0.6,0-1.1,0.5-1.1,1.1c0,0.3,0.1,0.6,0.3,0.8C98.3,14.3,98.6,14.4,98.9,14.4 M97.9,13.3c0-0.3,0.1-0.5,0.3-0.7\n\t\t\tc0.2-0.2,0.4-0.3,0.7-0.3c0.3,0,0.5,0.1,0.7,0.3c0.2,0.2,0.3,0.4,0.3,0.7c0,0.5-0.4,0.9-0.9,0.9c-0.3,0-0.5-0.1-0.7-0.3\n\t\t\tC98,13.8,97.9,13.6,97.9,13.3"}}),_vm._v(" "),_c('path',{staticClass:"white",attrs:{"d":"M99.4,13.8L99.4,13.8l0-0.2l0-0.2c0-0.1,0-0.1,0-0.2l-0.1-0.1l0.1-0.1c0-0.1,0-0.1,0-0.2c0-0.1-0.1-0.3-0.2-0.3\n\t\t\tc-0.1,0-0.1,0-0.2,0h-0.6h0v0v1.2v0h0h0.2h0v0v-0.5h0.3l0.1,0c0,0,0.1,0.1,0.1,0.1l0,0.2l0,0.1l0,0l0,0h0L99.4,13.8L99.4,13.8\n\t\t\tL99.4,13.8L99.4,13.8L99.4,13.8L99.4,13.8z M99.2,13c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0-0.2,0h-0.4v-0.4H99l0.1,0\n\t\t\tC99.1,12.9,99.2,12.9,99.2,13"}}),_vm._v(" "),_c('path',{staticClass:"white",attrs:{"d":"M6.2,0L0,0l0,0v14.4l0,0h2.5l0,0V1.6l0,0l2.8,0c1,0,1.6,1,1.6,2.9c0,1.9-0.6,2.9-1.6,2.9l-1.7,0l0,0V9l0,0h2.5\n\t\t\tC7,9,7.9,8.6,8.5,7.9c0.7-0.8,1.1-2,1.1-3.4C9.6,1.8,8.3,0,6.2,0"}}),_vm._v(" "),_c('polygon',{staticClass:"white",attrs:{"points":"13.7,0 11.2,0 11.2,0 11.2,14.4 11.2,14.4 13.7,14.4 13.7,14.4 13.7,0 \t\t\t"}}),_vm._v(" "),_c('path',{staticClass:"white",attrs:{"d":"M24.6,3.5L24.6,3.5l-4.5,0c-4,0-4.5,2.9-4.5,5.5l0,2.2c0,1.9,1.2,3.3,2.8,3.3h2.4l0,0v-1.5l0,0h-1.7\n\t\t\tc-0.4,0-0.9-0.2-0.9-1.5V8.9c0-1.6,0.2-2.6,0.5-3.2C19,5.1,19.6,5,20.1,5L22,5l0,0v9.4l0,0h2.5l0,0V3.5L24.6,3.5z"}}),_vm._v(" "),_c('path',{staticClass:"white",attrs:{"d":"M42.5,6l-1.2-0.1c-0.9-0.1-1.6-0.6-1.6-2.1c0-1.8,0.8-2.2,1.8-2.2h3.4l0,0V0l0,0h-0.1h0h-3.7c-2.3,0-4,1.4-4,4.1v0.1\n\t\t\tc0,2.1,1.3,3.7,3.3,3.8l1.2,0.1c0.9,0.1,1.5,0.9,1.5,2.2v0.4c0,0.8-0.2,2.2-1.9,2.2h-3.5h-0.1l0,0v1.5l0,0h4.4\n\t\t\tc1.4,0,3.6-0.5,3.6-4.2c0-1.3-0.3-2.4-0.9-3.1C44.3,6.4,43.5,6.1,42.5,6"}}),_vm._v(" "),_c('path',{staticClass:"white",attrs:{"d":"M62.9,3.5L62.9,3.5l-4.5,0c-4,0-4.5,2.9-4.5,5.5v2.2c0,1.9,1.2,3.3,2.8,3.3h2.4l0,0v-1.5l0,0h-1.7\n\t\t\tc-0.4,0-0.9-0.2-0.9-1.5V8.9c0-1.6,0.1-2.6,0.5-3.2C57.3,5.1,57.9,5,58.4,5l1.9,0l0,0l0,9.4l0,0h2.5l0,0L62.9,3.5z"}}),_vm._v(" "),_c('path',{staticClass:"white",attrs:{"d":"M52.9,3.4h-2.7l0,0v0V1.6l0,0h-2.5l0,0v9.5c0,1.9,1.2,3.3,2.8,3.3h1.8l0,0v-1.5l0,0h-1.1c-0.3,0-0.9,0-0.9-1.4V5l0,0\n\t\t\tc0.8,0,2.7,0,2.7,0l0,0L52.9,3.4L52.9,3.4z"}}),_vm._v(" "),_c('path',{staticClass:"white",attrs:{"d":"M70.2,3.4h-2.7l0,0v0V1.6l0,0H65l0,0v9.5c0,1.9,1.2,3.3,2.8,3.3h1.8l0,0v-1.5l0,0h-1.1c-0.3,0-0.9,0-0.9-1.4V5l0,0\n\t\t\tc0.8,0,2.7,0,2.7,0l0,0L70.2,3.4L70.2,3.4z"}}),_vm._v(" "),_c('polygon',{staticClass:"white",attrs:{"points":"74.3,3.4 71.9,3.4 71.8,3.5 71.8,14.4 71.9,14.4 74.3,14.4 74.4,14.4 74.4,3.5 \t\t\t"}}),_vm._v(" "),_c('polygon',{staticClass:"white",attrs:{"points":"74.3,0 71.9,0 71.8,0 71.8,2.1 71.9,2.2 74.3,2.2 74.4,2.1 74.4,0 \t\t\t"}}),_vm._v(" "),_c('path',{staticClass:"white",attrs:{"d":"M91.6,3.4h-4.4l0,0l0,10.9l0,0h2.5l0,0l0-9.4l0,0l1.9,0c0.5,0,1.1,0.1,1.4,0.7c0.3,0.5,0.5,1.5,0.5,3c0,0.1,0,5.8,0,5.8\n\t\t\tl0,0H96l0,0V8.9C96,6.4,95.5,3.4,91.6,3.4"}}),_vm._v(" "),_c('path',{staticClass:"white",attrs:{"d":"M80.7,3.4C76.6,3.4,76,6.4,76,9c0,2.6,0.5,5.5,4.7,5.5c4.2,0,4.7-2.9,4.7-5.5C85.4,6.4,84.9,3.4,80.7,3.4 M82.3,12.1\n\t\t\tc-0.4,0.6-1,0.7-1.6,0.7c-0.6,0-1.2-0.1-1.6-0.7c-0.4-0.6-0.5-1.6-0.5-3.2v0c0-1.9,0.2-3,0.8-3.5C79.7,5.2,80.1,5,80.7,5\n\t\t\tc0.6,0,1,0.1,1.3,0.4C82.6,6,82.8,7,82.8,9C82.8,10.6,82.7,11.6,82.3,12.1"}}),_vm._v(" "),_c('polygon',{staticClass:"white",attrs:{"points":"26,3.4 25.9,3.5 29.6,14.3 29.6,14.4 27.5,19.7 27.6,19.8 29.7,19.8 29.8,19.7 36.3,3.5 36.2,3.4 33.9,3.4\n\t\t\t33.8,3.5 31.1,10.6 31,10.6 28.6,3.5 28.6,3.4 \t\t\t"}})]),_vm._v(" "),_c('symbol',{staticClass:"white",attrs:{"id":"icon-eye-open","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12.015 7c4.751 0 8.063 3.012 9.504 4.636-1.401 1.837-4.713 5.364-9.504 5.364-4.42 0-7.93-3.536-9.478-5.407 1.493-1.647 4.817-4.593 9.478-4.593zm0-2c-7.569 0-12.015 6.551-12.015 6.551s4.835 7.449 12.015 7.449c7.733 0 11.985-7.449 11.985-7.449s-4.291-6.551-11.985-6.551zm-.015 3c-2.209 0-4 1.792-4 4 0 2.209 1.791 4 4 4s4-1.791 4-4c0-2.208-1.791-4-4-4z"}})]),_vm._v(" "),_c('symbol',{staticClass:"white",attrs:{"id":"icon-eye-close","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M19.604 2.562l-3.346 3.137c-1.27-.428-2.686-.699-4.243-.699-7.569 0-12.015 6.551-12.015 6.551s1.928 2.951 5.146 5.138l-2.911 2.909 1.414 1.414 17.37-17.035-1.415-1.415zm-6.016 5.779c-3.288-1.453-6.681 1.908-5.265 5.206l-1.726 1.707c-1.814-1.16-3.225-2.65-4.06-3.66 1.493-1.648 4.817-4.594 9.478-4.594.927 0 1.796.119 2.61.315l-1.037 1.026zm-2.883 7.431l5.09-4.993c1.017 3.111-2.003 6.067-5.09 4.993zm13.295-4.221s-4.252 7.449-11.985 7.449c-1.379 0-2.662-.291-3.851-.737l1.614-1.583c.715.193 1.458.32 2.237.32 4.791 0 8.104-3.527 9.504-5.364-.729-.822-1.956-1.99-3.587-2.952l1.489-1.46c2.982 1.9 4.579 4.327 4.579 4.327z"}})]),_vm._v(" "),_c('symbol',{staticClass:"white",attrs:{"id":"icon-external-link","viewBox":"0 0 48 48"}},[_c('path',{staticClass:"st0",attrs:{"d":"M38,34.1c0,2.2-1.8,4-4,4H14c-2.2,0-4-1.8-4-4v-20c0-2.2,1.8-4,4-4h4v-4h-8c-2.2,0-4,1.8-4,4v28c0,2.2,1.8,4,4,4h28c2.2,0,4-1.8,4-4v-8h-4V34.1z M40.6,6.2C40.2,6,39.8,6,39.3,6.1H28c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2h6.7L22.6,22.2c-0.9,0.9-0.9,2.3,0,3.1c0.9,0.9,2.3,0.9,3.1,0L38,13v7c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2v-12C42,7.2,41.4,6.4,40.6,6.2z"}})]),_vm._v(" "),_c('symbol',{staticClass:"black",attrs:{"id":"icon-external-link-hover","viewBox":"0 0 48 48"}},[_c('path',{staticClass:"st0",attrs:{"d":"M38,34.1c0,2.2-1.8,4-4,4H14c-2.2,0-4-1.8-4-4v-20c0-2.2,1.8-4,4-4h4v-4h-8c-2.2,0-4,1.8-4,4v28c0,2.2,1.8,4,4,4h28c2.2,0,4-1.8,4-4v-8h-4V34.1z M40.6,6.2C40.2,6,39.8,6,39.3,6.1H28c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2h6.7L22.6,22.2c-0.9,0.9-0.9,2.3,0,3.1c0.9,0.9,2.3,0.9,3.1,0L38,13v7c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2v-12C42,7.2,41.4,6.4,40.6,6.2z"}})]),_vm._v(" "),_c('symbol',{staticClass:"black",attrs:{"id":"icon-ellipsis","viewBox":"0 0 40 40"}},[_c('circle',{staticClass:"ellipsis",attrs:{"cx":"13","cy":"20","r":"1.5"}}),_vm._v(" "),_c('circle',{staticClass:"ellipsis",attrs:{"cx":"20","cy":"20","r":"1.5"}}),_vm._v(" "),_c('circle',{staticClass:"ellipsis",attrs:{"cx":"27","cy":"20","r":"1.5"}})]),_vm._v(" "),_c('symbol',{staticClass:"black",attrs:{"id":"icon-ellipsis-active","viewBox":"0 0 40 40"}},[_c('circle',{staticClass:"ellipsis-active",attrs:{"cx":"20","cy":"13","r":"1.5"}}),_vm._v(" "),_c('circle',{staticClass:"ellipsis-active",attrs:{"cx":"20","cy":"20","r":"1.5"}}),_vm._v(" "),_c('circle',{staticClass:"ellipsis-active",attrs:{"cx":"20","cy":"27","r":"1.5"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-email-query","viewBox":"0 0 62 58"}},[_c('image',{attrs:{"id":"icon_email","width":"71","height":"67","xlink:href":"data:img/png;base64,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"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-psn-dark","viewBox":"0 0 48 48"}},[_c('path',{staticClass:"icon-btn",attrs:{"d":"M24,6C14.1,6,6,14.1,6,24s8.1,18,18,18s18-8.1,18-18S33.9,6,24,6z M20.5,30.2c0,0.1,0,0.2,0,0.3\n\t\t\t\tc-0.7,0.1-1.3,0.2-2,0.2c-1.4,0-2.7-0.2-4-0.6c-0.4-0.1-0.8-0.3-1.2-0.6c-0.2-0.1-0.4-0.3-0.5-0.6c-0.1-0.2-0.1-0.4,0-0.6\n\t\t\t\tc0.1-0.2,0.2-0.3,0.4-0.5c0.4-0.3,0.8-0.5,1.3-0.7c0.4-0.2,0.8-0.3,1.2-0.4c1.6-0.6,3.2-1.1,4.8-1.7c0,0.6,0,1.3,0,1.9\n\t\t\t\tc0,0.1,0,0.2,0,0.3c-1.3,0.5-2.5,0.9-3.8,1.4c-0.2,0.1-0.4,0.1-0.5,0.3c-0.1,0.1-0.1,0.2-0.1,0.2c0,0.1,0.2,0.2,0.3,0.2\n\t\t\t\tc0.3,0.1,0.6,0.1,0.9,0.1c0.3,0,0.7,0,1-0.1c0.2,0,0.4-0.1,0.6-0.2c0.5-0.2,1.1-0.4,1.6-0.6C20.5,29.1,20.5,29.6,20.5,30.2z\n\t \t\t\tM25,18.3c-0.2,0.2-0.2,0.5-0.2,0.7c0,4.5,0,9.1,0,13.6c-1.2-0.4-2.4-0.8-3.7-1.2c0-5.4,0-10.8,0-16.2c1,0.2,1.9,0.4,2.9,0.7\n\t\t\t\tc0.5,0.2,1.1,0.3,1.6,0.5c0.9,0.3,1.7,0.6,2.5,1c0.3,0.2,0.7,0.4,1,0.7c0.3,0.3,0.6,0.7,0.7,1c0.3,0.7,0.4,1.5,0.5,2.3\n\t\t\t\tc0,0.5,0,1-0.1,1.5c-0.1,0.4-0.2,0.9-0.5,1.2c-0.2,0.3-0.5,0.6-0.8,0.8c-0.3,0.2-0.7,0.3-1.1,0.3c-0.6,0-1.1-0.2-1.6-0.4\n\t\t\t\tc0-1.7,0-3.4,0-5.1c0-0.3,0-0.6,0-0.9c0-0.2-0.1-0.5-0.3-0.6c-0.1-0.1-0.3-0.2-0.4-0.2C25.3,18.1,25.1,18.2,25,18.3z M35,28.6\n\t\t\t\tc-0.3,0.3-0.6,0.5-1,0.7c-0.4,0.2-0.8,0.3-1.2,0.5c-2.4,0.9-4.9,1.8-7.3,2.6c0-0.7,0-1.4,0-2.1c0,0,0-0.1,0-0.1\n\t\t\t\tc1.9-0.7,3.7-1.3,5.6-2c0.2-0.1,0.5-0.2,0.7-0.3c0.1-0.1,0.2-0.2,0.1-0.3c0-0.1-0.1-0.2-0.2-0.2c-0.3-0.1-0.6-0.1-0.9-0.1\n\t\t\t\tc-0.5,0-0.9,0.1-1.4,0.2c-1.3,0.5-2.6,0.9-4,1.4c0-0.7,0-1.5,0-2.2c1-0.3,2-0.5,3-0.7c0.4,0,0.7,0,1.1-0.1c1.2,0,2.4,0.2,3.5,0.5\n\t\t\t\tc0.2,0.1,0.4,0.2,0.7,0.2c0.4,0.1,0.8,0.3,1.1,0.6c0.2,0.2,0.4,0.4,0.4,0.7C35.3,28.3,35.2,28.5,35,28.6z"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-steam-dark","viewBox":"0 0 48 48"}},[_c('path',{staticClass:"icon-btn",attrs:{"d":"M42.1,24c0,9.9-8.1,18-18.1,18c-8.7,0-16-6.1-17.7-14.3l7.2,3c0.4,2.2,2.4,3.8,4.7,3.8\n\t\t\t\tc2.6,0,4.7-2.1,4.7-4.7c0,0,0,0,0,0l5.4-4c3.5,0,6.2-2.7,6.2-6.1c0-3.4-2.8-6.1-6.2-6.1c-3.4,0-6.1,2.7-6.2,6l-4,5.5\n\t\t\t\tc-1,0-1.9,0.3-2.7,0.8l-9.5-4C7.1,12.9,14.7,6,24,6C34,6,42.1,14,42.1,24z M17.1,32.2l-2.3-1c0.6,1.3,1.9,2.2,3.4,2.2\n\t\t\t\tc2,0,3.6-1.7,3.6-3.7c0-2-1.7-3.6-3.7-3.6c-0.4,0-0.9,0.1-1.3,0.2l2.3,1c1.4,0.6,2,2.1,1.4,3.5C20,32.1,18.4,32.7,17.1,32.2z\n \t\t\t\tM28.4,23.8c-2.3,0-4.2-1.9-4.2-4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2C32.6,21.9,30.7,23.8,28.4,23.8z M28.4,22.8\n\t\t\t\tc1.7,0,3.2-1.4,3.2-3.2c0-1.7-1.4-3.2-3.2-3.2c-1.7,0-3.2,1.4-3.2,3.2C25.2,21.3,26.6,22.8,28.4,22.8z"}})]),_vm._v(" "),_c('symbol',{attrs:{"id":"icon-xbox-dark","viewBox":"0 0 48 48"}},[_c('path',{staticClass:"icon-btn",attrs:{"d":"M14,9.1C14,9.1,14,9.1,14,9.1c0-0.1,0.2-0.2,0.3-0.2C17.1,7,20.4,6,24,6c3.4,0,6.5,0.9,9.2,2.6\n\t\t\t\tc0.2,0.1,0.7,0.5,1,0.8C31.6,6.5,24,12.7,24,12.7c-2.7-2-5.1-3.4-6.9-3.9C15.6,8.3,14.5,8.7,14,9.1L14,9.1z M37.2,11.8\n\t\t\t\tc-0.1-0.1-0.2-0.2-0.3-0.3c-0.7-0.7-1.5-0.9-2.2-0.9c-0.7,0.2-3.7,1.3-7.5,4.9c0,0,4.3,4.1,6.9,8.4c2.6,4.2,4.2,7.6,3.2,12.2\n\t\t\t\tC40.2,32.9,42,28.7,42,24C42,19.3,40.2,15,37.2,11.8L37.2,11.8z M30.7,25.7c-1.2-1.3-2.9-3.2-5.2-5.4c-0.5-0.5-1-1-1.6-1.5\n\t\t\t\tc0,0-0.8,0.8-1.9,1.9c-1.4,1.4-3.2,3.2-4.2,4.3c-1.8,1.9-6.8,7.8-7.1,11.2c0,0-1.1-2.6,1.4-8.7c1.6-4,6.5-10,8.6-11.9\n\t\t\t\tc0,0-1.9-2.1-4.2-3.5l0,0c0,0,0,0-0.1,0c-1.1-0.7-2.4-1.2-3.5-1.3c-1.2,0.1-2,1-2,1C7.8,14.9,6,19.2,6,24c0,9.9,8.1,18,18,18\n\t\t\t\tc5.3,0,10-2.3,13.3-5.9c0,0-0.4-2.4-2.8-5.8C34,29.5,31.9,27,30.7,25.7L30.7,25.7z M30.7,25.7"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_icon_sprite = (esExports);
// CONCATENATED MODULE: ./node_modules/@arena/toolkit/src/components/common/icon-sprite.vue
function injectStyle (ssrContext) {
  __webpack_require__("QEZO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06156d44"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  icon_sprite,
  common_icon_sprite,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var components_common_icon_sprite = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "FUzw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _apiHost = __webpack_require__("z42y");

var _apiHost2 = _interopRequireDefault(_apiHost);

var _router = __webpack_require__("YaEn");

var _router2 = _interopRequireDefault(_router);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.$accountAPI = _axios2.default.create({
	baseURL: environment.webApi,
	withCredentials: true
});

var globalApi = _axios2.default.create({
	baseURL: _apiHost2.default.globalApiHost
}),
    getCountryList = function () {
	var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
		var config, list;
		return _regenerator2.default.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return _axios2.default.get(environment.webApi + '/v2/configurations').then(function (res) {
							return res.data;
						});

					case 2:
						config = _context.sent;
						_context.next = 5;
						return globalApi.get('/country/v1/region-countries?membership_no=' + config.membership_no).then(function (res) {
							return res.data;
						}).catch(function () {
							return [];
						});

					case 5:
						list = _context.sent;
						return _context.abrupt('return', list);

					case 7:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, undefined);
	}));

	return function getCountryList() {
		return _ref.apply(this, arguments);
	};
}(),
    getCountryCode = function getCountryCode() {
	return globalApi.get('/geoip/v1/country').then(function (res) {
		return res.data;
	});
},
    pluginAPI = {
	install: function install(Vue) {
		Vue.prototype.$globalAPI = {
			getCountryList: getCountryList,
			getCountryCode: getCountryCode
		};

		window.$accountAPI.interceptors.response.use(function (response) {
			return response;
		}, function (error) {
			var errorCode = 'unknown';
			if (error.response && (0, _typeof3.default)(error.response.data) === 'object') {
				var errorData = error.response.data;
				console.error('api error: ' + error.config.method + ' - ' + error.config.url + ' => ' + error.response.data);
				// this is for login redirection due to login required action taken after page routing
				if (!_router2.default.history.pending && errorData.code === 'LOGIN_REQUIRED') {
					_router2.default.push({
						name: 'login',
						query: {
							return_url: document.URL
						},
						params: {
							locale: window.App.$i18n.locale
						}
					});
				}
				errorCode = errorData.code || errorData.status;
			} else if (error.message === 'Network Error') errorCode = 'NETWORK_ERROR';else if (error.code === 'ECONNABORTED') errorCode = 'TIMEOUT';

			return _promise2.default.reject(errorCode);
		});
		Vue.prototype.$accountAPI = window.$accountAPI;

		// currently, it is only for tracking each action point
		Vue.prototype.$grecaptchaV3 = function (action) {
			grecaptcha.ready(function () {
				grecaptcha.execute('6Lc60IgUAAAAAL3vtKNcWZc9B0DFAQaXKPcyxqsX', { action: action });
			});
		};
	}
};

exports.default = pluginAPI;

/***/ }),

/***/ "G+k6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@arena/toolkit/src/mixins/input-validation.js
var input_validation = __webpack_require__("sZPG");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@arena/toolkit/src/components/common/form-input.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var form_input = ({
	name: 'formInput',
	introduction: 'Vujs input form component',
	props: {
		value: {
			type: String,
			default: '',
			note: 'Form input value'
		},
		type: {
			type: String,
			default: 'text',
			note: 'Set input type'
		},
		id: {
			type: String,
			default: '',
			note: 'Set id'
		},
		name: {
			type: String,
			default: '',
			note: 'Attribute name'
		},
		labelText: {
			type: String,
			default: '',
			note: 'Label text'
		},
		placeholder: {
			type: String,
			default: '',
			note: 'Place holder text inside form'
		},
		minLength: {
			type: Number,
			default: 0,
			note: 'Set min of amount length'
		},
		maxLength: {
			type: Number,
			default: 350,
			note: 'Set max number of length'
		},
		disabled: {
			type: Boolean,
			default: false,
			note: 'Set disable when it needed'
		},
		enterHandler: {
			type: Function,
			note: 'Keyboard enter key handler'
		},
		inputRef: {
			type: String,
			default: '',
			note: 'Selector to choose specific element'
		},
		validator: {
			type: Function,
			default: null,
			note: 'Inline form validator'
		},
		submitted: {
			type: Boolean,
			default: false,
			note: 'Check submit state'
		},
		overrideErrorText: {
			type: String,
			default: null,
			note: 'Replace error Text'
		}
	},
	mixins: [input_validation["a" /* default */]],
	data: function data() {
		return {
			inlineErrorText: null,
			showError: null,
			internalValueCopy: ''
		};
	},

	computed: {
		pathName: function pathName() {
			return this.$route.name;
		},
		hasError: function hasError() {
			return this.showError && this.$store.state.inlineInput.errors[this.name];
		}
	},
	methods: {
		handleInput: function handleInput(event) {
			var value = event.target.value;
			this.internalValueCopy = value;
		},
		handleEnter: function handleEnter() {
			if (typeof this.enterHandler === 'function') {
				this.enterHandler();
			}
		},
		blur: function blur() {
			if (this.value.length > 0 && !this.validate()) {
				this.showError = true;
			}
		},
		keyup: function keyup() {
			if (this.showError) {
				this.showError = !this.validate();
			}
		},
		pushDatalayer: function pushDatalayer() {
			dataLayer.push({
				event: 'formFieldFocus',
				formName: this.pathName,
				fieldName: this.name
			});
		},
		validate: function validate() {
			if (this.validator) {
				return this.validator();
			}
			return this.validateForm();
		}
	},
	watch: {
		value: function value(modifiedVal) {
			this.internalValueCopy = modifiedVal;
		},
		internalValueCopy: function internalValueCopy(modifiedVal) {
			this.$emit('input', modifiedVal);
		},
		hasError: function hasError(modifiedVal) {
			this.$emit('validation-change', Boolean(modifiedVal));
		},
		overrideErrorText: function overrideErrorText(override) {
			if (override) {
				this.$store.commit('setInputValidationError', { field: this.id, msgs: 'error.input.' + override });
				this.inlineErrorText = this.overrideErrorText;
				this.showError = true;
			} else {
				this.$store.commit('clearValidationError', { field: this.id });
			}
		},
		submitted: function submitted() {
			// detect prop change
			this.showError = !this.validate();
		}
	},
	mounted: function mounted() {
		this.validate(this.id);
		this.internalValueCopy = this.value;
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3df1fec2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@arena/toolkit/src/components/common/form-input.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",class:{ 'has-error': _vm.hasError }},[(_vm.labelText !=='')?_c('label',{attrs:{"for":_vm.id}},[_vm._v(" "+_vm._s(_vm.labelText)+" ")]):_vm._e(),_vm._v(" "),_c('input',{ref:_vm.inputRef,staticClass:"form-control",class:{
			'disabled': _vm.disabled
		},attrs:{"id":_vm.id,"name":_vm.name,"placeholder":_vm.placeholder,"minlength":_vm.minLength,"maxlength":_vm.maxLength,"disabled":_vm.disabled,"type":_vm.type,"autocomplete":"off","spellcheck":"false","tabindex":"1"},domProps:{"value":_vm.value},on:{"input":_vm.handleInput,"blur":_vm.blur,"keyup":_vm.keyup,"focus":_vm.pushDatalayer,"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleEnter($event)},function($event){_vm.$emit('keydown', $event)}]}}),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasError),expression:"hasError"}],staticClass:"help-block",domProps:{"innerHTML":_vm._s(_vm.$t(_vm.inlineErrorText))}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_form_input = (esExports);
// CONCATENATED MODULE: ./node_modules/@arena/toolkit/src/components/common/form-input.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  form_input,
  common_form_input,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_common_form_input = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "G/83":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _iconSprite = __webpack_require__("FOgX");

var _iconSprite2 = _interopRequireDefault(_iconSprite);

var _iconSvg = __webpack_require__("EO4f");

var _iconSvg2 = _interopRequireDefault(_iconSvg);

var _clickOutside = __webpack_require__("dzPF");

var _clickOutside2 = _interopRequireDefault(_clickOutside);

var _configFooter = __webpack_require__("61ra");

var _configFooter2 = _interopRequireDefault(_configFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
	name: 'navFooter',
	components: {
		svgIcons: _iconSprite2.default,
		svgIcon: _iconSvg2.default
	},
	directives: {
		clickOutside: _clickOutside2.default
	},
	data: function data() {
		return {
			currentYear: new Date().getFullYear(),
			showLanguage: false,
			showGlobalLocale: false,
			footerTopLinks: [],
			footerBottomLinks: _configFooter2.default.footerBottomLinks,
			language: _configFooter2.default.languages,
			externalRegionLinks: _configFooter2.default.externalRegionLinks,
			regionHost: _configFooter2.default.externalRegionLinks,
			changeRegionUrl: null,
			moveFooterUp: false,
			showFooterBtn: window.innerWidth > 1024,
			checkPath: location.pathname.split('/')[1]
		};
	},

	computed: {
		classes: function classes() {
			return [this.region, this.currentLanguage];
		},
		region: function region() {
			return environment.region;
		},
		currentLanguage: function currentLanguage() {
			return this.$i18n.locale;
		}
	},
	methods: {
		close: function close() {
			this.showLanguage = false;
		},
		toggleGlobalLocale: function toggleGlobalLocale() {
			this.showGlobalLocale = !this.showGlobalLocale;
		},
		toggle: function toggle() {
			this.showLanguage = !this.showLanguage;
			this.showGlobalLocale = false;
		},
		select: function select() {
			this.toggle();
		},
		footerToogle: function footerToogle() {
			this.$root.$emit('moveUpToogle');
			this.moveFooterUp = !this.moveFooterUp;
		},
		handleResize: function handleResize() {
			this.showFooterBtn = window.innerWidth > 1024;
		},
		setLang: function setLang(lang) {
			this.$i18n.locale = lang;
		},
		changeLanguage: function changeLanguage(locale) {
			var pathnames = location.pathname.split('/');
			pathnames[2] = locale;

			this.$cookie.set('i18next', locale);
			if (typeof window.launcherData !== 'undefined') {
				// The following function is injected into window by the launcher
				window.launcherLanguageChange(localeLookup[lang]);
			}
			location.href = location.protocol + '//' + location.host + pathnames.join('/') + location.search;
		},
		changeRegion: function changeRegion(regionHost, locale) {
			var getUrl = window.location,
			    pathNameLast = getUrl.pathname.split('/')[3];

			if (getUrl.pathname.split('/')[1] === 'help') {
				this.changeRegionUrl = regionHost + '/main/' + locale;
			} else if (getUrl.pathname.split('/')[3] === undefined) {
				this.changeRegionUrl = regionHost + '/' + getUrl.pathname.split('/')[1] + '/' + locale + '/';
			} else {
				this.changeRegionUrl = regionHost + '/' + getUrl.pathname.split('/')[1] + '/' + locale + '/' + pathNameLast;
			}

			location.href = this.changeRegionUrl;
		},
		redirectToKR: function redirectToKR() {
			if (this.region === 'global') {
				this.$cookie.set('reDirectKR', this.externalRegionLinks.kr, { expires: '30D' });
			}
			window.open(this.externalRegionLinks.kr);
		},
		parseLinks: function parseLinks(linkDataList) {
			var _this = this;

			var findValueByPrefix = function findValueByPrefix(object, prefix) {
				var keys = (0, _keys2.default)(object),
				    key = keys.find(function (k) {
					return k.startsWith(prefix);
				});
				return object[key];
			};
			return linkDataList.map(function (singleLinkData) {
				return {
					name: findValueByPrefix(singleLinkData.titles, _this.$i18n.locale),
					url: findValueByPrefix(singleLinkData.urls, _this.$i18n.locale)
				};
			});
		}
	},
	created: function created() {
		var _this2 = this;

		window.addEventListener('resize', this.handleResize);
		var getUrl = window.location,
		    redirectKrUrl = this.$cookie.get('reDirectKR');

		this.setLang(getUrl.pathname.split('/')[2]);

		if (redirectKrUrl && this.region === 'global') {
			location.href = redirectKrUrl;
		}
		this.$cdnAPI.getFooter().then(function (data) {
			_this2.footerTopLinks = _this2.parseLinks(data);
		});
	},
	destroyed: function destroyed() {
		window.removeEventListener('resize', this.handleResize);
	},

	watch: {
		moveFooterUp: function moveFooterUp() {
			var _this3 = this;

			this.$root.$on('onFooterMoveUp', function (bool) {
				_this3.moveFooterUp = bool;
			});
		}
	}
};

/***/ }),

/***/ "G4pM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@arena/toolkit/src/components/common/form-checkbox.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var form_checkbox = ({
	name: 'formCheckbox',
	introduction: 'VueJs checkbox component',
	model: {
		prop: 'checked',
		event: 'change'
	},
	props: {
		id: {
			type: String,
			default: '',
			note: 'Assign id'
		},
		name: {
			type: String,
			default: '',
			note: 'Set attribute name'

		},
		labelText: {
			type: String,
			default: '',
			note: 'Checkbox label text'
		},
		disabled: {
			type: Boolean,
			default: false,
			note: 'Disabled state, default false'
		},
		hasError: {
			type: Boolean,
			default: false,
			note: 'Show error when it need'
		},
		inlineErrorText: {
			type: String,
			default: '',
			note: 'when hasError true, you can assign inline error text'
		},
		checked: {
			type: Boolean,
			default: false,
			note: 'Default fasle'
		}
	},
	data: function data() {
		return {
			checkedState: this.checked
		};
	},

	methods: {
		toggle: function toggle(event) {
			this.checkedState = !this.checkedState;
			this.$emit('change', this.checkedState);
			event.stopPropagation();
			event.preventDefault();
		}
	},
	watch: {
		checked: function checked(newValue) {
			this.checkedState = newValue;
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79677df9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@arena/toolkit/src/components/common/form-checkbox.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group custom-control custom-checkbox",class:{ 'has-error': _vm.hasError }},[_c('label',{staticClass:"checkbox",attrs:{"for":_vm.id},on:{"click":_vm.toggle}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.checkedState),expression:"checkedState"}],staticClass:"checkbox custom-control-input",class:{
				'disabled': _vm.disabled
			},attrs:{"type":"checkbox","id":_vm.id,"name":_vm.name,"disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.checkedState)?_vm._i(_vm.checkedState,null)>-1:(_vm.checkedState)},on:{"change":function($event){var $$a=_vm.checkedState,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.checkedState=$$a.concat([$$v]))}else{$$i>-1&&(_vm.checkedState=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.checkedState=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"input-check"}),_vm._v(" "),_c('span',{staticClass:"checkbox-label"},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.labelText)+"\n\t\t\t")])]),_vm._v(" "),(_vm.hasError && _vm.inlineErrorText !=='')?_c('p',{staticClass:"help-block"},[_vm._v("\n\t\t\t"+_vm._s(_vm.inlineErrorText)+"\n\t\t")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_form_checkbox = (esExports);
// CONCATENATED MODULE: ./node_modules/@arena/toolkit/src/components/common/form-checkbox.vue
function injectStyle (ssrContext) {
  __webpack_require__("+fG9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79677df9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  form_checkbox,
  common_form_checkbox,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_common_form_checkbox = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GjdZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@arena/toolkit/src/components/common/button.vue + 2 modules
var common_button = __webpack_require__("xJDE");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@arena/toolkit/src/components/common/multi-buttons.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var multi_buttons = ({
	name: 'multiButtons',
	description: 'It provide multi or single button set for Arena theme',
	components: {
		buttonType: common_button["a" /* default */]
	},
	props: {
		btnPrimaryText: {
			type: String,
			default: '',
			note: 'Primary button label'
		},
		btnSecondaryText: {
			type: String,
			default: '',
			note: 'Secondary button label'
		},
		btnPrimaryId: {
			type: String,
			default: '',
			note: 'Set primary button ID'
		},
		btnSecondaryId: {
			type: String,
			default: '',
			note: 'Set secondary button ID'
		},
		disabled: {
			type: Boolean,
			default: false,
			note: 'Assign disabled state if needed'
		},
		primaryButtonClick: {
			type: Function,
			default: null,
			note: 'Assign function to primary button'
		},
		secondaryButtonClick: {
			type: Function,
			default: null,
			note: 'Assign function to secondary button'
		},
		secondaryButtonHide: {
			type: Boolean,
			default: false,
			note: 'Hide option for secondary button'
		},
		secondaryButtonLoading: {
			type: Boolean,
			default: false,
			note: 'Show loading to secondary button if needed'
		},
		loading: {
			type: Boolean,
			default: false,
			note: 'Loading states for Primary button'
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-354ae149","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@arena/toolkit/src/components/common/multi-buttons.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"submit-button-group"},[_c('div',{staticClass:"col-xs-6 btn-right"},[_c('buttonType',{attrs:{"label":_vm.btnPrimaryText,"id":_vm.btnPrimaryId,"disabled":_vm.disabled,"buttonClick":_vm.primaryButtonClick,"loading":_vm.loading}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-6 btn-left"},[_c('buttonType',{attrs:{"btnPrimary":true,"label":_vm.btnSecondaryText,"id":_vm.btnSecondaryId,"buttonClick":_vm.secondaryButtonClick,"btnHide":_vm.secondaryButtonHide,"loading":_vm.secondaryButtonLoading}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_multi_buttons = (esExports);
// CONCATENATED MODULE: ./node_modules/@arena/toolkit/src/components/common/multi-buttons.vue
function injectStyle (ssrContext) {
  __webpack_require__("EXcH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-354ae149"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  multi_buttons,
  common_multi_buttons,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_common_multi_buttons = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "H6HN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut"}},[(_vm.showing)?_c('div',{class:( _obj = {}, _obj[_vm.overlayClass] = _vm.overlay, _obj )},[_vm._t("loading-container",[_c('div',{class:_vm.loaderClass},[_vm._t("loading-text",[_c('div',{staticClass:"pulled-left",domProps:{"innerHTML":_vm._s(_vm.label)}})]),_vm._v(" "),_vm._t("loading-spinner",[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"spinner-container"},[_c('div',{staticClass:"spinner-layer spinner-layer--blue"},[_c('div',{staticClass:"spinner-clipper spinner-clipper--left"},[_c('div',{staticClass:"spinner-circle"})]),_vm._v(" "),_c('div',{staticClass:"spinner--patch"},[_c('div',{staticClass:"spinner-circle"})]),_vm._v(" "),_c('div',{staticClass:"spinner-clipper spinner-clipper--right"},[_c('div',{staticClass:"spinner-circle"})])]),_vm._v(" "),_c('div',{staticClass:"spinner-layer spinner-layer--red"},[_c('div',{staticClass:"spinner-clipper spinner-clipper--left"},[_c('div',{staticClass:"spinner-circle"})]),_vm._v(" "),_c('div',{staticClass:"spinner--patch"},[_c('div',{staticClass:"spinner-circle"})]),_vm._v(" "),_c('div',{staticClass:"spinner-clipper spinner-clipper--right"},[_c('div',{staticClass:"spinner-circle"})])]),_vm._v(" "),_c('div',{staticClass:"spinner-layer spinner-layer--yellow"},[_c('div',{staticClass:"spinner-clipper spinner-clipper--left"},[_c('div',{staticClass:"spinner-circle"})]),_vm._v(" "),_c('div',{staticClass:"spinner--patch"},[_c('div',{staticClass:"spinner-circle"})]),_vm._v(" "),_c('div',{staticClass:"spinner-clipper spinner-clipper--right"},[_c('div',{staticClass:"spinner-circle"})])]),_vm._v(" "),_c('div',{staticClass:"spinner-layer spinner-layer--green"},[_c('div',{staticClass:"spinner-clipper spinner-clipper--left"},[_c('div',{staticClass:"spinner-circle"})]),_vm._v(" "),_c('div',{staticClass:"spinner--patch"},[_c('div',{staticClass:"spinner-circle"})]),_vm._v(" "),_c('div',{staticClass:"spinner-clipper spinner-clipper--right"},[_c('div',{staticClass:"spinner-circle"})])])])])])],2)])],2):_vm._e()])
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Hgy7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    props: {
        label: {
            default: 'Loading...'
        },
        show: {
            default: false
        },
        overlay: {
            default: true
        },
        loaderClass: {
            default: 'loader-wrapper'
        },
        overlayClass: {
            default: 'white-overlay'
        },
        // central event bus
        eventBus: {
            default: null
        },
        eventShow: {
            default: 'show-full-loading'
        },
        eventHide: {
            default: 'hide-full-loading'
        }
    },
    data: function data() {
        return {
            showing: false
        };
    },

    watch: {
        show: function show(val) {
            this.showing = val;
        }
    },
    methods: {
        showMe: function showMe() {
            this.showing = true;
        },
        hideMe: function hideMe() {
            this.showing = false;
        },

        // Register eventBus methods.
        registerBusMethods: function registerBusMethods() {
            this.eventBus.$on(this.eventShow, this.showMe);
            this.eventBus.$on(this.eventHide, this.hideMe);
        }
    },
    mounted: function mounted() {
        // If event bus, register methods.
        if (this.eventBus) this.registerBusMethods();
    }
};

/***/ }),

/***/ "HvZD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IFIa":
/***/ (function(module, exports) {

module.exports = {"account":{"agree-tou":"I agree to Nexon’s {touLink}. To understand how we process your information, please refer to our {privacyLink}.","tou":"Terms of Use","privacy":"Privacy Policy","third-party":{"facebook":"Facebook","google":"Google","steam":"Steam","psn":"Playstation"},"agree-tou-creation":"I agree to Nexon’s {touLink}. To understand how we process your information, please refer to our {privacyLink}.","create-tpa":"Facebook and Google will create <b><u>new accounts</u></b>,&nbsp;separate and unconnected to any Nexon accounts you may currently have. Please visit <a id=\"supportLinkTpa\" href=\"https://support.nexon.net/hc/en-us\" target=\"_blank\" rel=\"external noopener\">Support</a> for FAQ.","tpa-disabled-warning":"Google Third-Party Login is currently unavailable. We apologize for any inconvenience that this may cause, and are hard at work to resolve this issue as soon as possible.","title":"Nexon Account","meta-keyword":"Nexon, nexon.com, MMO, Nexon games","meta-desc":"Nexon's official site, home to the world's most popular online games!"},"login":{"login-to-nexon":"Login to Your Nexon Account","login-with":"or Login with","email":"Email Address","id":"Email Address or Nexon ID","password":"Password","login":"Log In","proceed-login":"Proceed to Log In","auto-login":"Login automatically in the future.","help":{"forgot-password":"Forgot your password?","create-account":"Don't have an account? Create one for free!"},"migration":{"title":"Convert Login ID to Email Address","desc":"Your login ID will be changed to your email address. From now on, you'll need to use your email to log in.","desc-complete":"Login IDs are being transitioned to email addresses. The email below will be used as your login from now on","desc-email-verify":"A verification message has been sent to your email.","new-login":"Your new login name is","trouble":"Trouble verifying?","resend-email":"Resend verification link"},"migrate-tpa":{"desc":"You already have a Nexon account linked to your Steam account. In order to log in with your Nexon account, you will need to use an email address as your username.","instructions-verified":"Your login ID will be changed to your email address.","instructions-unverified":"You can use the email registered to your account or enter a new one."},"confirmEmail":"Confirm Email Address","verify-device":{"title":"Trusted Devices","sub-title":"Secure your account","desc":"This appears to be a new browser, device, or location. A verification code has been sent to your email. Please enter the code to verify your identity.","desc-setting":"Remove all trusted devices associated with your account. The next time you log in on the launcher from any of these devices, you will be required to input the email verification code.","check-box-label":"Remember this device. Use this option for your personal devices.","remove-devices":"Remove Devices"}},"create-account":{"create-nexon-account":"Create Your Nexon Account","create-account":"Create Your Account","email":"Email address","password":"Password","new-password":"New Password","date-of-birth":"Date of birth (MM/YYYY)","newsletter-opt-in":"Sign me up for Nexon email newsletters and exclusive special offers.","select-country":"Select your country","help":{"have-account":"Already have a Nexon account?"},"complete":{"title":"Congratulations! You have successfully created a Nexon global account.","account-name":"Your account name is","desc-email-verify":"Please note: You will receive a verification email shortly and can validate while a game is installing. Once the email address is verified, you will be able to play Nexon and other games available in your region.","button-continue":"Continue to Nexon Launcher","download-launcher":"Install Nexon Launcher","or-continue":"or {continueLink}","continue":"Continue","desc-more-information":"For more information about managing your account information or unsubscribing from promotional emails, visit {accountSetting} page.","title-primary":"One last step!","title-secondary":"All you need to do is verify your email address and you will be on your way to play{gameTitle}!","call-to-action":"We emailed the verification link to"},"verify":{"title-checking":"Verify your Email Address","desc-checking":"We're checking your email verification now.","title-success":"Successfully verified","desc-success":"Congratulations! You have successfully verified the email address for your Nexon global account.","box-success":"Status: Verified","title-failure":"Invalid verification link.","box-failure":"Your verification link was not accepted. Verification links expire after 24 hours. Click the button below to send a fresh link to your email.","new-login":"Your account name is","trouble":"Trouble verifying?","resend-email":"Resend Link","continue":"Continue to Nexon main site"},"third-party-header":"Or Create Your New Account With","select-month":"Birth Month","select-year":"Birth Year","create":"Create an Account"},"settings":{"title":"Account Settings","country":"Country","verify":"verify","verify-email-title":"You still need to verify your email address.","verify-email-desc":"To change any settings for your account, please {0} your email address.","reset-second-password":"Reset second password/PIC","reset-second-password-desc":"Some games require a second password or a Personal Identification Code(PIC) for extra security.","vindictus":"Vindictus","maplestoryNA":"Maplestory - NA","maplestoryEU":"Maplestory - EU","mabinogi":"Mabinogi","securyty-questions":"Security Questions","newsletters":"Newsletters","newsletters-desc":"Receive news and special offers to this email address","reset-account":"Reset Your Account","add":"Add","reset":"Reset","yes":"Yes","no":"No","modal":{"emailVerify":{"title":"You still need to verify your email address.","desc":"Trouble verifying? Resend the verification email.","button":"Resend Email"},"emailResendSuccess":{"title":"Resend verification link","desc":"Another verification email has been sent. Please check your email."}},"email":{"additional-text":"Accounts created through Facebook, Google, Steam and Nexon are separate and unrelated, even though the same email address may be shared by all. To view account settings for a different account, please log in again choosing the proper method (Facebook, Google, Steam or Nexon) associated to that account."},"third-party-connections":"3rd Party Connections","twitch-link-desc":"In order to link or delink your 3rd party connections, you will be directed to outside of Nexon. Please refresh this page to confirm after changing your account connections from external site.","link":"Link","delink":"Delink","twitch-details-loading":"Twitch details loading...","twitch-not-linked":"Twitch account - Not Linked","twitch-account":"Twitch account","trusted-device-remove-title":"Remove all trusted devices","trusted-device-remove-desc":"Are you sure you want to remove all your trusted devices? You will be required to verify all your previous trusted devices the next time you login.","trusted-devices-remove-success-alert":"All devices associated with your account have been successfully removed.","social-link":{"0":{"0":"Social Login","one":"Social Login","other":"Social Login","0-plural-2":"","one-plural-2":"","other-plural-2":""},"title":"Social Login","desc":"Manage different login options and social activities.","delink-modal":{"title":"Delink Social Login","desc":"You are now delinking your Nexon account with following account: <br /><br /><p>{socialType}:  {socialEmail}</p>"},"need-password":{"title":"Set Your Password Before Delinking","desc":"You must set your password before delinking your social login from this account.<br />Following social login will be delinked after the password was created.<br /><br /><p>{socialType}:  {socialEmail}</p>","create-password":"Create Password"}},"social-link-desc":"Manage different login options and social activities.","linked":"Linked","not-linked":"Not Linked","privacy-email-heading":"Allow my email and profile to be searchable. (For specific games)","privacy-email-desc":"In specific games, users can find your account by email address or profile name. Turn this off to be searchable only by your profile name.","social-privacy":"Find Your Account by Email (For only specific games)","social-privacy-desc":"In specific games, you can allow users to find your account by email address as well as profile name."},"security-question":{"title":"Security Questions","change":"Change Security Question","first-question":"First Question","second-question":"Second Question","answer":"Answer","hint":"Hint","optional":"(Optional)","question":"Question","success-desc":"Your security questions have successfully been added.","success-change-desc":"Your security question has successfully been changed.","select-question":"Select your security question","question-100":"What street did you live on in third grade?","question-101":"What is your oldest sibling's birthday month and year? (e.g., January 1900)","question-102":"What is your oldest sibling's middle name?","question-103":"What school did you attend for sixth grade?","question-104":"What was your childhood phone number including area code? (e.g., 000-000-0000)","question-105":"What was the name of your first stuffed animal?","question-106":"In what city or town did your mother and father meet?","question-107":"What was the last name of your second grade teacher?","question-108":"What is your maternal grandmother's maiden name?","question-109":"In what town was your first job?","question-200":"What is your favorite fictional character?","question-201":"What is the number of your favorite sports star?","question-202":"Who is your favorite actor/actress?","question-203":"What is the punch line to a joke you like?","question-204":"What is the name (first and last) of a relative that is important to you?","question-205":"What is a date that has special significance to you?"},"reset-password":{"title":"Reset your password","desc":"Just enter the email address for your account and we will send you a password reset verification code.","reset":"Reset password","success-desc":"Your password has been changed!","un-migrated":"Please go to your email to verify your account."},"change-password":{"title":"Change your Password","current-password":"Current Password","new-password":"New Password","enter-current-password":"Enter current password","enter-new-password":"Enter new password","enter-confirm-password":"Confirm password","success-desc":"Your password has successfully been changed."},"change-email":{"title":"Change Email","new-email":"New Email","verification-code-desc":"A verification code has been sent to your email address. When received please enter it below, it will only be valid for the next 30 minutes.","enter-verification-code":"Enter verification code","success-desc":"Your Email has successfully been changed."},"reset-account":{"title":"Reset Your Account","desc":"A verification code has been sent to your email address.  When received please enter it below, it will only be valid for the next 30 minutes.","success-desc":"Your account has successfully reset."},"error":{"404":"404 File Not Found","500":"An unknown error has occurred.","404-desc":"The page you requested may have been moved or deleted.","500-desc":"Please attempt to refresh or return to the previous page.","input":{"id":"Please enter your email or Nexon ID.","email":"Please enter your email address.","newEmail":"Please enter your new email address","password":"Please enter your password.","dateOfBirth":"Please enter your date of birth.","not-valid-email":"Please enter a valid email address.","length":{"id":"Email address must be {0}-{1} characters.","password":"Password must be {0}-{1} characters.","dateOfBirth":"Please enter a valid date.","passwordShow":"Password must be {0}-{1} characters.","newPassword":"New password must be {0}-{1} characters.","confirmPassword":"Confirm Password must be {0}-{1} characters."},"securityAnswer":"Please answer the security question.","verificationCode":"Please enter a verification code.","newPassword":"Please enter a new password.","confirmPassword":"Passwords must match.","answer1":"Please enter an answer.","answer2":"Please enter an answer.","not-valid-dob":"Please enter a valid date of birth.","passwordShow":"Please enter your password.","emailConfirmation":"Email must match.","currentPassword":"Please enter a current password.","email-must-match":"Email must match.","password-must-match":"Passwords must match."},"form":{"INVALID_ID_FORMAT":"The email address you've entered is invalid.","INVALID_ID_TOKEN":"An error occurred while logging in. Please try again.","INVALID_LANGUAGE":"Invalid access.","INVALID_PARAMETER":"Invalid access with invalid parameter. Please try again.","INVALID_PURPOSE":"Invalid access.","INVALID_RESERVED_ID":"You can no longer cancel the ID change request. If the same issue continues to occur, please contact customer service.","INVALID_URI":"Invalid access.","INVALID_VERIFICATION_NO":"That verification code is no longer valid. Please request a new one.","INVALID_VERIFICATION_TOKEN":"An error has occurred. Please try again.","ACCOUNTS_EMPTY_TOKEN":"A system error has occurred. Please try again later (Error 2024/1903). ","ACCOUNTS_FAILED":"A system error has occurred. Please try again later. (Error 2024/1902)","ACCOUNTS_LIMIT_EXCEEDED":"A system error has occurred. Please try again later. (Error 2024/1901)","IS_NOT_YOUR_AREA":"You are attempting to access from outside of our service area.","MAIN_ST_NO_MAPPED_EXCEPTION":"A server error has occurred. (Code:Main)","META_DESC_SIGNUP_COMPLETE_MB":"Congratulations! You can now create an anime-inspired idol and customize your appearance with thousands of options, including clothing, hair styles and much more.","NO_MAPPED_EXCEPTION_PASSPORT":"A server error has occurred. (Code:Passport)","NOT_AVAILABLE_ID":"This ID cannot be used. Please try a different ID.","NOT_EXIST_USER":"Either this account doesn't exist or the password is incorrect. Please try again.","NOT_MEMBERSHIP_USER":"Invalid access.","NOT_PERMITTED_REQUEST":"Invalid access.","NOT_SUPPORTED_USER_STATUS":"Invalid access.","NOT_TEMPORARY_ACCOUNT":"This account cannot be registered. Please try again.","NOT_VERIFIED_ID":"Trouble verifying? Resend the verification email.","NOTICE":"Notice","PASSWORD_CHANGE_SUCCESS":"Your password has successfully been changed.","PASSWORD_CURRENTLY_IN_USE":"The password you've entered is the same as your current password. Please enter a new password.","PROTECTED_NMODE_TITLE":"Reactivation Required","PROTECTED_SMODE_TITLE":"Password reset required","PROTECTED_USER":"Your account is in Protected mode. To disable it, navigate to the \"Disable Protected Mode\" page.","REACTIVATE":"Reactivate","RELINK_TWITCH_MESSAGE":"Your Twitch account link has been revoked or expired. This may happen after changing your Twitch password. Click \"Link\" in the Twitch Third-Party Apps section below to relink.","RELINK_TWITCH_TITLE":"Twitch link disabled","RESEND_VERIFICATION_LINK":"Resend verification link","RESET":"Reset","RESET_PASSWORD":"Reset password","RESET_PASSWORD_EMAIL_SENT_CONTENTS":"Please go to your email to verify your account.","RESET_PASSWORD_SESSION_MIGHT_BE_EXPIRED":"An error has occurred. Please try again.","RESET_SECOND_FAIL":"You do not have a game character or password has not been set up on this account.","RESET_SECOND_FAIL_EXPIRED":"You have already reset the secondary password or the reset request has been expired.","RESET_SECOND_SUCCESS":"2nd password reset confirmation has been sent to your email.","RESET_SUCCESS":"Reset successfully.","RETURN_URL_WARNING_BODY":"You are being redirected to an external site. If you don't know why you're being taken to the below URL, click the Cancel button.","RETURN_URL_WARNING_CONTINUE_BUTTON":"Continue anyway","REVERT_EMAIL_SUCCESS":"Your email has successfully been reverted.","SECURITY_QUESTION_CHANGE_SUCCESS":"Your security question has successfully been changed.","SECURITY_QUESTION_DO_NOT_MATCH":"Oops! Security Questions don't match.","SECURITY_QUESTION_DUPLICATE":"You've chosen a duplicate security question. Please choose an alternate question that's different from your first choice.","SECURITY_QUESTIONS_ADDED":"Your security questions have successfully been added.","SEND_CODE":"Resend Email","SERVER_ERROR":"An error has occurred. Please try again.","STEAM_IDTOKEN_INVALID":"Invalid Steam login detected.","UNABLE_TO_CHANGE_ID":"Your ID cannot be changed right now. You must wait 7 days between changing IDs.","UNAUTHORIZED":"Invalid access.","UNDER_MAINTENANCE":"We are temporarily offline due to maintenance. Please log on once the maintenance is complete.","UNPROTECT_N_SESSION_MIGHT_BE_EXPIRED":"An error has occurred. Please try again.","VERIFICATION_CODE_CURRENT_EMAIL":"Another verification code has been sent to your current email.","VERIFICATION_CODE_SENT_BODY":"A new verification code has been sent to your email.","VERIFICATION_EMAIL_SENT_BODY":"Another verification email has been sent. Please check your email.","VERIFICATION_LINK_SENT_BODY":"A new verification link has been sent to your email. Click this link to verify your account.","VERIFICATION_SENT_HEADER":"Check your email","VERIFY_EMAIL_REQUIRED":"Trouble verifying? Resend the verification email.","VERIFY_EMAIL_REQUIRED_TITLE":"You still need to verify your email address.","WRONG_PASSWORD":"The password you've entered is incorrect.","ALREADY_MIGRATED_ID":"Your email has already been set as your user ID. Please login using your email from now on.","MAIN_ST_NOT_AUTHORIZED":"Invalid access. (Not Authorized)","NOT_PROTECTED_USER_S_MODE":"Invalid access.","NOT_EXIST_MEMBERSHIP_USER":"You are attempting to access from outside of our service area.","INVALID_SECURITY_QUESTION_ANSWER":"You have entered an invalid answer. Please try again.","WRONG_VERIFICATION_CODE":"The verification code you've entered does not match the one that was sent. Please try again.","complete-captcha":"You must complete the Captcha to login.","complete-captcha-create":"You must complete the Captcha to create an account.","fields":"One or more required fields are empty. Please complete the form and try again.","INTERNAL_SERVER_EXCEPTION":"Cannot access the server at this time. Please try again later.","LOGIN_REQUIRED":"Please log in to continue using the service.","NETWORK_ERROR":" A network error occurred (Code: 20010). Please try again later.","SESSION_EXPIRED":"Your session has expired. Please log in again.","BLOCKED_USER_PORTAL_BAN":"Your account has been blocked. To appeal this action, please submit a ticket at https://billingpp.zendesk.com.","BLOCKED_BY_SECURITY_POLICY":"Access temporarily revoked due to abnormal login attempts. Please try again later.","ALREADY_EXIST_ID":"This ID is already being used.","coppa":"Can't accept your submission at this time.","ALREADY_LINKED_WITH_DIFFERENT_ID":"The social login is already in use with another Nexon account.{lineBreak} To initiate linking process properly, you need to login with that Google or Facebook account.","CONFIRM_PIC_10309":"Your secondary password has been successfully reset.","CONFIRM_PIC_10310":"Invalid reset code.","CONFIRM_PIC_10023":"A secondary password has not been set up on this account.","CONFIRM_PIC_10025":"Your verification code has expired or is incorrect.","CONFIRM_PIC_10026":"A secondary password has not been set up on this account.","CONFIRM_PIC_10027":"An error occurred while processing your request. We are sorry for the inconvenience.  Please try again later.","CONFIRM_PIC_10019":"2nd password reset confirmation","BLOCKED_EMAIL_DOMAIN":"This ID cannot be used.","unknown":"An unknown error has occurred.","CHANGE_ID_SESSION_MIGHT_BE_EXPIRED":"Your session has expired. Please log in again.","ALREADY_EXIST_ID_IN_OTHER_MEMBERSHIP":"That email is being used in another Nexon region.","ERROR":"Error","SUCCESS":"Success","GENERAL":"There was an error that occurred during the process. (Error code: {errorCode})","TIMEOUT":"Our API is currently not responding. This can be caused by either poor connectivity or an error with our servers.{lineBreak} Please try again in a while.","ALREADY_CONNECTED_WITH_DIFFERENT_ID":"Unable to link the account. This email address is already linked to another Steam account.","ALREADY_LINKED":"Your account is already linked.{lineBreak} Please check and try again.","ALREADY_LINKED_WITH_DIFFERENT_ACCOUNT":"The social login is already in use with another Nexon account.{lineBreak} Please try again with another Google or Facebook account that is not linked to Nexon account.","ALREADY_EXIST_ACCOUNT":"This account already exists.","NEED_CAPTCHA":"You must complete the Captcha to login."},"modal":{"PROTECTED_USER_S_MODE":{"title":"Password Reset Required","desc":"You are required to reset your password. Please click \"Reset Password\" to start the process.","button":"Reset Password"},"PROTECTED_USER_N_MODE":{"title":"Reactivation Required","desc":"Suspicious attempts to access your account have been detected. For your protection, your account has been deactivated. Please click \"Reactivate\" below to activate your account and reset your password. An activation email has been sent out to your email address with a verification code.","button":"Reactivate"},"BLOCKED_USER_SUSPICIOUS_IP":{"title":"Reactivation Required","desc":"Suspicious attempts to access your account have been detected. For your protection, your account has been deactivated. Please click \"Reactivate\" below to activate your account and reset your password. An activation email has been sent out to your email address with a verification code.","button":"Reactivate"},"ALREADY_EXIST_ID_IN_OTHER_MEMBERSHIP":{"title":"Email Region-Locked","desc":"That email is being used in another Nexon region. To use that email here, first log in to your account with the other region and change your email in the Account Settings.","button":"Continue"},"IS_NOT_YOUR_AREA":{"title":"Login restricted to another region.","desc":"You are attempting to access from outside of our service area.","button":"Logout"},"BLOCKED_USER_PORTAL_BAN":{"desc":"Your account has been blocked. To appeal this action, please submit a ticket at https://billingpp.zendesk.com.","title":"Your account has been blocked"},"ALREADY_EXIST_ID_IN_OTHER_MEMBERSHIP_launcher":{"title":"Email Being Used in Another Region","desc":"The selected email is already being used in another Nexon region. To use this account, please install and run the launcher for that specific region.<br /><br /><b>{regionTitle}</b><br />","button":"Download the launcher"}},"maintenance":"Under Maintenance","twitch-link-error":"A Twitch linking API error occurred.","TWITCH_ALREADY_LINKED":"A Twitch account is already linked to your Nexon account.","TWITCH_ALREADY_LINKED_WITH_ANOTHER":"This Twitch account is already linked to another Nexon account.","try_again_or_support":"Please try again or visit {support} for FAQ."},"cancel":"Cancel","close":"Close","home":"Back to Home","change":"Change","success":"Success!","back-to-setting":"Back to settings","login-required":"Please login again to continue.","resend":"Resend","send-code":"Send Code","add":"Add","notice":"Notice","info":"Info","healup":{"title":"Update your information","desc-main":"To continue enjoying Nexon games, you are required to update your information below.","desc-country":"Please note: You also will use the currency of the corresponding country. And once a country is selected, it can only be changed through Customer Support.","button-save":"Save and continue","why":{"title":"Why is country selection required?","section1":{"title":"Why is my country not available?","desc":"Your country is not available because it's either serviced in another region or it's not supported."},"section2":{"title":"What impact will the selected country have on my account?","desc":"Depending on your region, your country will determine your currency type. Moreover, availability of Nexon games will be determined by your country."},"link":"Please visit {link} for FAQ.","linkUrl":"https://temp.url"},"tpa":{"title":"Create Your New Account"},"desc-main-steam":"You are creating a new Nexon account. To link your existing Nexon account with Steam, please enter your Nexon email address.","desc-main-tpa":"You are creating a&nbsp;<b><u>new account</u></b>. This account will be separate and unconnected to any Nexon accounts you may currently have."},"resend-modal":{"title":"Resend verification link","description-loading":"Sending another verification email.","description-success":"Another verification email has been sent. Please check your email.","description-failure":"Failed to send another verification email. Are you sure you entered the right email address?","description-verified":"You've already verified your email address."},"get-nx":"Get NX","support":"Support","logout":"Log Out","copyright":"©{0} NEXON Korea Corporation and NEXON America Inc. All Rights Reserved.","complete":"Complete","languages":{"es":"Español (LA)","en":"English","pt":"Português (BR)","de":"Deutsch","fr":"Français","it":"Italiano","pl":"Polski","tr":"Türkçe"},"verify":"Verify","revert-id":{"title":"Revert changed ID","desc":"You can revert email with new password."},"revert":"Revert","optout":{"success":"Your email has been opted out for Nexon newsletters.","your-email-is":"Your Email Address is"},"login-tpa":{"fb-settings-link":"your Facebook Apps and Websites page","fb-relink-prompt":"You've chosen not to share your Facebook email address with Nexon. This information is required to log in to Nexon using Facebook. You'll need to visit {fbSettingsLink}, select the NEXON app, and click \"Remove\" before using Nexon login through Facebook again."},"verify-code-tpa":{"title":"Verify to link your existing account","desc-top":"You already have an existing Nexon account.","selected-country":{"desc":"If your Nexon account already has country and DOB information, the previous country selection and DOB input will be ignored.","label":"Selected country"}},"country_healup":"To continue enjoying Nexon games, you are required to update your information below.","twitch-link-success-desc":"Your Twitch account was successfully linked to your Nexon account.","twitch-link-auth-refused":"In order to link your Twitch account, you must grant Nexon permission to read your Twitch details.","regions":{"sea":"SEA","th":"Thailand","kr":"Korea","jp":"Japan","tw":"Taiwan","global":"Global"},"confirm":"Confirm","resend-verification-email":"Resend verification email","cant-find-the-email":"Can't find the email?","social-link":{"title":"Link Nexon Email Account","info-box":{"create-or-link":"You can either create a new Nexon account with your email or {action}.","found-existing":"Great news! We found an existing Nexon account with '{userName}'.","id-used-different-region":"Sorry, but '{userName}' is currently used in another region.","id-already-in-use":"Sorry, but it appears that you have used '{userName}' on another Nexon account."},"instructions":{"update-info-below":"Please update your information below.","login-to-link":"Please log in to the Nexon account you want to link with.","enter-email-to-link":"Please enter a new Email address to link with your {linkType} account in your region."},"button-link":"Link this account","alt-action":{"link-to-existing":"Link to an existing Nexon account","link-to-new":"Create a new Nexon account to Link"},"help":{"why-required":"Why is this required?","email-restriction-tpa":"Why can't I use my Google or Facebook email address?","why-required-body":"We updated our Third Party Accounts to be link-able to Nexon Email Account. As a result, Third Party Accounts will not be new, separate accounts anymore.","email-restriction-tpa-body":"A Nexon email account is currently using the email address. If you wish to use it, please login to the associated Nexon Email account and change the email through Account Settings."}},"submit":"submit","create-password":{"title":"Create your password","success-desc":"Your password has successfully been created."},"dialog":{"title":{"notice":"Notice","error":"Error","success":"Success","reset":"Reset","reactivate":"Reactivate"},"desc":{"social-link-success":"Your social login has successfully been updated."}},"create":"Create","Uninstall-failed":"Uninstall failed.","_common":{"country-list":{"AD":"Andorra","AG":"Antigua and Barbuda","AL":"Albania","AM":"Armenia","AR":"Argentina","AT":"Austria","AU":"Australia","AX":"Åland","AZ":"Azerbaijan","BA":"Bosnia and Herzegovina","BB":"Barbados","BE":"Belgium","BG":"Bulgaria","BO":"Bolivia","BR":"Brazil","BS":"Bahamas","BY":"Belarus","BZ":"Belize","CA":"Canada","CH":"Switzerland","CL":"Chile","CO":"Colombia","CR":"Costa Rica","CU":"Cuba","CY":"Cyprus","CZ":"Czechia","DE":"Germany","DK":"Denmark","DM":"Dominica","DO":"Dominican Republic","EC":"Ecuador","EE":"Estonia","ES":"Spain","EU":"European Union","FI":"Finland","FO":"Faroe Islands","FR":"France","GD":"Grenada","GE":"Georgia","GI":"Gibraltar","GR":"Greece","GT":"Guatemala","GY":"Guyana","HK":"Hong Kong","HN":"Honduras","HR":"Croatia","HT":"Haiti","HU":"Hungary","ID":"Indonesia","IE":"Ireland","IL":"Israel","IM":"Isle of Man","IS":"Iceland","IT":"Italy","JE":"Jersey","JM":"Jamaica","KG":"Kyrgyzstan","KN":"Saint Kitts and Nevis","LC":"Saint Lucia","LI":"Liechtenstein","LT":"Lithuania","LU":"Luxembourg","LV":"Latvia","MC":"Monaco","MD":"Moldova","ME":"Montenegro","MK":"Macedonia","MO":"Macao","MT":"Malta","MX":"Mexico","MY":"Malaysia","NI":"Nicaragua","NL":"Netherlands","NO":"Norway","NZ":"New Zealand","PA":"Panama","PE":"Peru","PL":"Poland","PR":"Puerto Rico","PT":"Portugal","PY":"Paraguay","RO":"Romania","RS":"Serbia","SE":"Sweden","SG":"Singapore","SI":"Slovenia","SJ":"Svalbard and Jan Mayen","SK":"Slovakia","SM":"San Marino","SR":"Suriname","SV":"El Salvador","TH":"Thailand","TR":"Turkey","TT":"Trinidad and Tobago","TW":"Taiwan","UA":"Ukraine","UK":"United Kingdom","US":"United States","UY":"Uruguay","VA":"Vatican City","VC":"Saint Vincent and the Grenadines","VE":"Venezuela","VN":"Vietnam","XK":"Kosovo","AE":"United Arab Emirates","AF":"Afghanistan","AI":"Anguilla","AN":"Netherlands Antilles","AO":"Angola","AQ":"Antarctica","AS":"American Samoa","AW":"Aruba","BD":"Bangladesh","BF":"Burkina Faso","BH":"Bahrain","BI":"Burundi","BJ":"Benin","BL":"Saint Barthélemy","BM":"Bermuda","BN":"Brunei","BQ":"Bonaire","BT":"Bhutan","BV":"Bouvet Island","BW":"Botswana","CC":"Cocos [Keeling] Islands","CD":"Democratic Republic of the Congo","CF":"Central African Republic","CG":"Republic of the Congo","CI":"Ivory Coast","CK":"Cook Islands","CM":"Cameroon","CS":"Serbia and Montenegro","CV":"Cape Verde","CW":"Curacao","CX":"Christmas Island","DJ":"Djibouti","DZ":"Algeria","EG":"Egypt","EH":"Western Sahara","ER":"Eritrea","ET":"Ethiopia","FJ":"Fiji","FK":"Falkland Islands","FM":"Micronesia","GA":"Gabon","GB":"United Kingdom","GF":"French Guiana","GG":"Guernsey","GH":"Ghana","GL":"Greenland","GM":"Gambia","GN":"Guinea","GP":"Guadeloupe","GQ":"Equatorial Guinea","GS":"South Georgia and the South Sandwich Islands","GU":"Guam","GW":"Guinea-Bissau","HM":"Heard Island and McDonald Islands","IN":"India","IO":"British Indian Ocean Territory","IQ":"Iraq","IR":"Iran","JO":"Jordan","JP":"Japan","KE":"Kenya","KH":"Cambodia","KI":"Kiribati","KM":"Comoros","KP":"North Korea","KW":"Kuwait","KY":"Cayman Islands","KZ":"Kazakhstan","LA":"Laos","LB":"Lebanon","LK":"Sri Lanka","LR":"Liberia","LS":"Lesotho","LY":"Libya","MA":"Morocco","MF":"Saint Martin","MG":"Madagascar","MH":"Marshall Islands","ML":"Mali","MM":"Myanmar [Burma]","MN":"Mongolia","MP":"Northern Mariana Islands","MQ":"Martinique","MR":"Mauritania","MS":"Montserrat","MU":"Mauritius","MV":"Maldives","MW":"Malawi","MZ":"Mozambique","NA":"Namibia","NC":"New Caledonia","NE":"Niger","NF":"Norfolk Island","NG":"Nigeria","NP":"Nepal","NR":"Nauru","NU":"Niue","OM":"Oman","PF":"French Polynesia","PG":"Papua New Guinea","PH":"Philippines","PK":"Pakistan","PM":"Saint Pierre and Miquelon","PN":"Pitcairn Islands","PS":"Palestine","PW":"Palau","QA":"Qatar","RE":"Réunion","RW":"Rwanda","SA":"Saudi Arabia","SB":"Solomon Islands","SC":"Seychelles","SD":"Sudan","SH":"Saint Helena","SL":"Sierra Leone","SN":"Senegal","SO":"Somalia","SS":"South Sudan","ST":"São Tomé and Príncipe","SX":"Sint Maarten","SY":"Syria","SZ":"Swaziland","TC":"Turks and Caicos Islands","TD":"Chad","TF":"French Southern Territories","TG":"Togo","TJ":"Tajikistan","TK":"Tokelau","TL":"East Timor","TM":"Turkmenistan","TN":"Tunisia","TO":"Tonga","TV":"Tuvalu","TZ":"Tanzania","UG":"Uganda","UM":"U.S. Minor Outlying Islands","UZ":"Uzbekistan","VG":"British Virgin Islands","VI":"U.S. Virgin Islands","VU":"Vanuatu","WF":"Wallis and Futuna","WS":"Samoa","YE":"Yemen","YT":"Mayotte","ZA":"South Africa","ZM":"Zambia","ZW":"Zimbabwe"}}}

/***/ }),

/***/ "IKUm":
/***/ (function(module, exports) {

module.exports = {"footer":{"aboutNexon":"Acerca de Nexon","support":"Atención al cliente","careers":"Carreras","businessOpportunities":"Oportunidades de negocio","press":"Prensa","investorRelations":"Relaciones con inversionistas","privacy":"Política de Privacidad","legalDoc":"Documentación legal","tou":"Términos de uso","eula":"Acuerdo de Licencia del Usuario Final","copyright":"©{0} NEXON Korea Corporation y NEXON America Inc. Todos los derechos reservados.","languages":{"es":"Español (LA)","en":"English","pt":"Português (BR)","de":"Deutsch","fr":"Français","it":"Italiano","pl":"Polski","tr":"Türkçe","th":"ภาษาไทย","zh":"Chino","nl":"Dutch"},"regions":{"sea":"SEA","th":"Tailandia","kr":"Corea","jp":"Japón","tw":"Taiwan","global":"Global"}}}

/***/ }),

/***/ "IcnI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__("Dd8w");

var _extends4 = _interopRequireDefault(_extends3);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__("NYxO");

var _vuex2 = _interopRequireDefault(_vuex);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _vuexPersistedstate = __webpack_require__("424j");

var _vuexPersistedstate2 = _interopRequireDefault(_vuexPersistedstate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
	plugins: [(0, _vuexPersistedstate2.default)({
		paths: ['verifiedTokenEmail', 'creation.accountEmail']
	})],
	state: {
		accountId: null,
		accountPassword: null,
		isMobile: /(iPhone|iPad|Android|Mobile)/gi.test(navigator.userAgent),
		configurations: {},
		settings: null,
		thirdPartyList: [],
		inlineInput: {
			errors: {}
		},
		form: {
			errors: {}
		},
		create: {
			errors: {}
		},
		loginType: 'login',
		baseAccountAddress: '' + environment.webApi,
		requestLoginAddress: environment.webApi + '/login',
		createAccountType: 'create',
		requestCreateAccountAddress: environment.webApi + '/signup',
		migration: {
			accountEmail: null,
			legacyLoginID: null,
			emailVerified: false
		},
		creation: {
			accountEmail: null,
			autoLogin: null,
			passwordHash: null,
			captchaResponse: null
		},
		healup: {
			isTPA: true,
			tpaType: null
		},
		challengeTitle: null,
		securityQuestion: {},
		launcherLoginData: {},
		returnURL: null,
		authorizeParams: {},
		ssoParams: {},
		productId: null,
		partnerKey: null,
		middleWareUrl: null,
		optOutInfo: null,
		directReturn: null,
		channel: null,
		createdAccountEmail: null,
		verifiedTokenEmail: null,
		referrerUrl: null,
		appType: 'web',
		loading: false,
		tpaInit: {
			google: false,
			facebook: false
		}
	},
	actions: {
		retrieveConfiguration: function retrieveConfiguration(_ref) {
			var commit = _ref.commit;

			_axios2.default.get(environment.webApi + '/v2/configurations').then(function (response) {
				return response.data;
			}).then(function (configData) {
				commit('setConfiguration', configData);
			}).catch(function () {});
		}
	},
	mutations: {
		setAppType: function setAppType(state, payload) {
			state.appType = payload;
		},
		setVerifiedTokenEmail: function setVerifiedTokenEmail(state, payload) {
			state.verifiedTokenEmail = payload;
		},
		clearVerifiedTokenEmail: function clearVerifiedTokenEmail(state) {
			state.verifiedTokenEmail = null;
		},
		setDirectReturn: function setDirectReturn(state, payload) {
			state.directReturn = payload;
		},
		setLauncherLoginData: function setLauncherLoginData(state, payload) {
			state.launcherLoginData = payload;
		},
		getOptOutInfo: function getOptOutInfo(state, payload) {
			state.optOutInfo = payload;
		},
		getMiddlewareUrl: function getMiddlewareUrl(state, payload) {
			state.middleWareUrl = payload;
		},
		setAccountId: function setAccountId(state, payload) {
			state.accountId = payload;
		},
		setAccountPassword: function setAccountPassword(state, payload) {
			state.accountPassword = payload;
		},
		setProductId: function setProductId(state, payload) {
			state.productId = payload;
		},
		setPartnerKey: function setPartnerKey(state, payload) {
			state.partnerKey = payload;
		},
		getAuthorizeParams: function getAuthorizeParams(state, payload) {
			state.authorizeParams = (0, _extends4.default)({}, payload);
		},
		getSsoParams: function getSsoParams(state, payload) {
			state.ssoParams = (0, _extends4.default)({}, payload);
		},
		setSecurityChallengeInfo: function setSecurityChallengeInfo(state, payload) {
			state.securityQuestion = (0, _extends4.default)({}, state.securityQuestion, {
				question: payload.question,
				answer: payload.answer
			});
		},
		setChallengeTitle: function setChallengeTitle(state, payload) {
			state.challengeTitle = payload;
		},
		setConfiguration: function setConfiguration(state, payload) {
			state.configurations = (0, _extends4.default)({}, payload);
		},
		setSettingsData: function setSettingsData(state, payload) {
			state.settings = (0, _extends4.default)({}, payload);
		},
		setCreationData: function setCreationData(state, payload) {
			state.creation[payload.name] = payload.value;
		},
		setMigrationData: function setMigrationData(state, payload) {
			state.migration[payload.name] = payload.value;
		},
		changeLoginType: function changeLoginType(state, payload) {
			state.loginType = payload;
		},
		changeLoginAddress: function changeLoginAddress(state, payload) {
			state.requestLoginAddress = payload;
		},
		changeCreateAccountType: function changeCreateAccountType(state, payload) {
			state.createAccountType = payload;
		},
		changeCreateAccountAddress: function changeCreateAccountAddress(state, payload) {
			state.requestCreateAccountAddress = payload;
		},
		setData: function setData(state, payload) {
			state.checkoutData = (0, _extends4.default)({}, payload);
		},
		setInputValidationError: function setInputValidationError(state, payload) {
			state.inlineInput.errors = (0, _extends4.default)({}, state.inlineInput.errors, (0, _defineProperty3.default)({}, payload.field, payload.msgs));
		},
		setFormError: function setFormError(state, payload) {
			state.form.errors = (0, _extends4.default)({}, state.form.errors, { code: payload.field });
		},
		setLegacyLoginID: function setLegacyLoginID(state, payload) {
			state.legacyLoginID = payload;
		},
		clearValidationError: function clearValidationError(state, payload) {
			_vue2.default.delete(state.inlineInput.errors, payload.field);
		},
		getThirdPartyList: function getThirdPartyList(state, payload) {
			state.thirdPartyList = [].concat((0, _toConsumableArray3.default)(payload));
		},
		setReturnURL: function setReturnURL(state, payload) {
			state.returnURL = payload;
		},
		setChannel: function setChannel(state, payload) {
			state.channel = payload;
		},
		setReferrerUrl: function setReferrerUrl(state, payload) {
			state.referrerUrl = payload;
		},
		setLoading: function setLoading(state, payload) {
			state.loading = payload;
		},
		setTpaInit: function setTpaInit(state, payload) {
			if ((typeof payload === 'undefined' ? 'undefined' : (0, _typeof3.default)(payload)) !== 'object') return;
			state.tpaInit = (0, _assign2.default)({}, state.tpaInit, payload);
		}
	}
});

/***/ }),

/***/ "IoAV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JLIx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@arena/toolkit/src/components/common/icon-svg.vue + 2 modules
var icon_svg = __webpack_require__("EO4f");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@arena/toolkit/src/components/common/form-warning.vue
//
//
//
//
//
//
//
//



/* harmony default export */ var form_warning = ({
	name: 'formWarning',
	components: {
		svgIcon: icon_svg["default"]
	},
	props: {
		hideWarning: {
			type: Boolean,
			default: true,
			note: 'Hide and show warning'
		},
		warningMessage: {
			type: String,
			default: '',
			note: 'Message when it shows.'
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51f5b464","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@arena/toolkit/src/components/common/form-warning.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hideWarning)?_c('div',{staticClass:"alert alert-warning text-center",class:{ 'hide': _vm.hideWarning},attrs:{"role":"alert"}},[_c('svgIcon',{attrs:{"iconHolderClass":"icon-warning","iconId":"icon-warning"}}),_vm._v("\n\t"+_vm._s(_vm.warningMessage)+"\n\t"),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_form_warning = (esExports);
// CONCATENATED MODULE: ./node_modules/@arena/toolkit/src/components/common/form-warning.vue
function injectStyle (ssrContext) {
  __webpack_require__("A/uU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-51f5b464"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  form_warning,
  common_form_warning,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_common_form_warning = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Kkqs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// EXTERNAL MODULE: ./node_modules/@arena/toolkit/src/components/common/form-select.vue + 2 modules
var form_select = __webpack_require__("Tk1k");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@arena/toolkit/src/components/common/form-date.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var form_date = ({
	name: 'formDate',
	introduction: 'VueJs date selector component',
	components: {
		formSelect: form_select["a" /* default */]
	},
	props: {
		textFieldEnterHandler: {
			type: Function,
			note: 'Keyboard Enter key pressed, handling behavior'
		},
		submitted: {
			type: Boolean,
			default: false,
			note: 'Check submit status'
		},
		monthFirst: {
			type: Boolean,
			default: true,
			note: 'Inline select box order'
		},
		checkCoppa: {
			type: Boolean,
			default: false,
			note: 'Coppa under age checking'
		},
		hasError: {
			type: Boolean,
			default: false,
			note: 'Checking error state'
		}
	},
	data: function data() {
		return {
			internalValueCopy: '',
			// The regular 12 months (string values are + 1 because int months start at 0)
			monthsList: [].concat(toConsumableArray_default()(Array(12).keys())).map(function (value) {
				return { label: ('' + (value + 1)).padStart(2, '0'), value: value };
			}),
			// The past 120 years
			yearsList: [].concat(toConsumableArray_default()(Array(120).keys())).map(function (value) {
				return {
					label: '' + (value + (new Date().getFullYear() - 120)),
					value: value + (new Date().getFullYear() - 120)
				};
			}).reverse(),
			selectedMonth: null,
			selectedYear: null
		};
	},

	methods: {
		monthAsString: function monthAsString() {
			var monthInt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selectedMonth;

			return ('' + (monthInt + 1)).padStart(2, '0');
		},
		updateSelectedMonth: function updateSelectedMonth(monthInt) {
			this.selectedMonth = monthInt;
			this.emitDateIfComplete();
		},
		updateSelectedYear: function updateSelectedYear(yearInt) {
			this.selectedYear = yearInt;
			this.emitDateIfComplete();
		},
		emitDateIfComplete: function emitDateIfComplete() {
			if (this.selectedMonth !== null && this.selectedYear !== null) {
				this.$emit('input', '' + this.selectedYear + this.monthAsString());
			}
		}
	},
	computed: {
		coppaValid: function coppaValid() {
			// COPPA end date is 13 years after birth
			var coppaEnded = new Date(this.selectedYear + 13, this.selectedMonth);
			return new Date() > coppaEnded;
		}
	},
	watch: {
		selectedMonth: function selectedMonth() {
			if (this.selectedMonth === null || this.selectedYear === null) {
				this.$emit('validation-change', true);
			} else {
				this.$emit('validation-change', false);
			}
			if (this.checkCoppa) {
				if (this.submitted) {
					this.$emit('coppa-valid', this.coppaValid);
				}
			}
		},
		selectedYear: function selectedYear() {
			if (this.selectedMonth === null || this.selectedYear === null) {
				this.$emit('validation-change', true);
			} else {
				this.$emit('validation-change', false);
			}
			if (this.checkCoppa) {
				if (this.submitted) {
					this.$emit('coppa-valid', this.coppaValid);
				}
			}
		},
		submitted: function submitted(modifiedVal) {
			if (modifiedVal !== true) {
				return;
			}
			if (this.selectedMonth === null || this.selectedYear === null) {
				this.$emit('validation-change', true);
			} else {
				this.$emit('validation-change', false);
			}
			if (this.checkCoppa) {
				this.$emit('coppa-valid', this.coppaValid);
			}
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70f948c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@arena/toolkit/src/components/common/form-date.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dob-wrapper",class:{ 'has-error': _vm.hasError }},[(_vm.monthFirst)?_c('formSelect',{staticClass:"dob-month half-width",attrs:{"value":_vm.selectedMonth,"dontLocalize":true,"placeHolder":_vm.$t('create-account.select-month'),"options":_vm.monthsList,"enterHandler":_vm.textFieldEnterHandler,"filterable":true,"hasError":_vm.hasError,"labelText":''},on:{"change":_vm.updateSelectedMonth}}):_vm._e(),_vm._v(" "),_c('formSelect',{staticClass:"dob-year half-width",class:_vm.monthFirst ? 'right-side' : '',attrs:{"value":_vm.selectedYear,"dontLocalize":true,"placeHolder":_vm.$t('create-account.select-year'),"options":_vm.yearsList,"enterHandler":_vm.textFieldEnterHandler,"filterable":true,"hasError":_vm.hasError,"labelText":''},on:{"change":_vm.updateSelectedYear}}),_vm._v(" "),(!_vm.monthFirst)?_c('formSelect',{staticClass:"dob-month half-width",class:!_vm.monthFirst ? 'right-side' : '',attrs:{"value":_vm.selectedMonth,"dontLocalize":true,"placeHolder":_vm.$t('create-account.select-month'),"options":_vm.monthsList,"enterHandler":_vm.textFieldEnterHandler,"filterable":true,"hasError":_vm.hasError,"labelText":''},on:{"change":_vm.updateSelectedMonth}}):_vm._e(),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasError),expression:"hasError"}],staticClass:"help-block"},[_vm._v("\n\t\t"+_vm._s(_vm.$t('error.input.not-valid-dob'))+"\n\t")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_form_date = (esExports);
// CONCATENATED MODULE: ./node_modules/@arena/toolkit/src/components/common/form-date.vue
function injectStyle (ssrContext) {
  __webpack_require__("HvZD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  form_date,
  common_form_date,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_common_form_date = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LEAh":
/***/ (function(module, exports) {

module.exports = {"footer":{"aboutNexon":"O Nexon","support":"Wsparcie","careers":"Kariera","businessOpportunities":"Możliwości biznesowe","press":"Prasa","investorRelations":"Relacje inwestorskie","privacy":"Polityka prywatności","legalDoc":"Dokumentacja prawna","tou":"Warunki korzystania","eula":"Umowa licencyjna użytkownika końcowego","copyright":"©{0} NEXON Korea Corporation i NEXON America Inc. Wszelkie prawa zastrzeżone.","languages":{"es":"Español (LA)","en":"English","pt":"Português (BR)","de":"Deutsch","fr":"Français","it":"Italiano","pl":"Polski","tr":"Türkçe","th":"ภาษาไทย","zh":"Chiński","nl":"Dutch"},"regions":{"sea":"SEA","th":"Thailand","kr":"Korea","jp":"Japan","tw":"Taiwan","global":"Świat"}}}

/***/ }),

/***/ "LdM+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@arena/toolkit/src/components/common/accordion.vue
//
//
//
//
//
//

/* eslint-disable */
/* harmony default export */ var accordion = ({
	name: 'accordion',
	description: 'It can be used with panel component.',
	props: {
		oneAtAtime: {
			type: Boolean,
			default: false,
			note: "Open one accordion at once, no multiple open allowed"
		}
	},
	methods: {
		open: function open(child) {
			if (this.oneAtAtime) {
				this.$children.forEach(function (item) {
					if (child !== item) {
						item.open = false;
					}
				});
			}
		}
	},
	created: function created() {
		this.accordion = true;
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-749cd8d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@arena/toolkit/src/components/common/accordion.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-group"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_accordion = (esExports);
// CONCATENATED MODULE: ./node_modules/@arena/toolkit/src/components/common/accordion.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  accordion,
  common_accordion,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_common_accordion = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Lu/T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer",attrs:{"id":"launcher-footer"}},[_c('a',{staticClass:"nexon-logo-footer",attrs:{"href":_vm.portalUrl,"target":_vm.hrefTarget}},[_c('svgIcon',{attrs:{"iconHolderClass":"logo","iconId":"nexon-logo-full"}})],1),_vm._v(" "),_c('div',{staticClass:"copyright"},[_vm._v(_vm._s(_vm.$t('copyright', [_vm.currentYear])))]),_vm._v(" "),(_vm.region === 'global')?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.close),expression:"close"}],ref:"select",staticClass:"locale",class:{ 'show-languages': _vm.showLanguage }},[_c('div',{staticClass:"current-language",on:{"click":function($event){_vm.toggle();},"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }$event.stopPropagation();$event.preventDefault();return _vm.close($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.stopPropagation();$event.preventDefault();return _vm.toggle($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.stopPropagation();$event.preventDefault();return _vm.toggle($event)}]}},[_c('svgIcon',{attrs:{"iconHolderClass":"icon-locale","iconId":"icon-globe"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(("languages." + (_vm.$i18n.locale)))))])],1),_vm._v(" "),_c('ul',{staticClass:"languages list-unstyled",class:{ 'show-languages': _vm.showLanguage }},_vm._l((_vm.languageList),function(list){return _c('li',{key:list},[_c('a',{on:{"click":function($event){_vm.setLang(("" + (list.split('-')[0])));}}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.$t(("languages." + (list.split('-')[0]))))+"\n\t\t\t\t")])])}),0)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "M59s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@arena/toolkit/src/components/common/modal.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var modal = ({
	name: 'modal',
	description: 'You can assign the custom options for header and body and footer.',
	props: {
		modalTitle: {
			type: String,
			default: '',
			note: 'set modal title'
		},
		modalDescription: {
			type: String,
			default: '',
			note: 'Assign description in body'
		},
		showModal: {
			type: Boolean,
			default: false,
			note: 'Show or hide modal'
		},
		clickButtonPrimary: {
			type: Function,
			note: 'Assign function to primary button'
		},
		primaryButtonText: {
			type: String,
			default: '',
			note: 'Primary button label'
		},
		primaryButtonId: {
			type: String,
			default: '',
			note: 'Primary button ID'
		},
		secondaryButtonText: {
			type: String,
			default: '',
			note: 'Secondary button label'
		},
		secondaryButtonId: {
			type: String,
			default: '',
			note: 'Secondary button ID'
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7923836","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@arena/toolkit/src/components/common/modal.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal",class:{ 'show':_vm.showModal },attrs:{"id":"","tabindex":"-1","role":"dialog"}},[_c('div',{staticClass:"modal-dialog",class:{ 'show':_vm.showModal }},[_c('div',{staticClass:"modal-content"},[_vm._t("alert"),_vm._v(" "),_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('h4',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.modalTitle))])])],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body",[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.modalDescription)+"\n\t\t\t\t")])],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer")],2)],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_modal = (esExports);
// CONCATENATED MODULE: ./node_modules/@arena/toolkit/src/components/common/modal.vue
function injectStyle (ssrContext) {
  __webpack_require__("yxAE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e7923836"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  modal,
  common_modal,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_common_modal = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5b7c9f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("WuGU");
function injectStyle (ssrContext) {
  __webpack_require__("PcO3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5b7c9f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Mz7D":
/***/ (function(module, exports) {

module.exports = {"footer":{"aboutNexon":"About Nexon","support":"Support","careers":"Careers","businessOpportunities":"Business Opportunities","press":"Press","investorRelations":"Investor Relations","privacy":"Privacy Policy","legalDoc":"Legal Documentation","tou":"Terms of Use","eula":"End User License Agreement","copyright":"©{0} NEXON Korea Corporation and NEXON America Inc. All Rights Reserved.","languages":{"es":"Español (LA)","en":"English","pt":"Português (BR)","de":"Deutsch","fr":"Français","it":"Italiano","pl":"Polski","tr":"Türkçe","th":"ภาษาไทย","zh":"中文","nl":"Dutch"},"regions":{"sea":"SEA","th":"Thailand","kr":"Korea","jp":"Japan","tw":"Taiwan","global":"Global"}}}

/***/ }),

/***/ "NHnr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueHead = __webpack_require__("RZCy");

var _vueHead2 = _interopRequireDefault(_vueHead);

var _vueJsonp = __webpack_require__("qJdI");

var _vueJsonp2 = _interopRequireDefault(_vueJsonp);

var _vueCookie = __webpack_require__("K/Lq");

var _vueCookie2 = _interopRequireDefault(_vueCookie);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _vueMeta = __webpack_require__("p3jY");

var _vueMeta2 = _interopRequireDefault(_vueMeta);

var _vueModalDialogs = __webpack_require__("obEk");

var ModalDialogs = _interopRequireWildcard(_vueModalDialogs);

__webpack_require__("MU8w");

__webpack_require__("j1ja");

var _ravenJs = __webpack_require__("/Hyb");

var _ravenJs2 = _interopRequireDefault(_ravenJs);

var _vue3 = __webpack_require__("6fN7");

var _vue4 = _interopRequireDefault(_vue3);

var _vuelidate = __webpack_require__("ESwS");

var _vuelidate2 = _interopRequireDefault(_vuelidate);

__webpack_require__("smsM");

__webpack_require__("PW/D");

var _NotificationAPI = __webpack_require__("8Ygz");

var _NotificationAPI2 = _interopRequireDefault(_NotificationAPI);

var _App = __webpack_require__("M93x");

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__("YaEn");

var _router2 = _interopRequireDefault(_router);

var _store = __webpack_require__("IcnI");

var _store2 = _interopRequireDefault(_store);

var _i18n = __webpack_require__("+ChJ");

var _i18n2 = _interopRequireDefault(_i18n);

var _apiHelper = __webpack_require__("FUzw");

var _apiHelper2 = _interopRequireDefault(_apiHelper);

var _dialogHelper = __webpack_require__("U2hi");

var _dialogHelper2 = _interopRequireDefault(_dialogHelper);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_axios2.default.defaults.xsrfHeaderName = 'xsrf_default_overwritten'; // The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


_ravenJs2.default.config('https://948e5fdd713f424283f22a3ef0b58908@sentry.d.nexon.io/14', {
	release: "1.19.0",
	environment: "prod"
}).addPlugin(_vue4.default, _vue2.default).install();

_vue2.default.config.productionTip = false;

_vue2.default.use(_NotificationAPI2.default);
_vue2.default.use(_vueHead2.default);
_vue2.default.use(_vueJsonp2.default);
_vue2.default.use(_vueCookie2.default);
_vue2.default.use(_vueMeta2.default);
_vue2.default.use(ModalDialogs);
_vue2.default.use(_vuelidate2.default);

_vue2.default.use(_apiHelper2.default);
_vue2.default.use(_dialogHelper2.default);

_vue2.default.prototype.$http = _axios2.default.create({
	withCredentials: true
});

_vue2.default.mixin({
	data: function data() {
		return { region: environment.region };
	}
});
/* eslint-disable no-new */
window.App = new _vue2.default({
	el: '#app',
	i18n: _i18n2.default,
	router: _router2.default,
	store: _store2.default,
	silentTranslationWarn: true,
	template: '<App/>',
	components: {
		App: _App2.default
	},
	data: function data() {
		return {
			getData: {}
		};
	},

	methods: {
		setCookie: function setCookie() {
			var // returnURL = this.$route.query.return_url,
			prodId = this.$route.query.prod_id;

			// if (returnURL) {
			// 	this.$cookie.set('ReturnURL', returnURL, {
			// 		expires: '10m',
			// 	});
			// }
			if (prodId) {
				this.$cookie.set('ProdId', prodId);
				this.$store.commit('setProductId', prodId);
			}
		},
		addScript: function addScript(id, url) {
			return new _promise2.default(function (resolve, reject) {
				var g = document.createElement('script'),
				    s = document.getElementsByTagName('script')[0];
				if (document.getElementById(id)) return;
				g.id = id;
				g.src = url;
				g.onload = resolve;
				g.onerror = reject;
				g.defer = true;
				s.parentNode.insertBefore(g, s);
			});
		}
	},
	beforeCreate: function beforeCreate() {
		this.$store.dispatch('retrieveConfiguration');
	},
	mounted: function mounted() {
		this.setCookie();
	}
});

/***/ }),

/***/ "Nhc7":
/***/ (function(module, exports) {

module.exports = {"navigation":{"gameList":{"maplestory2":"MapleStory 2","maplestory":"MapleStory","hyperUniverse":"Hyper Universe","mabinogi":"Mabinogi","ridersOfIcarus":"Riders of Icarus","vindictus":"Vindictus","lawBreakers":"LawBreakers","counterStrikeZ":"Counter-Strike Nexon: Zombies","duelOfSummoners":"Duel of Summoners","treeOfSavior":"Tree of Savior","afterTheEnd":"After The End Forsaken Destiny","battleJack":"Battlejack","evilFactory":"Evil Factory","dominations":"DomiNations","dynastyWarriors":"Dynasty Warriors: Unleashed","hit":"HIT – Heroes of Incredible Tales","titanFall":"Titanfall Assault","pointBlankStrike":"PointBlank: Strike","masterOfEternity":"Master of Eternity","romanceOfTheThreeKingdoms":"Romance of the Three Kingdoms: The Legend of CaoCao","maplestoryBlitz":"MapleStory Blitz","returners":"Returners","sangokushiSousoudenOnline":"","mabinogiDuel":"Mabinogi Duel","tango5Reloaded":"Tango 5 Reloaded","darknessRises":"Darkness Rises","maplestoryM":"MapleStory M","durango":"Durango: Wild Lands","moonlightBlade":"Moonlight Blade"},"games":"Jeux","logIn":"Connexion","createAccount":"Créer compte","myAccount":"Mon compte","accountSetting":"Paramètres du compte","addBalance":"Ajout solde","reviewPurchase":"Validation achat","findGameCard":"Trouver une carte de jeu","nxGuide":"Guide des NX","logout":"Déconnexion","support":"Support","launcher":"Nexon Launcher","launcherDownLoad":"Téléchargement du Launcher","launcherDesc":"Jouez à tous vos jeux Nexon grâce au Launcher.","pcGames":"Jeux PC","mobileGames":"Jeux mobile"}}

/***/ }),

/***/ "Ns/l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-box dialog-mask"},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h4',{directives:[{name:"t",rawName:"v-t",value:({ path: _vm.title }),expression:"{ path: title }"}],staticClass:"modal-title"})]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t(_vm.errorMessageId, { errorCode: _vm.errorCode, lineBreak: '<br />' }))}}),_vm._v(" "),(_vm.showSupport)?_c('i18n',{attrs:{"path":"error.try_again_or_support","tag":"p"}},[_c('a',{attrs:{"place":"support","href":"https://support.nexon.net/hc/en-us/","target":"_blank","rel":"external"}},[_vm._v(_vm._s(_vm.$t('support')))])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"col-xs-6 pull-right"},[_c('FormButton',{staticClass:"btn-black",attrs:{"id":"modalPrimaryButtonId","buttonClick":_vm.click,"label":_vm.$t(_vm.closeLabel)}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OlVZ":
/***/ (function(module, exports) {

module.exports = {"navigation":{"gameList":{"maplestory2":"楓之谷 2","maplestory":"楓之谷","hyperUniverse":"超能宇宙","mabinogi":"瑪奇","ridersOfIcarus":"伊卡洛斯","vindictus":"新瑪奇英雄戰","lawBreakers":"LawBreakers","counterStrikeZ":"Counter-Strike Nexon: Zombies","duelOfSummoners":"瑪奇決戰","treeOfSavior":"救世者之樹","afterTheEnd":"After The End Forsaken Destiny","battleJack":"Battlejack","evilFactory":"惡魔工廠","dominations":"文明爭戰","dynastyWarriors":"真三國無雙 斬","hit":"HIT - 英雄之戰","titanFall":"泰坦降臨：突擊","pointBlankStrike":"無限戰場","masterOfEternity":"星光戰姬","romanceOfTheThreeKingdoms":"三國志:曹操傳","maplestoryBlitz":"楓之谷:突擊","returners":"回歸者","sangokushiSousoudenOnline":"三國志曹操傳 Online","mabinogiDuel":"瑪奇決戰","tango5Reloaded":"Tango 5 Reloaded","darknessRises":"暗黑復仇者 3","maplestoryM":"楓之谷M","durango":"Durango: Wild Lands","moonlightBlade":"天涯明月刀"},"games":"遊戲","logIn":"登入","createAccount":"建立帳號","myAccount":"我的帳號","accountSetting":"帳號設定","addBalance":"儲值點數","reviewPurchase":"查詢購買紀錄","findGameCard":"查詢遊戲點數卡","nxGuide":"NX 說明","logout":"登出","support":"服務與支援","launcher":"Nexon 啟動器","launcherDownLoad":"啟動器下載","launcherDesc":"在全球啟動器中遊玩您所有的Nexon遊戲。","pcGames":"PC Games","mobileGames":"Mobile Games"}}

/***/ }),

/***/ "P2cg":
/***/ (function(module, exports) {

module.exports = {"footer":{"aboutNexon":"Sobre a Nexon","support":"Suporte","careers":"Carreiras","businessOpportunities":"Oportunidades de Negócios","press":"Imprensa","investorRelations":"Relações com Investidores","privacy":"Política de Privacidade","legalDoc":"Documentação Jurídica","tou":"Termos de Uso","eula":"Contrato de Licença de Usuário Final","copyright":"©{0} NEXON Korea Corporation and NEXON America Inc. Todos os direitos reservados.","languages":{"es":"Español (LA)","en":"English","pt":"Português (BR)","de":"Deutsch","fr":"Français","it":"Italiano","pl":"Polski","tr":"Türkçe","th":"ภาษาไทย","zh":"Chinês","nl":"Dutch"},"regions":{"sea":"SEA","th":"Thailand","kr":"Korea","jp":"Japan","tw":"Taiwan","global":"Global"}}}

/***/ }),

/***/ "PcO3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QEZO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rt5s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@arena/toolkit/src/components/common/form-input.vue + 2 modules
var form_input = __webpack_require__("G+k6");

// EXTERNAL MODULE: ./node_modules/@arena/toolkit/src/components/common/icon-svg.vue + 2 modules
var icon_svg = __webpack_require__("EO4f");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@arena/toolkit/src/components/common/form-password.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var form_password = ({
	name: 'formPassword',
	introduction: 'Vuejs password input form component',
	components: {
		formInput: form_input["a" /* default */],
		svgIcon: icon_svg["default"]
	},
	props: {
		id: {
			type: String,
			value: null,
			note: 'Set element id'
		},
		enterHandler: {
			type: Function,
			value: null,
			note: 'Keyboard enter key handler'
		},
		value: {
			type: String,
			value: null,
			note: 'Assign input value'
		},
		submitted: {
			type: Boolean,
			value: false,
			note: 'Check submit state'
		}
	},
	data: function data() {
		return {
			showPass: false,
			internalValueCopy: ''
		};
	},

	methods: {
		handleInput: function handleInput(value) {
			this.internalValueCopy = value;
			this.$emit('input', value);
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-718e1f5f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@arena/toolkit/src/components/common/form-password.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('formInput',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showPass),expression:"!showPass"}],staticClass:"showable",attrs:{"value":_vm.value,"id":_vm.id,"name":"password","type":"password","submitted":_vm.submitted,"enterHandler":_vm.enterHandler,"minLength":8,"maxLength":32,"placeholder":_vm.$t('create-account.new-password')},on:{"input":_vm.handleInput,"validation-change":function($event){_vm.$emit('validation-change', $event)}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showPass),expression:"!showPass"}],staticClass:"toggle-show-pass icon-eye-open",on:{"click":function($event){_vm.showPass = true}}},[_c('svgIcon',{attrs:{"iconHolderClass":"toggle-show","iconId":"icon-eye-open"}})],1)]),_vm._v(" "),_c('formInput',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPass),expression:"showPass"}],staticClass:"showable",attrs:{"value":_vm.value,"id":((this.id) + "Show"),"name":"password","type":"text","submitted":_vm.submitted,"enterHandler":_vm.enterHandler,"minLength":8,"maxLength":32,"placeholder":_vm.$t('create-account.new-password')},on:{"input":_vm.handleInput}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPass),expression:"showPass"}],staticClass:"toggle-show-pass icon-eye-closed",on:{"click":function($event){_vm.showPass = false}}},[_c('svgIcon',{attrs:{"iconHolderClass":"toggle-show","iconId":"icon-eye-close"}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_form_password = (esExports);
// CONCATENATED MODULE: ./node_modules/@arena/toolkit/src/components/common/form-password.vue
function injectStyle (ssrContext) {
  __webpack_require__("Wprr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  form_password,
  common_form_password,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_common_form_password = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Tk1k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/@arena/toolkit/src/utils/click-outside.js
var click_outside = __webpack_require__("dzPF");
var click_outside_default = /*#__PURE__*/__webpack_require__.n(click_outside);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@arena/toolkit/src/components/common/form-select.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


var timeout = {};

/* harmony default export */ var form_select = ({
	name: 'formSelect',
	description: 'Support custom style and embedded mobile slelect option',
	directives: {
		clickOutside: click_outside_default.a
	},
	props: {
		hasError: {
			type: Boolean,
			default: false,
			note: 'Check error state'
		},
		closeOnSelect: {
			type: Boolean,
			default: false,
			note: 'Set the option close behavior'
		},
		disabled: {
			type: Boolean,
			default: false,
			note: 'Disable when it needed'
		},
		name: {
			type: String,
			default: null,
			note: 'Set attribute name'
		},
		id: {
			type: String,
			default: null,
			note: 'Set element id '
		},
		options: {
			type: Array,
			default: function _default() {
				return [];
			},

			note: 'Selectable option list'
		},
		optionsLabel: {
			type: String,
			default: 'label',
			note: 'Options label text'
		},
		optionsValue: {
			type: String,
			default: 'value',
			note: 'Options value'
		},
		parent: {
			default: true
		},
		placeHolder: {
			type: String,
			default: null,
			note: 'Place holder text'
		},
		readonly: {
			type: Boolean,
			default: null,
			note: 'Change read only'
		},
		required: {
			type: Boolean,
			default: null,
			note: 'Set input requried'
		},
		value: null,
		inputLarge: {
			type: Boolean,
			default: false,
			note: 'Change input element size to large'
		},
		inputSmall: {
			type: Boolean,
			default: false,
			note: 'Change input element size to small'
		},
		labelText: {
			type: String,
			default: null,
			note: 'From label text'
		},
		labelOption: {
			type: String,
			default: null,
			note: 'Additional text next to label text'
		},
		stringSelector: {
			type: String,
			default: null,
			note: 'Need to be assigned string selector to get localized text'
		},
		orderByLoco: {
			type: Boolean,
			default: false,
			note: 'Pption list ordering option'
		},
		dontLocalize: {
			type: Boolean,
			default: false,
			note: 'If it does not need localize '
		},
		filterable: {
			type: Boolean,
			default: false,
			note: 'Options filtering option'
		}
	},
	data: function data() {
		return {
			textFilter: '',
			list: [],
			loading: null,
			show: false,
			val: null,
			isMobile: this.$store.state.isMobile,
			highlightedOption: null
		};
	},

	computed: {
		classes: function classes() {
			return [{
				open: this.show,
				disabled: this.disabled
			}, this.class, this.elementNameClass];
		},
		elementNameClass: function elementNameClass() {
			if (this.isLi) return 'dropdown';
			if (this.inInput) return 'input-group-btn';
			return 'btn-group';
		},
		inInput: function inInput() {
			return this.$parent._input;
		},
		isLi: function isLi() {
			return;
			this.$parent._navbar || this.$parent.menu || this.$parent._tabset;
		},
		selected: function selected() {
			var _this = this;

			if (this.filteredList.length === 0) {
				var currentIndex = this.list.map(function (_ref) {
					var label = _ref.label,
					    value = _ref.value;
					return value;
				}).indexOf(this.highlightedOption);
				if (currentIndex === -1) {
					return this.placeHolder;
				}
				var currentLabel = this.list[currentIndex].label;
				if (this.dontLocalize) {
					return currentLabel;
				} else {
					return this.$t(this.stringSelector + '.' + currentLabel);
				}
			}
			var sel = this.values.map(function (val) {
				return (_this.filteredList.find(function (o) {
					return o[_this.optionsValue] === val;
				}) || {})[_this.optionsLabel];
			}).filter(function (val) {
				return val !== undefined;
			});
			this.$emit('selected', sel);
			if (this.dontLocalize) {
				return sel[0];
			} else {
				if (sel[0]) {
					return this.$t(this.stringSelector + '.' + sel.join(', '));
				} else {
					return this.placeholder;
				}
			}
		},
		showPlaceholder: function showPlaceholder() {
			return this.values.length === 0 ? this.placeHolder : null;
		},
		values: function values() {
			return this.val instanceof Array ? this.val : ~[null, undefined].indexOf(this.val) ? [] : [this.val];
		},
		optionListItems: function optionListItems() {
			if (this.orderByLoco) {
				return this.inLocoOrder;
			}
			return this.filteredList;
		},
		inLocoOrder: function inLocoOrder() {
			var _this2 = this;

			var sorted = this.filteredList.slice();
			sorted.sort(function (a, b) {
				return _this2.$t(_this2.stringSelector + '.' + a.label).localeCompare(_this2.$t(_this2.stringSelector + '.' + b.label));
			});
			return sorted;
		},
		filteredList: function filteredList() {
			var _this3 = this;

			if (!this.filterable) {
				return this.list;
			}
			var filtered = this.list.filter(function (_ref2) {
				var label = _ref2.label,
				    value = _ref2.value;
				return (_this3.dontLocalize ? label : _this3.$t(_this3.stringSelector + '.' + label)).toLowerCase().indexOf(_this3.textFilter.toLowerCase()) === 0;
			});
			return filtered;
		}
	},
	watch: {
		options: function options(modifiedOptions) {
			this.setOptions(modifiedOptions);
		},
		value: function value(val, old) {
			if (val !== old) {
				this.val = val;
			}
		},
		val: function val(_val, old) {
			if (_val === undefined) {
				this.val = _val = null;
			}
			if (_val !== old) {
				this.$emit('change', _val);
				this.$emit('input', _val);
				this.highlightedOption = _val;
			}
		}
	},
	methods: {
		transferFocusUp: function transferFocusUp() {
			var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
			// true on IE11; false on Edge and other IEs/browsers.
			if (isIE11) {
				this.$refs.btn.focus();
			}
		},
		select: function select(v, disabled) {
			if (disabled) {
				return;
			}
			this.val = v;
			this.close();
		},
		scrollSelectionIntoView: function scrollSelectionIntoView() {
			var _this4 = this;

			this.$nextTick(function () {
				return document.getElementById(_this4.val).scrollIntoView({ inline: "nearest", behavior: "smooth" });
			});
		},
		selectWithoutToggle: function selectWithoutToggle(v) {
			this.val = v;
			this.highlightedOption = v;
			this.scrollSelectionIntoView();
		},
		selectNextWithoutToggle: function selectNextWithoutToggle() {
			if (this.optionListItems.length === 0) {
				return;
			}
			if (this.highlightedOption === null) {
				this.selectWithoutToggle(this.optionListItems[0].value);
			} else {
				var prevIndex = this.optionListItems.map(function (_ref3) {
					var label = _ref3.label,
					    value = _ref3.value;
					return value;
				}).indexOf(this.highlightedOption);
				if (prevIndex === -1) {
					return;
				}
				if (prevIndex + 1 < this.optionListItems.length) {
					this.selectWithoutToggle(this.optionListItems[prevIndex + 1].value);
				}
			}
		},
		selectPrevWithoutToggle: function selectPrevWithoutToggle() {
			if (this.optionListItems.length === 0) {
				return;
			}
			if (this.highlightedOption === null) {
				this.selectWithoutToggle(this.optionListItems[this.optionListItems.length - 1].value);
			} else {
				var prevIndex = this.optionListItems.map(function (_ref4) {
					var label = _ref4.label,
					    value = _ref4.value;
					return value;
				}).indexOf(this.highlightedOption);
				if (prevIndex === -1) {
					return;
				}
				if (prevIndex - 1 >= 0) {
					this.selectWithoutToggle(this.optionListItems[prevIndex - 1].value);
				}
			}
		},
		setOptions: function setOptions(options) {
			this.list = options.filter(function (el) {
				return el instanceof Object;
			}).map(function (el) {
				return extends_default()({}, el);
			});
			this.$emit('options', this.list);
		},
		close: function close() {
			this.toggle(false);
		},
		open: function open() {
			this.toggle(true);
		},
		toggle: function toggle(openOrClosed) {
			if (this.disabled) return;
			this.show = typeof openOrClosed === 'boolean' ? openOrClosed : !this.show;
			if (!this.show) {
				this.$refs.btn.blur();
				this.clearFilter();
				this.$emit('closed');
			}
		},
		handleKeypress: function handleKeypress(event) {
			var key = event.key;
			if (key >= 'a' && key <= 'z' || key >= '0' && key <= '9' || key === '.') {
				this.textFilter = '' + this.textFilter + key;
				if (this.filteredList[0]) {
					this.selectWithoutToggle(this.filteredList[0][this.optionsValue]);
				}
			} else if (key === 'Backspace') {
				this.textFilter = this.textFilter.slice(0, -1);
				if (this.filteredList[0]) {
					this.selectWithoutToggle(this.filteredList[0][this.optionsValue]);
				}
			} else if (key === 'Tab') {
				this.close();
				this.$emit('keydown', { key: 'Tab' });
			} else if (key === 'ArrowUp') {
				this.selectPrevWithoutToggle();
				event.preventDefault();
			} else if (key === 'ArrowDown') {
				this.selectNextWithoutToggle();
				event.preventDefault();
			}
		},
		clearFilter: function clearFilter() {
			this.textFilter = '';
		}
	},
	created: function created() {
		this.setOptions(this.options);
		this.val = this.value;
		if (this.val === undefined || !this.parent) {
			this.val = null;
		}
		var parent = this.$parent;
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6aef4e8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@arena/toolkit/src/components/common/form-select.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isMobile === false)?_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.close),expression:"close"}],ref:"select",staticClass:"form-group",class:_vm.classes},[(_vm.labelText != '')?_c('label',{on:{"click":_vm.close}},[_vm._v("\n\t\t\t"+_vm._s(_vm.labelText)+"\n\t\t\t"),(_vm.labelOption != '')?_c('span',[_vm._v(_vm._s(_vm.labelOption))]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clear-fix"}),_vm._v(" "),_c('div',{ref:"btn",staticClass:"form-control select dropdown-toggle",class:{
				'input-lg': _vm.inputLarge,
				'input-sm': _vm.inputSmall,
				error: this.hasError
				},attrs:{"tabindex":"1","id":_vm.id,"disabled":_vm.disabled,"readonly":_vm.readonly},on:{"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }$event.stopPropagation();$event.preventDefault();return _vm.close($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.stopPropagation();$event.preventDefault();return _vm.toggle($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.stopPropagation();$event.preventDefault();return _vm.toggle($event)},function($event){$event.stopPropagation();return _vm.handleKeypress($event)}],"focus":_vm.open}},[_c('span',{staticClass:"btn-content",class:{
					'hidden': _vm.isMobile
				},domProps:{"innerHTML":_vm._s(_vm.loading ? _vm.loading : _vm.showPlaceholder || (_vm.disabled ? _vm.selectedText : _vm.selected))},on:{"click":_vm.transferFocusUp}}),_vm._v(" "),_c('span',{staticClass:"caret",on:{"click":_vm.transferFocusUp}})]),_vm._v(" "),_c('ul',{ref:"options",staticClass:"dropdown-menu",class:{
				'dropdown-lg': _vm.inputLarge,
				'input-sm': _vm.inputSmall
			},attrs:{"tabindex":"1"}},[(_vm.filteredList.length)?_vm._l((_vm.optionListItems),function(option){return _c('li',{class:{ 'disabled-item': option['disabled'] === true },attrs:{"id":option[_vm.optionsValue],"value":option[_vm.optionsValue]}},[_c('a',{class:{ 'highlight': _vm.highlightedOption === option[_vm.optionsValue] },on:{"mousedown":function($event){$event.preventDefault();_vm.select(option[_vm.optionsValue], option['disabled'])}}},[_c('span',[_vm._v(_vm._s(_vm.dontLocalize ? option[_vm.optionsLabel] : _vm.$t(_vm.stringSelector + '.' + option[_vm.optionsLabel])))])])])}):_vm._e()],2)]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('div',{staticClass:"form-group mobile"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.val),expression:"val"}],ref:"sel",staticClass:"form-control",class:{
				'hidden': !_vm.isMobile,
				error: this.hasError
				},attrs:{"name":_vm.name,"id":_vm.id,"required":_vm.required,"readonly":_vm.readonly,"disabled":_vm.disabled},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.val=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.optionListItems),function(option){return _c('option',{attrs:{"disabled":option['disabled'] === true},domProps:{"value":option[_vm.optionsValue]}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.dontLocalize ? option[_vm.optionsLabel] : _vm.$t(_vm.stringSelector + '.' + option[_vm.optionsLabel]))+"\n\t\t\t")])}),0),_vm._v(" "),_c('span',{staticClass:"btn-content placeholder",class:{
				'hidden': !_vm.isMobile && _vm.selected
			},domProps:{"innerHTML":_vm._s(_vm.loading ? _vm.loading : _vm.showPlaceholder || (_vm.disabled ? _vm.selectedText : _vm.selected))}}),_vm._v(" "),_c('span',{staticClass:"caret"})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_form_select = (esExports);
// CONCATENATED MODULE: ./node_modules/@arena/toolkit/src/components/common/form-select.vue
function injectStyle (ssrContext) {
  __webpack_require__("YOt9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f6aef4e8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  form_select,
  common_form_select,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_common_form_select = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TvNF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U+AH":
/***/ (function(module, exports) {

module.exports = {"navigation":{"gameList":{"maplestory2":"MapleStory 2","maplestory":"MapleStory","hyperUniverse":"Hyper Universe","mabinogi":"Mabinogi","ridersOfIcarus":"Riders of Icarus","vindictus":"Vindictus","lawBreakers":"LawBreakers","counterStrikeZ":"Counter-Strike Nexon: Zombies","duelOfSummoners":"Duel of Summoners","treeOfSavior":"Tree of Savior","afterTheEnd":"After The End Forsaken Destiny","battleJack":"Battlejack","evilFactory":"Evil Factory","dominations":"DomiNations","dynastyWarriors":"Dynasty Warriors: Unleashed","hit":"HIT – Heroes of Incredible Tales","titanFall":"Titanfall Assault","pointBlankStrike":"PointBlank: Strike","masterOfEternity":"Master of Eternity","romanceOfTheThreeKingdoms":"Romance of the Three Kingdoms: The Legend of CaoCao","maplestoryBlitz":"MapleStory Blitz","returners":"Returners","sangokushiSousoudenOnline":"","mabinogiDuel":"Mabinogi Duel","tango5Reloaded":"Tango 5 Reloaded","darknessRises":"Darkness Rises","maplestoryM":"MapleStory M","durango":"Durango: Wild Lands","moonlightBlade":"Moonlight Blade"},"games":"Spiele","logIn":"Anmelden","createAccount":"Konto erstellen","myAccount":"Mein Konto","accountSetting":"Kontoeinstellungen","addBalance":"Guthaben hinzufügen","reviewPurchase":"Kauf überprüfen","findGameCard":"Game Card kaufen","nxGuide":"Anleitung zu NX","logout":"Abmelden","support":"Support","launcher":"Nexon Launcher","launcherDownLoad":"Launcher runterladen","launcherDesc":"Spiele alle deine Nexon-Spiele mit einem Launcher.","pcGames":"PC-Spiele","mobileGames":"Mobile Games"}}

/***/ }),

/***/ "U2hi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _vueModalDialogs = __webpack_require__("obEk");

var _router = __webpack_require__("YaEn");

var _router2 = _interopRequireDefault(_router);

var _confirm = __webpack_require__("52fu");

var _confirm2 = _interopRequireDefault(_confirm);

var _error = __webpack_require__("7NE0");

var _error2 = _interopRequireDefault(_error);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var confirmDialog = (0, _vueModalDialogs.create)(_confirm2.default),
    errorDialog = (0, _vueModalDialogs.create)(_error2.default, 'errorCode'),
    errorDialogHandler = function errorDialogHandler(errorCode, i18nData) {
	if (false) console.error(errorCode);
	switch (errorCode) {
		case 'NEED_TO_SET_THE_PASSWORD':
			return confirmDialog({
				title: 'settings.social-link.need-password.title',
				content: _router2.default.app.$t('settings.social-link.need-password.desc', i18nData),
				confirmLabel: 'settings.social-link.need-password.create-password',
				confirmFunction: function confirmFunction() {
					return _router2.default.push({ name: 'create-change-password' });
				},
				cancelLabel: 'cancel'
			});
		default:
			return errorDialog(errorCode);
	}
},
    dialogHelper = {
	install: function install(vue) {
		vue.prototype.$dialog = { confirm: confirmDialog, error: errorDialogHandler };
	}
};

exports.default = dialogHelper;

/***/ }),

/***/ "VdXg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "W6ax":
/***/ (function(module, exports) {

module.exports = {"navigation":{"gameList":{"maplestory2":"MapleStory 2","maplestory":"MapleStory","hyperUniverse":"Hyper Universe","mabinogi":"Mabinogi","ridersOfIcarus":"Riders of Icarus","vindictus":"Vindictus","lawBreakers":"LawBreakers","counterStrikeZ":"Counter-Strike Nexon: Zombies","duelOfSummoners":"Duel of Summoners","treeOfSavior":"Tree of Savior","afterTheEnd":"After The End Forsaken Destiny","battleJack":"Battlejack","evilFactory":"Evil Factory","dominations":"DomiNations","dynastyWarriors":"Dynasty Warriors: Unleashed","hit":"HIT – Heroes of Incredible Tales","titanFall":"Titanfall Assault","pointBlankStrike":"PointBlank: Strike","masterOfEternity":"Master of Eternity","romanceOfTheThreeKingdoms":"Romance of the Three Kingdoms: The Legend of CaoCao","maplestoryBlitz":"MapleStory Blitz","returners":"Returners","sangokushiSousoudenOnline":"","mabinogiDuel":"Mabinogi Duel","tango5Reloaded":"Tango 5 Reloaded","darknessRises":"Darkness Rises","maplestoryM":"MapleStory M","durango":"Durango: Wild Lands","moonlightBlade":"Moonlight Blade"},"games":"Giochi","logIn":"Accedi","createAccount":"Crea il tuo account","myAccount":"Il mio account","accountSetting":"Impostazioni account","addBalance":"Aggiungi saldo","reviewPurchase":"Rivedi acquisto","findGameCard":"Trova una carta di gioco","nxGuide":"Guida NX","logout":"Disconnessione","support":"Assistenza","launcher":"Nexon Launcher","launcherDownLoad":"Scarica Launcher","launcherDesc":"Gioca a tutti i giochi Nexon nel launcher globale.","pcGames":"Giochi per PC","mobileGames":"Giochi per dispositivo mobile"}}

/***/ }),

/***/ "Wprr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WuGU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[(!_vm.hideError && _vm.getNotificationString(_vm.notificationList))?_c('div',{staticClass:"alert alert-danger text-center",attrs:{"id":"errorContainer","role":"alert"}},[_c('div',{staticClass:"error-section"},[_c('svgIcon',{attrs:{"iconHolderClass":"icon-warning","iconId":"icon-warning"}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.getNotificationString(_vm.notificationList))}})],1),_vm._v(" "),_vm._t("default")],2):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"appear":"","name":"fade","mode":"out-in"}},[(_vm.$store.state.loading)?_c('div',{staticClass:"page-spinner-wrapper main-spinner"},[_c('span',{staticClass:"spinner-circle"})]):_c('router-view',{staticClass:"body",attrs:{"name":"body"}})],1),_vm._v(" "),_c('dialogs-wrapper',{attrs:{"transition-name":"fade"}}),_vm._v(" "),((_vm.isLauncher && !_vm.checkSettingPageIn) || _vm.isSteamConnector || (_vm.isToy && _vm.region === 'global'))?_c('globalFooter'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Xbua":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _iconSvg = __webpack_require__("EO4f");

var _iconSvg2 = _interopRequireDefault(_iconSvg);

var _clickOutside = __webpack_require__("0OET");

var _clickOutside2 = _interopRequireDefault(_clickOutside);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var localeLookup = {
	de: 'de_DE',
	en: 'en_US',
	es: 'es_419',
	fr: 'fr_FR',
	it: 'it_IT',
	pl: 'pl_PL',
	pt: 'pt_BR',
	th: 'th_TH',
	tr: 'tr_TR',
	zh: 'zh_TW'
};

exports.default = {
	name: 'globalFooter',
	components: {
		svgIcon: _iconSvg2.default
	},
	directives: {
		clickOutside: _clickOutside2.default
	},
	data: function data() {
		return {
			currentYear: new Date().getFullYear(),
			showLanguage: false
		};
	},

	computed: {
		portalUrl: function portalUrl() {
			return this.$store.state.configurations.portal_url;
		},
		hrefTarget: function hrefTarget() {
			return this.$store.state.channel === 'web' ? '_self' : '_blank';
		},
		logoutUrl: function logoutUrl() {
			return '/account/' + this.$i18n.locale + '/logout';
		},
		languageList: function languageList() {
			return this.$store.state.configurations.languages;
		}
	},
	methods: {
		close: function close() {
			this.showLanguage = false;
		},
		toggle: function toggle() {
			this.showLanguage = !this.showLanguage;
		},
		select: function select() {
			this.toggle();
		},
		setLang: function setLang(lang) {
			this.$i18n.locale = lang;
			this.$cookie.set('i18next', this.$i18n.locale);
			this.showLanguage = false;
			if (typeof window.launcherData !== 'undefined') {
				// The following function is injected into window by the launcher
				window.launcherLanguageChange(localeLookup[lang]);
			}
			this.$router.push({ params: { locale: lang } });
		}
	}
};

/***/ }),

/***/ "YOt9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _store = __webpack_require__("IcnI");

var _store2 = _interopRequireDefault(_store);

var _routes = __webpack_require__("3kZz");

var _routes2 = _interopRequireDefault(_routes);

var _i18n = __webpack_require__("+ChJ");

var _i18n2 = _interopRequireDefault(_i18n);

var _locales = __webpack_require__("3lXs");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);
var router = new _vueRouter2.default({
	mode: 'history',
	base: '/account/',
	routes: _routes2.default,
	// when page transitioning, need to fix scroll position
	scrollBehavior: function scrollBehavior(to, from, savedPosition) {
		if (to.hash) {
			return {
				selector: to.hash
			};
		}
		return !savedPosition ? { x: 0, y: 0 } : savedPosition;
	}
});

function lazyLoadLocale(locale) {
	__webpack_require__("DX4b")("./" + _locales.localeCodes[locale] + '.json').then(function (msgs) {
		_i18n2.default.setLocaleMessage(locale, msgs.default || msgs);
		_i18n2.default.locale = locale;
	}).catch(function () {
		return false;
	});
}

function setRouteCookies(to) {
	var routeLang = to.params.locale,
	    returnURL = to.query.return_url,
	    prodId = to.query.prod_id,
	    partnerKey = to.query.partnerkey || to.query.partner_key,
	    cookieLang = _vue2.default.cookie.get('i18next');

	if (!cookieLang && routeLang) {
		_vue2.default.cookie.set('i18next', routeLang);
	}
	if (returnURL) {
		_vue2.default.cookie.set('ReturnURL', returnURL);
	}
	if (prodId) {
		_vue2.default.cookie.set('ProdId', prodId);
		_store2.default.commit('setProductId', prodId);
	}
	if (partnerKey) {
		_vue2.default.cookie.set('partner_key', partnerKey);
		_store2.default.commit('setPartnerKey', partnerKey);
	}
}

router.beforeEach(function (to, from, next) {
	var routeLang = to.params.locale,
	    referrerUrl = document.referrer,
	    appType = to.query.app_type,
	    returnUrl = location.protocol + '//' + location.host + '/account' + to.fullPath;

	if (to.name) {
		document.body.className = to.name.toLowerCase();
	}
	if (referrerUrl) {
		// Store it if it's a nexon.com URL but NOT from the current site
		if (referrerUrl.indexOf('nexon.com') > 0 && !new URL(referrerUrl).pathname.startsWith('/account/')) {
			_store2.default.commit('setReferrerUrl', referrerUrl);
		}
	}
	setRouteCookies(to);
	lazyLoadLocale(routeLang);

	if (appType) {
		_store2.default.commit('setAppType', appType);
	}

	if (to.matched.some(function (record) {
		return record.meta.requireSettingsInfo;
	})) {
		_store2.default.commit('setLoading', true);
		router.app.$accountAPI.get('/account?_t=' + Date.now()).then(function (response) {
			if (!response.data.status) {
				_store2.default.commit('setSettingsData', response.data);
			}
			next();
		}, function (errorCode) {
			console.log('router:', 'requireSettingsInfo', errorCode);
			next({
				name: 'login',
				query: {
					return_url: returnUrl
				},
				params: to.params
			});
		}).finally(function () {
			_store2.default.commit('setLoading', false);
		});
		return;
	}

	if (to.matched.some(function (record) {
		return record.meta.requiresLogin;
	})) {
		_store2.default.commit('setLoading', true);
		router.app.$accountAPI.get('/login/status?_t=' + Date.now()).then(function () {
			next();
		}, function (errorCode) {
			console.log('router:', 'requiresLogin', errorCode);
			next({
				name: 'login',
				query: {
					return_url: returnUrl
				},
				params: to.params
			});
		}).finally(function () {
			_store2.default.commit('setLoading', false);
		});
		return;
	}

	next();
});

exports.default = router;

/***/ }),

/***/ "ZiVs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a+vl":
/***/ (function(module, exports) {

module.exports = {"navigation":{"gameList":{"maplestory2":"MapleStory 2","maplestory":"MapleStory","hyperUniverse":"Hyper Universe","mabinogi":"Mabinogi","ridersOfIcarus":"Riders of Icarus","vindictus":"Vindictus","lawBreakers":"LawBreakers","counterStrikeZ":"Counter-Strike Nexon: Zombies","duelOfSummoners":"Duel of Summoners","treeOfSavior":"Tree of Savior","afterTheEnd":"After The End Forsaken Destiny","battleJack":"Battlejack","evilFactory":"Evil Factory","dominations":"DomiNations","dynastyWarriors":"Dynasty Warriors: Unleashed","hit":"HIT – Heroes of Incredible Tales","titanFall":"Titanfall Assault","pointBlankStrike":"PointBlank: Strike","masterOfEternity":"Master of Eternity","romanceOfTheThreeKingdoms":"Romance of the Three Kingdoms: The Legend of CaoCao","maplestoryBlitz":"MapleStory Blitz","returners":"Returners","sangokushiSousoudenOnline":"","mabinogiDuel":"Mabinogi Duel","tango5Reloaded":"Tango 5 Reloaded","darknessRises":"Darkness Rises","maplestoryM":"MapleStory M","durango":"Durango: Wild Lands","moonlightBlade":"Moonlight Blade"},"games":"เกม","logIn":"เข้าสู่ระบบ","createAccount":"สร้างบัญชี","myAccount":"บัญชีของคุณ","accountSetting":"การตั้งค่าบัญชี","addBalance":"เติมเงิน","reviewPurchase":"ประวัติการเติมเงิน","findGameCard":"หาบัตรเติมเงิน","nxGuide":"NX Guide","logout":"ออกจากระบบ","support":"ช่วยเหลือ","launcher":"Nexon Launcher","launcherDownLoad":"ดาวน์โหลด Launcher","launcherDesc":"เล่นเกมของ Nexon ทั้งหมดได้ใน Nexon Launcher","pcGames":"เกม PC","mobileGames":"เกมมือถือ"}}

/***/ }),

/***/ "abZ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_global_footer_vue__ = __webpack_require__("Xbua");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_global_footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_global_footer_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_global_footer_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_global_footer_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a3a1110_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_global_footer_vue__ = __webpack_require__("Lu/T");
function injectStyle (ssrContext) {
  __webpack_require__("TvNF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a3a1110"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_global_footer_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a3a1110_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_global_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "alqS":
/***/ (function(module, exports) {

module.exports = {"navigation":{"gameList":{"maplestory2":"MapleStory 2","maplestory":"MapleStory","hyperUniverse":"Hyper Universe","mabinogi":"Mabinogi","ridersOfIcarus":"Riders of Icarus","vindictus":"Vindictus","lawBreakers":"LawBreakers","counterStrikeZ":"Counter-Strike Nexon: Zombies","duelOfSummoners":"Duel of Summoners","treeOfSavior":"Tree of Savior","afterTheEnd":"After The End Forsaken Destiny","battleJack":"Battlejack","evilFactory":"Evil Factory","dominations":"DomiNations","dynastyWarriors":"Dynasty Warriors: Unleashed","hit":"HIT – Heroes of Incredible Tales","titanFall":"Titanfall Assault","pointBlankStrike":"PointBlank: Strike","masterOfEternity":"Master of Eternity","romanceOfTheThreeKingdoms":"RTK: The Legend of CaoCao","maplestoryBlitz":"MapleStory Blitz","returners":"Returners","sangokushiSousoudenOnline":"","mabinogiDuel":"Mabinogi Duel","tango5Reloaded":"Tango 5 Reloaded","darknessRises":"Darkness Rises","maplestoryM":"MapleStory M","durango":"Durango: Wild Lands","moonlightBlade":"Moonlight Blade"},"games":"Games","logIn":"Aanmelden","createAccount":"Account maken","myAccount":"Mijn account","accountSetting":"Accountinstellingen","addBalance":"Saldo toevoegen","reviewPurchase":"Aankoop controleren","findGameCard":"Een gamecard zoeken","nxGuide":"NX-gids","logout":"Afmelden","support":"Ondersteuning","launcher":"Nexon Launcher","launcherDownLoad":"Launcher downloaden","launcherDesc":"Speel al je Nexon-games via de wereldwijde launcher.","pcGames":"PC-games","mobileGames":"Mobiele games"}}

/***/ }),

/***/ "az0N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _toolkit = __webpack_require__("5w4A");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	components: {
		ModalMultiButtons: _toolkit.ModalMultiButtons
	},
	props: {
		title: String,
		content: String,
		confirmLabel: {
			type: String,
			default: 'Ok'
		},
		confirmResult: {
			default: true
		},
		confirmFunction: {
			type: Function,
			default: null
		},
		cancelLabel: {
			type: String,
			default: ''
		},
		cancelResult: {
			default: false
		},
		i18nData: {
			type: Object,
			default: function _default() {}
		}
	},
	data: function data() {
		return {
			loading: false
		};
	},

	methods: {
		clickYes: function () {
			var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
				return _regenerator2.default.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.prev = 0;

								if (!this.confirmFunction) {
									_context.next = 6;
									break;
								}

								this.loading = true;
								_context.next = 5;
								return this.confirmFunction();

							case 5:
								this.confirmResult = _context.sent;

							case 6:
								this.$close(this.confirmResult);
								_context.next = 12;
								break;

							case 9:
								_context.prev = 9;
								_context.t0 = _context['catch'](0);

								this.$error(_context.t0);

							case 12:
							case 'end':
								return _context.stop();
						}
					}
				}, _callee, this, [[0, 9]]);
			}));

			function clickYes() {
				return _ref.apply(this, arguments);
			}

			return clickYes;
		}(),
		clickNo: function clickNo() {
			this.$close(this.cancelResult);
		}
	}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "b9Fc":
/***/ (function(module, exports) {

module.exports = {"navigation":{"gameList":{"maplestory2":"MapleStory 2","maplestory":"MapleStory","hyperUniverse":"Hyper Universe","mabinogi":"Mabinogi","ridersOfIcarus":"Riders of Icarus","vindictus":"Vindictus","lawBreakers":"LawBreakers","counterStrikeZ":"Counter-Strike Nexon: Zombies","duelOfSummoners":"Duel of Summoners","treeOfSavior":"Tree of Savior","afterTheEnd":"After The End Forsaken Destiny","battleJack":"Battlejack","evilFactory":"Evil Factory","dominations":"DomiNations","dynastyWarriors":"Dynasty Warriors: Unleashed","hit":"HIT – Heroes of Incredible Tales","titanFall":"Titanfall Assault","pointBlankStrike":"PointBlank: Strike","masterOfEternity":"Master of Eternity","romanceOfTheThreeKingdoms":"Romance of the Three Kingdoms: The Legend of CaoCao","maplestoryBlitz":"MapleStory Blitz","returners":"Returners","sangokushiSousoudenOnline":"","mabinogiDuel":"Mabinogi Duel","tango5Reloaded":"Tango 5 Reloaded","darknessRises":"Darkness Rises","maplestoryM":"MapleStory M","durango":"Durango: Wild Lands","moonlightBlade":"Moonlight Blade"},"games":"Oyunlar","logIn":"Giriş yap","createAccount":"Hesap Oluştur","myAccount":"Hesabım","accountSetting":"Hesap Ayarları","addBalance":"Bakiye Ekle","reviewPurchase":"Satın Alımı Göster","findGameCard":"Bir oyun kartı bulun","nxGuide":"NX Rehberi","logout":"Çıkış yap","support":"Destek","launcher":"Nexon Launcher","launcherDownLoad":"Launcher'ı İndir","launcherDesc":"Tüm Nexon oyunlarınızı küresel bir başlatıcıda oynayın.","pcGames":"PC Oyunları","mobileGames":"Mobil Oyunlar"}}

/***/ }),

/***/ "boQf":
/***/ (function(module, exports) {

module.exports = {"navigation":{"gameList":{"maplestory2":"MapleStory 2","maplestory":"MapleStory","hyperUniverse":"Hyper Universe","mabinogi":"Mabinogi","ridersOfIcarus":"Riders of Icarus","vindictus":"Vindictus","lawBreakers":"LawBreakers","counterStrikeZ":"Counter-Strike Nexon: Zombies","duelOfSummoners":"Duel of Summoners","treeOfSavior":"Tree of Savior","afterTheEnd":"After The End Forsaken Destiny","battleJack":"Battlejack","evilFactory":"Evil Factory","dominations":"DomiNations","dynastyWarriors":"Dynasty Warriors: Unleashed","hit":"HIT – Heroes of Incredible Tales","titanFall":"Titanfall Assault","pointBlankStrike":"PointBlank: Strike","masterOfEternity":"Master of Eternity","romanceOfTheThreeKingdoms":"Romance of the Three Kingdoms: The Legend of CaoCao","maplestoryBlitz":"MapleStory Blitz","returners":"Returners","sangokushiSousoudenOnline":"","mabinogiDuel":"Mabinogi Duel","tango5Reloaded":"Tango 5 Reloaded","darknessRises":"Darkness Rises","maplestoryM":"MapleStory M","durango":"Durango: Wild Lands","moonlightBlade":"Moonlight Blade"},"games":"Jogos","logIn":"Entrar","createAccount":"Criar Conta","myAccount":"Minha Conta","accountSetting":"Configurações da Conta","addBalance":"Adicionar Saldo","reviewPurchase":"Reavaliar Compra","findGameCard":"Ache um cartão de jogo","nxGuide":"Guia NX","logout":"Sair","support":"Suporte","launcher":"Nexon Launcher","launcherDownLoad":"Download do Launcher","launcherDesc":"Jogue todos os seus jogos da Nexon no launcher global.","pcGames":"Jogos de PC","mobileGames":"Jogos para dispositivos móveis"}}

/***/ }),

/***/ "diDF":
/***/ (function(module, exports) {

module.exports = {"navigation":{"gameList":{"maplestory2":"MapleStory 2","maplestory":"MapleStory","hyperUniverse":"Hyper Universe","mabinogi":"Mabinogi","ridersOfIcarus":"Riders of Icarus","vindictus":"Vindictus","lawBreakers":"LawBreakers","counterStrikeZ":"Counter-Strike Nexon: Zombies","duelOfSummoners":"Duel of Summoners","treeOfSavior":"Tree of Savior","afterTheEnd":"After The End Forsaken Destiny","battleJack":"Battlejack","evilFactory":"Evil Factory","dominations":"DomiNations","dynastyWarriors":"Dynasty Warriors: Unleashed","hit":"HIT – Heroes of Incredible Tales","titanFall":"Titanfall Assault","pointBlankStrike":"PointBlank: Strike","masterOfEternity":"Master of Eternity","romanceOfTheThreeKingdoms":"Romance of the Three Kingdoms: The Legend of CaoCao","maplestoryBlitz":"MapleStory Blitz","returners":"Returners","sangokushiSousoudenOnline":"","mabinogiDuel":"Mabinogi Duel","tango5Reloaded":"Tango 5 Reloaded","darknessRises":"Darkness Rises","maplestoryM":"MapleStory M","durango":"Durango: Wild Lands","moonlightBlade":"Moonlight Blade"},"games":"Gry","logIn":"Zaloguj","createAccount":"Stwórz konto","myAccount":"Moje konto","accountSetting":"Ustawienia konta","addBalance":"Dodaj środki","reviewPurchase":"Przegląd zakupu","findGameCard":"Kup kartę przedpłaconą","nxGuide":"Poradnik NX","logout":"Wyloguj","support":"Wsparcie","launcher":"Nexon Launcher","launcherDownLoad":"Pobieranie aplikacji Launcher","launcherDesc":"Zyskaj dostęp do wszystkich gier Nexon dzięki temu globalnemu programowi uruchamiającemu.","pcGames":"Gry komputerowe","mobileGames":"Gry mobilne"}}

/***/ }),

/***/ "efOz":
/***/ (function(module, exports) {

module.exports = {"footer":{"aboutNexon":"Über Nexon","support":"Support","careers":"Karriere","businessOpportunities":"Geschäftlicher Kontakt","press":"Presse","investorRelations":"Investor Relations","privacy":"Datenschutzrichtlinie","legalDoc":"Rechtliche Hinweise","tou":"Nutzungsbedingungen","eula":"Endbenutzerlizenzvereinbarung","copyright":"©{0} NEXON Korea Corporation und NEXON America Inc. Alle Rechte vorbehalten.","languages":{"es":"Español (LA)","en":"English","pt":"Português (BR)","de":"Deutsch","fr":"Français","it":"Italiano","pl":"Polski","tr":"Türkçe","th":"ภาษาไทย","zh":"Chinesisch","nl":"Dutch"},"regions":{"sea":"Südostasien","th":"Thailand","kr":"Korea","jp":"Japan","tw":"Taiwan","global":"International"}}}

/***/ }),

/***/ "eqgD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_global_footer_vue__ = __webpack_require__("G/83");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_global_footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_global_footer_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_global_footer_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_global_footer_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_672e795e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_global_footer_vue__ = __webpack_require__("A9iO");
function injectStyle (ssrContext) {
  __webpack_require__("ygcn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-672e795e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_global_footer_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_672e795e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_global_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "fVip":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "j+p7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jSmg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _iconSprite = __webpack_require__("FOgX");

var _iconSprite2 = _interopRequireDefault(_iconSprite);

var _iconSvg = __webpack_require__("EO4f");

var _iconSvg2 = _interopRequireDefault(_iconSvg);

var _clickOutside = __webpack_require__("dzPF");

var _clickOutside2 = _interopRequireDefault(_clickOutside);

var _configNavigation = __webpack_require__("AobU");

var _configNavigation2 = _interopRequireDefault(_configNavigation);

var _configDownloadLauncher = __webpack_require__("s5tN");

var _configDownloadLauncher2 = _interopRequireDefault(_configDownloadLauncher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	name: 'navTop',
	components: {
		svgIcons: _iconSprite2.default,
		svgIcon: _iconSvg2.default
	},
	directives: {
		clickOutside: _clickOutside2.default
	},
	data: function data() {
		return {
			imageHost: '../../static/static/images',
			isActive: false,
			isLoggedIn: false,
			openMyAccountDropDown: false,
			openSideBar: false,
			openPcGames: false,
			openMobileGames: false,
			myAccountList: _configNavigation2.default.myAccount,
			pcGameList: null,
			mobileGameList: null,
			supportLink: _configNavigation2.default.supportLinks,
			nexonHome: _configNavigation2.default.nexonHome,
			domain: _configNavigation2.default.domain,
			login: _configNavigation2.default.login,
			createAccount: _configNavigation2.default.createAccount
		};
	},

	computed: {
		classes: function classes() {
			return [this.region, this.language];
		},
		region: function region() {
			return environment.region;
		},
		language: function language() {
			return this.$i18n.locale;
		},
		isMObile: function isMObile() {
			return (/(iPhone|iPad|Android)/ig.test(navigator.userAgent)
			);
		}
	},
	methods: {
		getLocaleString: function getLocaleString(data) {
			if (!data) return '';
			if ((0, _keys2.default)(data).length === 0) return '';
			return data[this.$i18n.locale] || data[(0, _keys2.default)(data)[0]];
		},
		closeMyAccount: function closeMyAccount() {
			this.openMyAccountDropDown = false;
		},
		closeSidebar: function closeSidebar() {
			this.openSideBar = false;
		},
		togglePcGames: function togglePcGames() {
			this.openPcGames = !this.openPcGames;
		},
		toggleMobileGames: function toggleMobileGames() {
			this.openMobileGames = !this.openMobileGames;
		},
		toggleSidebar: function toggleSidebar() {
			this.openSideBar = !this.openSideBar;
		},
		toggleDropDown: function toggleDropDown() {
			this.openMyAccountDropDown = !this.openMyAccountDropDown;
		},
		toggleGameList: function toggleGameList() {
			this.isActive = !this.isActive;
		},
		downloadLauncher: function downloadLauncher() {
			var _this = this;

			var getLauncherType = function getLauncherType() {
				if (_this.region === 'global') {
					return '';
				}
				return '_' + _this.region.toUpperCase();
			},
			    launcherType = getLauncherType(),
			    partnerKey = this.getParameterByName('partnerkey'),
			    base = new URL(_configDownloadLauncher2.default.LauncherDownloadHost["prod"]);

			base.searchParams.set('file', 'NexonLauncherSetup' + launcherType + '.exe');

			if (typeof window.ga.getAll === 'function') {
				base.searchParams.set('client-id', '' + window.ga.getAll()[0].get('clientId'));
			}
			if (partnerKey) {
				base.searchParams.set('partnerkey', partnerKey);
			}
			window.location = base.href;
		},
		getParameterByName: function getParameterByName(name, url) {
			if (!url) url = window.location.href;
			name = name.replace(/[[\]]/g, '\\$&');
			var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
			    results = regex.exec(url);
			if (!results) return null;
			if (!results[2]) return '';
			return decodeURIComponent(results[2].replace(/\+/g, ' '));
		},
		setLang: function setLang(lang) {
			this.$i18n.locale = lang;
		},
		getLoginStatus: function getLoginStatus() {
			var _this2 = this;

			var configure = { headers: { 'Cache-Control': 'no-cache, no-store', Pragma: 'no-cache', Expires: 0 } };

			return this.$http.get(this.domain[this.region] + '/account-webapi/login/status', configure).then(function () {
				_this2.isLoggedIn = true;
			}).catch(function () {
				_this2.isLoggedIn = false;
			});
		}
	},
	created: function created() {
		var _this3 = this;

		var getUrl = window.location;

		this.setLang(getUrl.pathname.split('/')[2]);
		this.loginCheckPromise = this.getLoginStatus();
		_promise2.default.all([this.$cdnAPI.getPCList(), this.$cdnAPI.getMobileList()]).then(function (d) {
			_this3.pcGameList = d[0];
			_this3.mobileGameList = d[1];
		});
	}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "jn4Q":
/***/ (function(module, exports) {

module.exports = {"footer":{"aboutNexon":"Nexon Hakkında","support":"Destek","careers":"Kariyer","businessOpportunities":"İş Olanakları","press":"Basın","investorRelations":"Yatırımcı İlişkileri","privacy":"Gizlilik Politikası","legalDoc":"Yasal Belgeler","tou":"Kullanım Şartları","eula":"Son Kullanıcı Lisans Anlaşması","copyright":"©{0} NEXON Korea Corporation ve NEXON America Inc. Tüm Hakları Saklıdır.","languages":{"es":"Español (LA)","en":"English","pt":"Português (BR)","de":"Deutsch","fr":"Français","it":"Italiano","pl":"Polski","tr":"Türkçe","th":"ภาษาไทย","zh":"中文","nl":"Dutch"},"regions":{"sea":"SEA","th":"Thailand","kr":"Korea","jp":"Japan","tw":"Taiwan","global":"Küresel"}}}

/***/ }),

/***/ "mVvc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Loading_vue__ = __webpack_require__("Hgy7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Loading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Loading_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Loading_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Loading_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_07fae1cb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Loading_vue__ = __webpack_require__("H6HN");
function injectStyle (ssrContext) {
  __webpack_require__("1cKC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-07fae1cb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Loading_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_07fae1cb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "meBj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _toolkit = __webpack_require__("5w4A");

exports.default = {
	components: {
		FormButton: _toolkit.FormButton
	},
	props: {
		title: {
			type: String,
			default: 'dialog.title.error'
		},
		errorCode: {
			type: String,
			default: '00000'
		},
		closeLabel: {
			type: String,
			default: 'close'
		}
	},
	computed: {
		errorMessageId: function errorMessageId() {
			var msgId = 'error.form.' + this.errorCode;
			if (msgId === this.$t(msgId)) {
				return 'error.form.GENERAL';
			}
			return msgId;
		},
		showSupport: function showSupport() {
			return this.errorMessageId === 'error.form.GENERAL';
		}
	},
	methods: {
		click: function click() {
			this.$close(true);
		}
	}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "ns8J":
/***/ (function(module, exports) {

module.exports = {"footer":{"aboutNexon":"Over Nexon","support":"Ondersteuning","careers":"Carrières","businessOpportunities":"Zakelijke mogelijkheden","press":"Pers","investorRelations":"Investeerdersrelaties","privacy":"Privacybeleid","legalDoc":"Juridische documentatie","tou":"Algemene voorwaarden","eula":"Licentie-overeenkomst eindgebruiker","copyright":"©{0} NEXON Korea Corporation en NEXON America Inc. Alle rechten voorbehouden.","languages":{"es":"Español (LA)","en":"English","pt":"Português (BR)","de":"Deutsch","fr":"Français","it":"Italiano","pl":"Polski","tr":"Türkçe","th":"ภาษาไทย","zh":"中文","nl":"Nederlands"},"regions":{"sea":"Zuidoost-Azië","th":"Thailand","kr":"Korea","jp":"Japan","tw":"Taiwan","global":"Wereldwijd"}}}

/***/ }),

/***/ "o2FB":
/***/ (function(module, exports) {

module.exports = {"footer":{"aboutNexon":"À propos de Nexon","support":"Support","careers":"Carrière","businessOpportunities":"Affaires","press":"Presse","investorRelations":"Investisseurs","privacy":"Déclaration de confidentialité","legalDoc":"Documents légaux","tou":"Conditions d'utilisation","eula":"Contrat de Licence Utilisateur Final","copyright":"©{0} NEXON Korea Corporation et NEXON America Inc. Tous droits réservés.","languages":{"es":"Español (LA)","en":"English","pt":"Português (BR)","de":"Deutsch","fr":"Français","it":"Italiano","pl":"Polski","tr":"Türkçe","th":"ภาษาไทย","zh":"Chinois","nl":"Dutch"},"regions":{"sea":"SEA","th":"Thailand","kr":"Korea","jp":"Japan","tw":"Taiwan","global":"Global"}}}

/***/ }),

/***/ "oPmM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ob/X":
/***/ (function(module, exports) {

module.exports = {"navigation":{"gameList":{"maplestory2":"MapleStory 2","maplestory":"MapleStory","hyperUniverse":"Hyper Universe","mabinogi":"Mabinogi","ridersOfIcarus":"Riders of Icarus","vindictus":"Vindictus","lawBreakers":"LawBreakers","counterStrikeZ":"Counter-Strike Nexon: Zombies","duelOfSummoners":"Duel of Summoners","treeOfSavior":"Tree of Savior","afterTheEnd":"After The End Forsaken Destiny","battleJack":"Battlejack","evilFactory":"Evil Factory","dominations":"DomiNations","dynastyWarriors":"Dynasty Warriors: Unleashed","hit":"HIT – Heroes of Incredible Tales","titanFall":"Titanfall Assault","pointBlankStrike":"PointBlank: Strike","masterOfEternity":"Master of Eternity","romanceOfTheThreeKingdoms":"RTK: The Legend of CaoCao","maplestoryBlitz":"MapleStory Blitz","returners":"Returners","sangokushiSousoudenOnline":"","mabinogiDuel":"Mabinogi Duel","tango5Reloaded":"Tango 5 Reloaded","darknessRises":"Darkness Rises","maplestoryM":"MapleStory M","durango":"Durango: Wild Lands","moonlightBlade":"Moonlight Blade"},"games":"Games","logIn":"Log in","createAccount":"Create Account","myAccount":"My Account","accountSetting":"Account Settings","addBalance":"Add Balance","reviewPurchase":"Review Purchase","findGameCard":"Find a game card","nxGuide":"NX Guide","logout":"Logout","support":"Support","launcher":"Nexon Launcher","launcherDownLoad":"Launcher Download","launcherDesc":"Play all your Nexon games in the global launcher.","pcGames":"PC Games","mobileGames":"Mobile Games"}}

/***/ }),

/***/ "pu/K":
/***/ (function(module, exports) {

module.exports = {"navigation":{"gameList":{"maplestory2":"MapleStory 2","maplestory":"MapleStory","hyperUniverse":"Hyper Universe","mabinogi":"Mabinogi","ridersOfIcarus":"Riders of Icarus","vindictus":"Vindictus","lawBreakers":"LawBreakers","counterStrikeZ":"Counter-Strike Nexon: Zombies","duelOfSummoners":"Duel of Summoners","treeOfSavior":"Tree of Savior","afterTheEnd":"After The End Forsaken Destiny","battleJack":"Battlejack","evilFactory":"Evil Factory","dominations":"DomiNations","dynastyWarriors":"Dynasty Warriors: Unleashed","hit":"HIT – Heroes of Incredible Tales","titanFall":"Titanfall Assault","pointBlankStrike":"PointBlank: Strike","masterOfEternity":"Master of Eternity","romanceOfTheThreeKingdoms":"Romance of the Three Kingdoms: The Legend of CaoCao","maplestoryBlitz":"MapleStory Blitz","returners":"Returners","sangokushiSousoudenOnline":"","mabinogiDuel":"Mabinogi Duel","tango5Reloaded":"Tango 5 Reloaded","darknessRises":"Darkness Rises","maplestoryM":"MapleStory M","durango":"Durango: Wild Lands","moonlightBlade":"Moonlight Blade"},"games":"Juegos","logIn":"Iniciar sesión","createAccount":"Crear una cuenta","myAccount":"Mi cuenta","accountSetting":"Configuración de la cuenta","addBalance":"Agregar saldo","reviewPurchase":"Revisar compra","findGameCard":"Encontrar tarjetas de juego","nxGuide":"Guía de NX","logout":"Cerrar sesión","support":"Atención al cliente","launcher":"Nexon Launcher","launcherDownLoad":"Descargar el Launcher","launcherDesc":"Juega todos tus juegos de Nexon en el Launcher global.","pcGames":"Juegos para PC","mobileGames":"Juegos para móvil"}}

/***/ }),

/***/ "r2sx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_global_navigation_vue__ = __webpack_require__("jSmg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_global_navigation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_global_navigation_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_global_navigation_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_global_navigation_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5af1f5e3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_global_navigation_vue__ = __webpack_require__("tPkk");
function injectStyle (ssrContext) {
  __webpack_require__("IoAV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5af1f5e3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_global_navigation_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5af1f5e3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_global_navigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "r8QZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@arena/toolkit/src/components/common/panel.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ var panel = ({
	name: 'panel',
	introduction: 'Vuejs panel component',
	description: 'Require to use Accordion component.',
	props: {
		header: {
			type: String,
			default: null,
			note: 'Header text on panel'
		},
		isOpen: {
			type: Boolean,
			default: null,
			note: 'Show or close panel'
		},
		type: {
			type: String,
			default: null,
			note: 'Panel type'
		},
		openIconId: {
			type: String,
			default: 'icon-page-down',
			note: 'Panel open icon\'s svg id'
		},
		closeIconId: {
			type: String,
			default: 'icon-page-right',
			note: 'Panel close icon\'s svg id'
		}
	},
	data: function data() {
		return {
			open: this.isOpen
		};
	},

	watch: {
		isOpen: function isOpen(val) {
			this.open = val;
		}
	},
	computed: {
		inAccordion: function inAccordion() {
			return this.$parent && this.$parent.accordion;
		},
		panelType: function panelType() {
			var panelType = 'panel-' + (this.type || this.$parent && this.$parent.type || 'default');
			return panelType;
		},
		iconId: function iconId() {
			return this.open ? this.openIconId : this.closeIconId;
		}
	},
	methods: {
		toggle: function toggle() {
			this.open = !this.open;
			if (this.inAccordion) {
				this.$parent.open(this);
			}
		},
		enter: function enter(el) {
			var endWidth = getComputedStyle(el).height;
			el.style.height = 'auto';
			el.style.height = '0px';
			el.offsetHeight;
			el.style.height = endWidth;
		},
		afterEnter: function afterEnter(el) {
			el.style.height = 'auto';
		},
		beforeLeave: function beforeLeave(el) {
			el.style.height = getComputedStyle(el).height;
			el.offsetHeight;
			el.style.height = '0px';
		}
	},
	created: function created() {
		if (this.isOpen === null) {
			this.open = !this.inAccordion;
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04bbca98","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@arena/toolkit/src/components/common/panel.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['panel',_vm.panelType]},[_c('div',{class:['panel-heading',{'accordion-toggle':_vm.inAccordion}],on:{"click":function($event){$event.preventDefault();_vm.inAccordion&&_vm.toggle()}}},[_vm._v("\n\n\t\t"+_vm._s(_vm.header)+"\n\n\t\t"),_c('svg',{staticClass:"icon-faq"},[_c('use',{attrs:{"xlink:href":("#" + _vm.iconId)}})])]),_vm._v(" "),_c('transition',{attrs:{"name":"collapse"},on:{"enter":_vm.enter,"after-enter":_vm.afterEnter,"before-leave":_vm.beforeLeave}},[(_vm.open)?_c('div',{staticClass:"panel-collapse"},[_c('div',{staticClass:"panel-body"},[_vm._t("default")],2)]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_panel = (esExports);
// CONCATENATED MODULE: ./node_modules/@arena/toolkit/src/components/common/panel.vue
function injectStyle (ssrContext) {
  __webpack_require__("VdXg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04bbca98"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  panel,
  common_panel,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_common_panel = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tPkk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{class:_vm.classes,attrs:{"id":"globalNavigation"}},[_c('div',{staticClass:"global-navigation"},[_c('svgIcons',{staticClass:"hide"}),_vm._v(" "),_c('div',{staticClass:"left-section pull-left"},[_c('a',{staticClass:"nav-logo-container",attrs:{"href":_vm.nexonHome[_vm.region]}},[_c('svgIcon',{attrs:{"iconHolderClass":"nexon-logo","iconId":"nexon-logo"}})],1),_vm._v(" "),_c('a',{staticClass:"section",on:{"click":_vm.toggleGameList}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.$t('navigation.games'))+"\n\t\t\t\t"),_c('svgIcon',{class:{ active: _vm.isActive },attrs:{"iconHolderClass":"icon-page-down","iconId":"icon-page-down"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeMyAccount),expression:"closeMyAccount"}],staticClass:"right-section pull-right"},[_c('a',{staticClass:"nav-toggle",on:{"click":_vm.toggleSidebar}},[_c('svgIcon',{attrs:{"iconHolderClass":"icon-menu","iconId":"icon-menu"}})],1),_vm._v(" "),(!_vm.isLoggedIn)?_c('a',{staticClass:"section",attrs:{"href":_vm.login[_vm.region]}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.$t('navigation.logIn'))+"\n\t\t\t")]):_vm._e(),_vm._v(" "),(!_vm.isLoggedIn)?_c('a',{staticClass:"section",attrs:{"href":_vm.createAccount[_vm.region]}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.$t('navigation.createAccount'))+"\n\t\t\t")]):_c('a',{staticClass:"section dropdown",on:{"click":_vm.toggleDropDown}},[_c('svgIcon',{attrs:{"iconHolderClass":"icon-account","iconId":"icon-account"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('navigation.myAccount')))]),_vm._v(" "),_c('svgIcon',{class:{ active: _vm.openMyAccountDropDown },attrs:{"iconHolderClass":"icon-page-down","iconId":"icon-page-down"}})],1),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu my-account fadeIn animated",class:{ active: _vm.openMyAccountDropDown }},[_vm._l((_vm.myAccountList[_vm.region]),function(myAccount){return _c('li',{class:myAccount.name},[_c('a',{attrs:{"id":myAccount.name,"href":myAccount.url}},[_vm._v(_vm._s(_vm.$t(("navigation." + (myAccount.name)))))]),_vm._v(" "),_c('div',{staticClass:"divider",attrs:{"role":"separator"}})])}),_vm._v(" "),_c('li',{staticClass:"support"},[_c('a',{attrs:{"href":_vm.supportLink[_vm.region]}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.$t('navigation.support'))+"\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"divider",attrs:{"role":"separator"}})])],2)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})],1),_vm._v(" "),_c('div',{staticClass:"modal",class:{ active: _vm.openSideBar }},[_c('div',{staticClass:"blank-area",on:{"click":_vm.toggleSidebar}}),_vm._v(" "),_c('div',{staticClass:"sidebar-modal slideInRight animated",class:{ mobile: _vm.isMObile }},[_c('div',{staticClass:"mobile-menu"},[_c('a',{staticClass:"close",on:{"click":_vm.toggleSidebar}},[_c('svgIcon',{attrs:{"iconHolderClass":"icon-close","iconId":"icon-close"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),(!_vm.isLoggedIn)?_c('div',{staticClass:"myaccount"},[_c('a',{staticClass:"login",attrs:{"id":"login","href":_vm.login[_vm.region]}},[_c('h5',{staticClass:"text-uppercase text-white"},[_vm._v(_vm._s(_vm.$t('navigation.logIn')))])]),_vm._v(" "),_c('a',{staticClass:"create-account",attrs:{"id":"createAccount","href":_vm.createAccount[_vm.region]}},[_c('h5',{staticClass:"text-uppercase text-white"},[_vm._v(_vm._s(_vm.$t('navigation.createAccount')))])])]):_c('div',{staticClass:"myaccount logged-in"},[_c('ul',{staticClass:"list-unstyled"},[_c('svgIcon',{attrs:{"iconHolderClass":"icon-account","iconId":"icon-account"}}),_vm._v(" "),_c('h5',{staticClass:"text-uppercase text-white"},[_vm._v(_vm._s(_vm.$t('navigation.myAccount')))]),_vm._v(" "),_vm._l((_vm.myAccountList[_vm.region]),function(myAccount){return _c('li',[_c('a',{attrs:{"href":myAccount.url,"id":myAccount.name}},[_vm._v(_vm._s(_vm.$t(("navigation." + (myAccount.name)))))])])})],2)]),_vm._v(" "),(_vm.pcGameList)?_c('div',{staticClass:"games"},[_c('a',{on:{"click":_vm.togglePcGames}},[_c('h5',{staticClass:"text-uppercase text-white"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.$t('navigation.pcGames'))+"\n\t\t\t\t\t\t\t"),_c('svgIcon',{class:{ active: _vm.openPcGames },attrs:{"iconHolderClass":"icon-page-down","iconId":"icon-page-down"}})],1)]),_vm._v(" "),_c('ul',{staticClass:"pc-games list-unstyled",class:{ active: _vm.openPcGames }},_vm._l((_vm.pcGameList),function(pcGames){return _c('li',[_c('a',{class:{disable: !_vm.getLocaleString(pcGames.siteUrl)},attrs:{"href":_vm.getLocaleString(pcGames.siteUrl),"target":"_blank","rel":"external"}},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(pcGames.title)+"\n\t\t\t\t\t\t\t")])])}),0)]):_vm._e(),_vm._v(" "),(_vm.mobileGameList)?_c('div',{staticClass:"games"},[_c('a',{on:{"click":_vm.toggleMobileGames}},[_c('h5',{staticClass:"text-uppercase text-white"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.$t('navigation.mobileGames'))+"\n\t\t\t\t\t\t\t"),_c('svgIcon',{class:{ active: _vm.openMobileGames },attrs:{"iconHolderClass":"icon-page-down","iconId":"icon-page-down"}})],1)]),_vm._v(" "),_c('ul',{staticClass:"mobile-games list-unstyled",class:{ active: _vm.openMobileGames }},_vm._l((_vm.mobileGameList),function(mobileGames){return _c('li',[_c('a',{attrs:{"href":_vm.getLocaleString(mobileGames.siteUrl),"target":"_blank","rel":"external"}},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(mobileGames.title)+"\n\t\t\t\t\t\t\t")])])}),0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"support"},[_c('a',{attrs:{"id":"support","href":_vm.supportLink[_vm.region]}},[_c('h5',{staticClass:"text-uppercase text-white"},[_vm._v(_vm._s(_vm.$t('navigation.support')))])])])]),_vm._v(" "),(_vm.isMObile === false)?_c('div',{staticClass:"launcher-download"},[_c('h5',{staticClass:"text-uppercase"},[_vm._v(_vm._s(_vm.$t('navigation.launcher')))]),_vm._v(" "),_c('button',{staticClass:"btn home download-launcher",on:{"click":_vm.downloadLauncher}},[_c('svgIcon',{attrs:{"iconHolderClass":"icon-download","iconId":"icon-download"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('navigation.launcherDownLoad')))])],1)]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"modal open-list",class:{ active: _vm.isActive },on:{"click":_vm.toggleGameList}},[_c('a',[_c('svgIcon',{attrs:{"iconHolderClass":"icon-close","iconId":"icon-close"}})],1),_vm._v(" "),_c('div',{staticClass:"game-list"},[_c('div',{staticClass:"game-section"},[(_vm.pcGameList)?_c('div',{staticClass:"pc-games pull-left"},[_c('h5',{staticClass:"text-uppercase text-white"},[_vm._v(_vm._s(_vm.$t('navigation.pcGames')))]),_vm._v(" "),_c('ul',{staticClass:"games list-unstyled",class:{'short-list': _vm.pcGameList.length < 4 }},_vm._l((_vm.pcGameList),function(pcGames){return _c('li',[_c('a',{class:{disable: !_vm.getLocaleString(pcGames.siteUrl)},attrs:{"href":_vm.getLocaleString(pcGames.siteUrl),"target":"_blank","rel":"external"}},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(pcGames.title)+"\n\t\t\t\t\t\t\t")])])}),0),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e(),_vm._v(" "),(_vm.mobileGameList)?_c('div',{staticClass:"mobile-games pull-left"},[_c('h5',{staticClass:"text-uppercase text-white"},[_vm._v(_vm._s(_vm.$t('navigation.mobileGames')))]),_vm._v(" "),_c('ul',{staticClass:"games list-unstyled"},_vm._l((_vm.mobileGameList),function(mobileGames){return _c('li',[_c('a',{class:mobileGames.title,attrs:{"href":_vm.getLocaleString(mobileGames.siteUrl),"target":"_blank","rel":"external"}},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(mobileGames.title)+"\n\t\t\t\t\t\t\t")])])}),0),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"})])]),_vm._v(" "),_c('div',{staticClass:"launcher-section"},[(_vm.isMObile === false)?_c('div',{staticClass:"launcher-download text-center bounceInDown animated"},[_c('div',{staticClass:"launcher-thumb"}),_vm._v(" "),_c('h5',{staticClass:"text-uppercase text-highlight"},[_vm._v(_vm._s(_vm.$t('navigation.launcher')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('navigation.launcherDesc')))]),_vm._v(" "),_c('button',{staticClass:"btn home download-launcher",on:{"click":_vm.downloadLauncher}},[_c('svgIcon',{attrs:{"iconHolderClass":"icon-download","iconId":"icon-download"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('navigation.launcherDownLoad')))])],1)]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tiBo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vHtg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@arena/toolkit/src/components/common/button.vue + 2 modules
var common_button = __webpack_require__("xJDE");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@arena/toolkit/src/components/common/modal-multi-buttons.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var modal_multi_buttons = ({
	name: 'modalMultiButtons',
	description: 'It provide multi or single button set into Modal for Arena theme',
	components: {
		buttonType: common_button["a" /* default */]
	},
	props: {
		btnPrimaryText: {
			type: String,
			default: '',
			note: 'Primary button label'
		},
		btnSecondaryText: {
			type: String,
			default: '',
			note: 'Secondary button label'
		},
		btnPrimaryId: {
			type: String,
			default: '',
			note: 'Set primary button ID'
		},
		btnSecondaryId: {
			type: String,
			default: '',
			note: 'Set secondary button ID'
		},
		disabled: {
			type: Boolean,
			default: false,
			note: 'Assign disabled state if needed'
		},
		primaryButtonClick: {
			type: Function,
			default: null,
			note: 'Assign function to primary button'
		},
		secondaryButtonClick: {
			type: Function,
			default: null,
			note: 'Assign function to secondary button'
		},
		secondaryButtonHide: {
			type: Boolean,
			default: false,
			note: 'Hide option for secondary button'
		},
		secondaryButtonLoading: {
			type: Boolean,
			default: false,
			note: 'Show loading to secondary button if needed'
		},
		loading: {
			type: Boolean,
			default: false,
			note: 'Loading states for Primary button'
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76e91c13","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@arena/toolkit/src/components/common/modal-multi-buttons.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"submit-button-group"},[_c('div',{staticClass:"col-xs-6 btn-right"},[_c('buttonType',{staticClass:"btn-black",attrs:{"label":_vm.btnPrimaryText,"id":_vm.btnPrimaryId,"disabled":_vm.disabled,"buttonClick":_vm.primaryButtonClick,"loading":_vm.loading}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-6 btn-left"},[_c('buttonType',{attrs:{"label":_vm.btnSecondaryText,"id":_vm.btnSecondaryId,"buttonClick":_vm.secondaryButtonClick,"btnHide":_vm.secondaryButtonHide,"loading":_vm.secondaryButtonLoading}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_modal_multi_buttons = (esExports);
// CONCATENATED MODULE: ./node_modules/@arena/toolkit/src/components/common/modal-multi-buttons.vue
function injectStyle (ssrContext) {
  __webpack_require__("9pJU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-76e91c13"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  modal_multi_buttons,
  common_modal_multi_buttons,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_common_modal_multi_buttons = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _iconSvg = __webpack_require__("EO4f");

var _iconSvg2 = _interopRequireDefault(_iconSvg);

var _globalFooter = __webpack_require__("abZ0");

var _globalFooter2 = _interopRequireDefault(_globalFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
	name: 'app',
	components: {
		globalFooter: _globalFooter2.default,
		svgIcon: _iconSvg2.default
	},
	metaInfo: function metaInfo() {
		return {
			title: this.$t('account.title'),
			meta: [{ name: 'description', content: this.$t('account.meta-desc') }, { name: 'keywords', content: this.$t('account.meta-keyword') }, { property: 'og:site_name', content: this.$t('account.title') }, { property: 'og:type', content: 'website' }, { property: 'og:url', content: 'http://www.nexon.com/' }, { property: 'og:title', content: this.$t('account.title') }, { property: 'og:description', content: this.$t('account.meta-desc') }, {
				property: 'og:image',
				content: 'https://web.nxfs.nexon.com/nexon-logo.png'
			}, { itemprop: 'name', content: this.$t('account.meta-title') }, { itemprop: 'description', content: this.$t('account.meta-desc') }, {
				itemprop: 'image',
				content: 'https://web.nxfs.nexon.com/nexon-logo.png'
			}, {
				'http-equiv': 'Content-Security-Policy',
				content: 'default-src *.nexon.com *.nexon.io *.nexon.net *.google-analytics.com \'self\';\n\t\t\t\t\t\tconnect-src *.nexon.com *.nexon.net *.nexon.io *.serving-sys.com \'self\';\n\t\t\t\t\t\tscript-src *.nexon.com *.nexon.net *.google-analytics.com *.googletagmanager.com *.google.com *.facebook.net *.gstatic.com *.iesnare.com *.googleadservices.com *.doubleclick.net https://sentry.d.nexon.io *.serving-sys.com  https://gleam.io \'unsafe-eval\' \'unsafe-inline\' \'self\';\n\t\t\t\t\t\tstyle-src *.nexon.com *.google.com *.googleapis.com \'unsafe-inline\';\n\t\t\t\t\t\timg-src *.nexon.com *.google.com *.google-analytics.com https://www.googletagmanager.com *.gstatic.com *.doubleclick.net \'self\' data:;\n\t\t\t\t\t\tfont-src *.nexon.com *.google.com *.facebook.com \'self\';\n\t\t\t\t\t\tframe-src *.nexon.com *.nexon.net *.google.com *.facebook.com'
			}]
		};
	},
	data: function data() {
		return {
			notificationList: []
		};
	},

	computed: {
		classes: function classes() {
			return [this.channel, this.region, this.language];
		},
		maintenance: function maintenance() {
			return this.$store.state.configurations.maintenance;
		},
		isLauncher: function isLauncher() {
			return navigator.userAgent.indexOf('NexonLauncher') > 0;
		},
		isSteamConnector: function isSteamConnector() {
			return navigator.userAgent.indexOf('steam-connector') > 0;
		},
		isToy: function isToy() {
			return this.$store.state.appType === 'toy';
		},
		productClass: function productClass() {
			var prodId = this.$cookie.get('ProdId');
			return prodId ? 'product-' + prodId : false;
		},
		regionDataLayer: function regionDataLayer() {
			var region = this.region;
			return region === 'global' ? 'west' : region;
		},
		language: function language() {
			return this.$i18n.locale;
		},
		channel: function channel() {
			if (this.isLauncher) return 'launcher';
			if (this.isSteamConnector) return 'steam';
			if (this.isToy) return 'toy';
			return 'web';
		},
		hideError: function hideError() {
			var result = this.notificationList.find(function (field) {
				return field.Name === 'Account';
			});
			return !result;
		},
		checkSettingPageIn: function checkSettingPageIn() {
			if (this.$store.state.settings === null) {
				return false;
			}
			return true;
		}
	},
	methods: {
		maintenanceModeRedirect: function maintenanceModeRedirect() {
			if (this.maintenance) {
				this.$router.push({ name: 'maintenance' });
			}
		},
		productIdClass: function productIdClass() {
			var account = document.getElementById('account');
			account.classList.add(this.productClass);
		},
		storeDirectReturn: function storeDirectReturn() {
			if (this.$route.query.direct_return) {
				this.$store.commit('setDirectReturn', this.$route.query.direct_return);
			}
		},
		storeChannel: function storeChannel() {
			if (this.channel !== 'web') {
				var account = document.getElementById('account');
				account.classList.add('launcher');
			}
			this.$store.commit('setChannel', this.channel);
		},
		getNotificationString: function getNotificationString(data) {
			if (!data) return '';
			var notification = data.find(function (field) {
				return field.Name === 'Account';
			});
			return notification.Message[this.$i18n.locale || this.$i18n.fallbackLocale];
		}
	},
	created: function created() {
		var _this = this;

		this.productIdClass();
		this.maintenanceModeRedirect();
		this.storeDirectReturn();
		this.storeChannel();
		_promise2.default.all([this.$notificationAPI.getNotificationList()]).then(function (d) {
			_this.notificationList = d[0];
		});
	},
	mounted: function mounted() {
		window.version = 'Current Version => ' + "1.19.0";
	},
	updated: function updated() {
		dataLayer.push({
			channel: this.channel,
			region: this.regionDataLayer,
			language: this.language
		});
	}
};

/***/ }),

/***/ "xJDE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@arena/toolkit/src/components/common/button.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var common_button = ({
	name: 'formButton',
	description: 'Basic button setting with spinner loading state, disable.. etc',
	props: {
		btnId: {
			type: String,
			default: '',
			note: 'Button ID'
		},
		btnPrimary: {
			type: Boolean,
			default: false,
			note: 'Primary CSS type'
		},
		btnHide: {
			type: Boolean,
			default: false,
			note: 'Button hide'
		},
		label: {
			type: String,
			default: '',
			note: 'Button text(label)'
		},
		disabled: {
			type: Boolean,
			default: false,
			note: 'Handling disabled state'

		},
		buttonClick: {
			type: Function,
			note: 'Function when it clicked'
		},
		loading: {
			type: Boolean,
			default: false,
			note: 'Loading state, when it true, spinner showing and label hide'
		}
	},
	methods: {
		handleClicked: function handleClicked() {
			this.$emit('click');
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-920d81c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@arena/toolkit/src/components/common/button.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-block btn-default",class:{
		'disabled': _vm.disabled || _vm.loading,
		'btn-primary': _vm.btnPrimary,
		'hide': _vm.btnHide
	},attrs:{"tabindex":"1","id":_vm.btnId,"disabled":_vm.disabled || _vm.loading},on:{"click":_vm.buttonClick}},[(_vm.loading)?_c('div',{staticClass:"loading"},[_vm._m(0),_vm._v(" "),_vm._m(1)]):_c('span',[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loadingLeft"},[_c('div')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loadingRight"},[_c('div')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_common_button = (esExports);
// CONCATENATED MODULE: ./node_modules/@arena/toolkit/src/components/common/button.vue
function injectStyle (ssrContext) {
  __webpack_require__("CXSM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-920d81c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  common_button,
  components_common_button,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_common_button = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yAqM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@arena/toolkit/src/components/common/form-select.vue + 2 modules
var form_select = __webpack_require__("Tk1k");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@arena/toolkit/src/components/common/country-select.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var country_select = ({
	name: 'countrySelect',
	model: {
		prop: 'code',
		event: 'change'
	},
	props: {
		stringSelector: {
			type: String,
			default: null,
			required: true,
			note: 'For localize support, it must be defined'
		},
		hasError: {
			type: Boolean,
			default: false,
			note: 'Error handling'
		},
		code: {
			type: String,
			default: null,
			note: 'Country code setting'
		},
		countryCodesList: {
			type: Array,
			default: function _default() {
				return [];
			},

			note: 'Country list code.'
		}
	},
	components: {
		formSelect: form_select["a" /* default */]
	},
	data: function data() {
		return {
			inputCountryCode: this.code
		};
	},

	computed: {
		countryStringsList: function countryStringsList() {
			return this.countryCodesList.map(function (alpha2) {
				return {
					label: '' + alpha2,
					value: alpha2
				};
			});
		}
	},
	watch: {
		code: function code(newValue) {
			this.inputCountryCode = newValue;
		}
	},
	methods: {
		changeCountry: function changeCountry(newValue) {
			this.inputCountryCode = newValue;
			this.$emit('change', this.inputCountryCode);
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6739804b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@arena/toolkit/src/components/common/country-select.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('formSelect',{attrs:{"orderByLoco":true,"hasError":_vm.hasError,"options":_vm.countryStringsList,"stringSelector":_vm.stringSelector,"placeHolder":_vm.$t('create-account.select-country'),"filterable":true,"labelText":""},on:{"change":function($event){_vm.changeCountry($event)}},model:{value:(_vm.inputCountryCode),callback:function ($$v) {_vm.inputCountryCode=$$v},expression:"inputCountryCode"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_country_select = (esExports);
// CONCATENATED MODULE: ./node_modules/@arena/toolkit/src/components/common/country-select.vue
function injectStyle (ssrContext) {
  __webpack_require__("ZiVs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  country_select,
  common_country_select,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_common_country_select = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yGhP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@arena/toolkit/src/components/common/icon-svg.vue + 2 modules
var icon_svg = __webpack_require__("EO4f");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/@arena/toolkit/src/components/common/form-success.vue
//
//
//
//
//
//
//
//



/* harmony default export */ var form_success = ({
	name: 'formSuccess',
	components: {
		svgIcon: icon_svg["default"]
	},
	props: {
		hideSuccess: {
			type: Boolean,
			default: true,
			note: 'Hide and show success'
		},
		successCode: {
			type: String,
			default: '',
			note: 'Message when it shows.'
		}
	},
	watch: {
		successCode: function successCode() {
			var container = document.getElementById('successContainer');

			if (container !== null) {
				container.scrollIntoView({
					behavior: 'smooth'
				});
			}
		}
	},
	created: function created() {
		if (!this.successCode) {
			this.hideSuccess = true;
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-416c5770","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@arena/toolkit/src/components/common/form-success.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hideSuccess)?_c('div',{staticClass:"alert alert-success text-center",class:{ 'hide': _vm.hideSuccess },attrs:{"id":"successContainer","role":"alert"}},[_c('svgIcon',{attrs:{"iconHolderClass":"icon-warning","iconId":"icon-warning"}}),_vm._v("\n\t"+_vm._s(_vm.successCode)+"\n\t"),_vm._t("default")],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var common_form_success = (esExports);
// CONCATENATED MODULE: ./node_modules/@arena/toolkit/src/components/common/form-success.vue
function injectStyle (ssrContext) {
  __webpack_require__("tiBo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-416c5770"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  form_success,
  common_form_success,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_common_form_success = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ygcn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yxAE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z42y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var globalApiHosts = {
	dev: 'https://api.d.nexon.io',
	testPre: 'https://test-pre-api.nexon.io',
	test: 'https://test-api.nexon.io',
	pre: 'https://pre-api.nexon.io',
	prod: 'https://api.nexon.io'
};

exports.default = {
	globalApiHost: globalApiHosts["prod"]
};

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/app.c20039b888f5b31f234f.js